<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Vitals from "./vitals";
import EarningReport from "./earning";
import {FormWizard, TabContent} from "vue-form-wizard";
import appConfig from "@/app.config.json";
import Chart from "chart.js";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';


/**
 * Dashboard component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Vitals,
    EarningReport,
    FormWizard,
    TabContent,
    ckeditor: CKEditor.component,
    Multiselect
  },
  data() {
    return {
      avatarImage: "http://localhost:8080/img/avatar-2.02aea0c2.jpg",
      showImageUploadModal: false,
      showReviewNoteModal: false,
      showTreatmentTestModal: false,
      showReferralModal: false,
      showAssessmentModal: false,
      showAssessmentDetailsModal: false,
      showDeviceModal: false,
      showWellnessEntryModal: false,
      showTransitionModal: false,
      selectedAssessment: null,
      assessmentList: [
        {
          id: 1,
          date: '2025-08-01',
          type: 'Medical History',
          provider: 'Dr. John Smith',
          status: 'Completed',
          notes: 'Regular checkup'
        },
        {
          id: 2,
          date: '2025-07-15',
          type: 'Physical Examination',
          provider: 'Dr. Sarah Johnson',
          status: 'Completed',
          notes: 'Annual physical'
        },
        {
          id: 3,
          date: '2025-06-22',
          type: 'Social & Environmental',
          provider: 'Dr. Michael Brown',
          status: 'In Progress',
          notes: 'Follow-up assessment'
        }
      ],
      assessmentFields: [
        { key: 'date', label: 'Date' },
        { key: 'type', label: 'Assessment Type' },
        { key: 'provider', label: 'Provider' },
        { key: 'status', label: 'Status' },
        { key: 'actions', label: 'Actions' }
      ],
      currentAssessmentStep: 1,
      wellnessEntryForm: {
        selectedPackages: [],
        addOnServices: []
      },
      transitionForm: {
        selectedPrograms: [],
        patientInfo: {
          name: '',
          age: '',
          gender: '',
          condition: '',
          admissionDate: '',
          dischargeDate: ''
        },
        addOnServices: [],
        selectedProgramDetails: null // To store details of the currently selected program for viewing
      },
      wellnessPackages: [
        {
          category: "Foundational Wellness",
          description: "These packages focus on general health, prevention, and basic well-being.",
          packages: [
            {
              id: 1,
              name: "Wellness Kickstart",
              level: "Basic",
              targetAudience: "Individuals new to wellness programs, or those seeking a basic health assessment and guidance.",
              services: [
                "Comprehensive Health Check-up (Blood tests, BP, BMI, etc.): 1 session",
                "Nutrition Consultation (Initial Assessment & Basic Plan): 1 session",
                "Stress Management Workshop (Group): 1 session (2-3 hours)",
                "Introduction to Yoga/Meditation (Group Class): 4 sessions"
              ],
              price: 5000
            },
            {
              id: 2,
              name: "Healthy Habits Builder",
              level: "Standard",
              targetAudience: "Individuals looking for more structured guidance to build sustainable healthy habits.",
              services: [
                "Comprehensive Health Check-up: 1 session",
                "Nutrition Consultations (Initial + 2 Follow-ups): 3 sessions",
                "Personalized Exercise Plan (with trainer guidance): 1 session",
                "Group Fitness Classes (e.g., Zumba, Aerobics): 8 sessions",
                "Mindfulness/Meditation Sessions (Group): 8 sessions",
                "Stress Management Counseling (Individual): 2 sessions"
              ],
              price: 10000
            }
          ]
        },
        {
          category: "Mind-Body Harmony",
          description: "These packages emphasize mental, emotional, and holistic well-being.",
          packages: [
            {
              id: 3,
              name: "Mindful Living Journey",
              level: "Premium",
              targetAudience: "Individuals experiencing stress, anxiety, or seeking emotional balance.",
              services: [
                "Initial Mental Health Assessment/Counselling: 1 session",
                "Individual Counselling/Therapy: 4-6 sessions",
                "Meditation/Mindfulness Training (Individual or Small Group): 8-12 sessions",
                "Yoga/Pranayama Sessions (Gentle): 8 sessions",
                "Aromatherapy/Relaxation Massage: 2 sessions"
              ],
              price: 85000
            },
            {
              id: 4,
              name: "Holistic Rejuvenation Retreat",
              level: "Premium/Short-Term Intensive",
              targetAudience: "Those seeking a deep detox and rejuvenation experience. This could be a multi-day program.",
              services: [
                "Ayurvedic Doctor Consultation: 1 session",
                "Panchakarma Therapies (e.g., Abhyanga, Shirodhara, Swedana): Daily sessions based on individual needs (e.g., 1-2 sessions/day)",
                "Specialized Yoga & Meditation sessions: Daily",
                "Dietary Guidance (Ayurvedic meals included): Throughout the program",
                "Stress Reduction Workshops: 2-3 sessions",
                "Post-Program Follow-up (online): 1 session"
              ],
              price: 50000
            }
          ]
        }
      ],
      wellnessAddOnServices: [
        {
          id: 1,
          name: "Additional Nutrition Consultation",
          description: "One-on-one session with a nutritionist for personalized dietary guidance",
          price: 1500
        },
        {
          id: 2,
          name: "Personal Training Session",
          description: "Individual workout session with a certified fitness trainer",
          price: 1200
        },
        {
          id: 3,
          name: "Therapeutic Massage",
          description: "60-minute massage therapy session",
          price: 2000
        },
        {
          id: 4,
          name: "Stress Management Workshop",
          description: "Group workshop on stress reduction techniques",
          price: 1000
        },
        {
          id: 5,
          name: "Sleep Improvement Consultation",
          description: "Specialized consultation for better sleep quality",
          price: 1800
        }
      ],
      transitionCarePackages: [
        {
          id: 1,
          tier: "Tier 1",
          name: "Basic Post-Acute Recovery",
          duration: "7-14 days",
          targetAudience: "Patients recovering from less complex surgeries or mild deconditioning, needing basic nursing care and early mobilization.",
          services: [
            "24/7 Nursing Supervision & Medical Oversight",
            "Medication Management",
            "Daily Physiotherapy (e.g., 1-2 sessions of 45-60 mins each)",
            "Basic Occupational Therapy for ADLs (integrated with PT)",
            "Dietary Support",
            "Discharge Planning"
          ],
          idealFor: "Post-op fracture recovery (non-complex), mild pneumonia recovery, general weakness.",
          price: 25000
        },
        {
          id: 2,
          tier: "Tier 2",
          name: "Moderate Rehabilitation & Complex Care",
          duration: "15-30 days",
          targetAudience: "Patients requiring more intensive rehabilitation for conditions like mild-moderate stroke, major orthopedic surgeries, or chronic disease exacerbations.",
          services: [
            "All Tier 1 services",
            "Intensive Daily Physiotherapy (e.g., 2-3 sessions of 45-60 mins each)",
            "Focused Occupational Therapy (e.g., 1-2 sessions of 45-60 mins each)",
            "Speech Therapy (if needed, 1 session of 30-45 mins daily or alternate days)",
            "Dedicated Psychiatric/Psychological Counseling (e.g., 1-2 sessions per week)",
            "Advanced Wound Care (if applicable)",
            "Regular Physician Rounds"
          ],
          idealFor: "Moderate stroke recovery, major joint replacement, cardiac rehabilitation post-bypass, post-trauma recovery.",
          price: 45000
        },
        {
          id: 3,
          tier: "Tier 3",
          name: "Intensive Neuro/Complex Rehabilitation",
          duration: "30+ days, up to 60-90 days",
          targetAudience: "Patients with severe neurological deficits, complex multi-system trauma, or prolonged critical illness requiring extensive, long-term rehabilitation.",
          services: [
            "All Tier 2 services",
            "Highly individualized and intensive therapy plans (PT, OT, ST as needed, potentially 3+ sessions daily across disciplines)",
            "Specialized equipment (e.g., robotics-assisted therapy, gait trainers)",
            "Continuous monitoring with advanced equipment if needed",
            "Neuro-psychological assessment and therapy",
            "Family counseling and training for home care",
            "Long-term discharge planning and community integration support"
          ],
          idealFor: "Severe stroke with significant deficits, spinal cord injury, traumatic brain injury, complex neurological disorders.",
          price: 75000
        }
      ],
      transitionCareAddOnServices: [
        {
          id: 1,
          name: "Home Visit for Assessment",
          description: "Pre-admission home assessment for suitability, post-discharge home safety assessment.",
          price: 3000
        },
        {
          id: 2,
          name: "Ambulance Services",
          description: "For transfer to/from the center.",
          price: 2500
        },
        {
          id: 3,
          name: "Diagnostics",
          description: "Blood tests, X-rays, ECGs (if not included in package price, often charged at cost).",
          price: 5000
        },
        {
          id: 4,
          name: "Consultant Specialists",
          description: "Visits by neurologists, cardiologists, orthopedic surgeons if specific issues arise (beyond routine medical oversight).",
          price: 4000
        },
        {
          id: 5,
          name: "Specialized Equipment Rental",
          description: "E.g., continuous passive motion (CPM) machines, specific rehabilitation devices.",
          price: 3500
        },
        {
          id: 6,
          name: "Personal Attendant/Caregiver Training",
          description: "Specific training for family members or hired caregivers on patient handling, medication, and exercises.",
          price: 2000
        },
        {
          id: 7,
          name: "Dietary Supplements/Specialized Nutrition",
          description: "Beyond standard meal plans.",
          price: 1500
        }
      ],
      activeMedicalTab: 'Medical History',
      assessmentForm: {
        pastMedicalHistory: {
          conditions: [],
          customCondition: '',
          diagnosisDate: '',
          status: 'Active',
          notes: ''
        },
        familyHistory: {
          members: [],
          currentMember: {
            relationship: '',
            age: '',
            status: 'Living',
            conditions: [],
            customCondition: '',
            notes: ''
          }
        },
        medicationHistory: {
          medicationName: '',
          dosage: '',
          frequency: '',
          startDate: '',
          endDate: '',
          purpose: '',
          prescriber: '',
          status: 'Current',
          notes: ''
        },
        socialHistory: {
          tobaccoUse: 'Never',
          alcoholUse: 'Never',
          drugUse: 'Never',
          exercise: 'None',
          diet: '',
          occupation: '',
          livingArrangement: '',
          familySupport: '',
          notes: ''
        },
        physicalExamination: {
          height: '',
          weight: '',
          bmi: '',
          temperature: '',
          pulse: '',
          respiratoryRate: '',
          bloodPressure: '',
          oxygenSaturation: '',
          generalAppearance: '',
          skin: '',
          heent: '',
          neck: '',
          cardiovascular: '',
          respiratory: '',
          gastrointestinal: '',
          musculoskeletal: '',
          neurological: '',
          psychiatric: '',
          notes: ''
        },
        socialEnvironmental: {
          housingStatus: '',
          livingArrangement: '',
          transportationAccess: '',
          foodSecurity: '',
          financialStability: '',
          educationLevel: '',
          employmentStatus: '',
          socialSupport: '',
          communityEngagement: '',
          safetyRisks: '',
          environmentalExposures: '',
          notes: '',
          supportPersons: [],
          currentSupportPerson: {
            name: '',
            relationship: '',
            mobile: '',
            frequency: 'Weekly',
            mealPreparation: false,
            emergencyContact: false,
            transportation: false,
            homeMaintenance: false,
            notes: ''
          },
          supportScore: 82,
          familySupport: 'Excellent',
          communitySupport: 'Good',
          professionalSupport: 'Good',
          summaryAssessment: 'Patient has a strong support network, primarily from spouse and adult children. Active in church community which provides additional social connections. Professional healthcare team is well-established with good coordination.',
          keyStrengths: [
            'Spouse provides consistent daily support',
            'Adult children visit weekly and assist with transportation',
            'Active church membership provides social engagement'
          ],
          potentialGaps: [
            'Limited backup transportation options',
            'Spouse is sole caregiver with minimal respite'
          ],
          recommendations: {
            caregiverSupport: 'Explore respite care options for spouse to prevent caregiver burnout. Consider adult day program 1-2 days/week.',
            transportationResources: 'Connect with senior transportation services as backup option when family is unavailable. Provide information on local senior ride programs.',
            socialEngagement: 'Encourage participation in senior center activities to expand social network beyond family and church. Consider diabetes support group.',
            technologySupport: 'Explore video calling options to maintain connection with grandchildren who live out of state. Consider basic smartphone training.'
          }
        }
      },
      reviewNoteText: '',
      editor: ClassicEditor,
      treatmentTestForm: {
        treatmentType: '',
        testName: '',
        description: '',
        date: '',
        provider: '',
        notes: ''
      },
      showTreatmentModal: false,
      selectedTreatmentType: '', // 'treatment' or 'programs'
      showTreatmentWizard: false, // For Programs wizard
      // Services data
      services: [],
      newService: {
        type: "",
        name: []
      },
      addedTreatments: [], // Array to store multiple treatments added by the user
      selectAllTreatments: false, // For select all checkbox in treatments table
      serviceTypeOptions: [
        "Medical",
        "Medical Support",
        "Non Medical"
      ],
      medicalServiceOptions: [
        "General Medicine / Internal Medicine",
        "Pediatrics",
        "Emergency Medicine / Accident & Emergency (A&E)",
        "Observation Unit (Short Stay Admissions)"
      ],
      medicalSupportServiceOptions: [
        "X-ray",
        "MRI (Magnetic Resonance Imaging)",
        "CT Scan (Computed Tomography)",
        "Ultrasound / Sonography",
        "Mammography",
        "Color Doppler",
        "Interventional Radiology Procedures",
        "Clinical Biochemistry",
        "Clinical Microbiology & Serology",
        "Clinical Pathology",
        "Haematology",
        "Histopathology & Cytology",
        "Blood Bank / Transfusion Services",
        "ECG (Electrocardiogram)",
        "Echocardiography (Echo)",
        "Treadmill Test (TMT) / Stress Test",
        "Holter Monitoring",
        "EEG (Electroencephalogram)",
        "Nerve Conduction Study (NCS)",
        "Electromyography (EMG)",
        "Spirometry / PFT (Pulmonary Function Test)",
        "Bronchoscopy (Diagnostic)",
        "Audiometry (Hearing Tests)",
        "Tympanometry",
        "Speech Assessment",
        "Intensive Care Unit (ICU) / Critical Care Unit (CCU) - Adult",
        "Neonatal Intensive Care Unit (NICU)",
        "Pediatric Intensive Care Unit (PICU)"
      ],
      nonMedicalServiceOptions: [
        "Admissions & Discharges",
        "Billing & Cashier Services",
        "Insurance & TPA Desk",
        "Front Office / Reception",
        "Patient Relations / Patient Advocacy (PALS)",
        "Housekeeping & Sanitation",
        "Bio-Medical Engineering",
        "Maintenance & Engineering",
        "Security Services",
        "Dietary / Food Services (for patients and staff)",
        "Laundry Services",
        "Employee's",
        "Information Technology",
        "QA/QC Patient Safety"
      ],
      treatmentForm: {
        type: 'surgical', // 'surgical', 'non-surgical', or 'others'
        name: '',
        description: '',
        notes: '',
        prescriptions: [], // Array to store uploaded prescription files
        surgicalDetails: {
          procedure: [],
          location: '',
          anesthesia: '',
          duration: '',
          complications: '',
          surgeon: '',
          assistants: '',
          preOpDiagnosis: '',
          postOpDiagnosis: '',
          implants: '',
          bloodLoss: '',
          painLevel: 0,
          recoveryTime: '',
          followUpDate: '',
          followUpInstructions: '',
          operationTheaterDuration: '',
          equipment: [],
          rentedEquipment: [], // Array to store rented equipment with cost and duration
          teamMembers: {
            nurseCount: 0,
            nurses: [],
            assistantDoctorCount: 0,
            assistantDoctors: [],
            seniorDoctorCount: 0,
            seniorDoctors: []
          }
        },
        nonSurgicalDetails: {
          treatmentType: '', // 'physical', 'medication', 'therapy', etc.
          programTypes: [], // Array to store selected program types
          frequency: '',
          duration: '',
          dosage: '',
          route: '',
          medicationName: '',
          medicationClass: '',
          manufacturer: '',
          sideEffects: '',
          contraindications: '',
          therapyGoals: '',
          therapyProgress: '',
          homeInstructions: '',
          refills: 0,
          pharmacyName: '',
          pharmacyPhone: ''
        },
        othersDetails: {
          category: '',
          specificType: '',
          description: '',
          duration: '',
          frequency: '',
          specialInstructions: '',
          additionalNotes: ''
        }
      },
      selectedProcedure: '',
      treatmentCurrentPage: 1,
      treatmentPerPage: 6,
      treatmentNames: [
        'Appendectomy',
        'Antibiotic Treatment',
        'Knee Arthroscopy',
        'Physical Therapy',
        'Cataract Surgery',
        'Insulin Therapy',
        'Cesarean Section',
        'Cognitive Behavioral Therapy',
        'Coronary Artery Bypass Graft',
        'Chemotherapy',
        'Total Hip Replacement',
        'Radiation Therapy'
      ],
      procedureDetails: {
        'Appendectomy': {
          description: 'Surgical removal of inflamed appendix',
          treatment: 'Laparoscopic or open surgical procedure to remove the appendix',
          recovery: '2-4 weeks recovery time',
          risks: 'Infection, bleeding, injury to nearby organs'
        },
        'Antibiotic Treatment': {
          description: 'Treatment for bacterial infections',
          treatment: 'Course of antibiotics to eliminate bacterial infection',
          recovery: 'Varies based on infection severity',
          risks: 'Side effects, allergic reactions, antibiotic resistance'
        },
        'Knee Arthroscopy': {
          description: 'Minimally invasive knee surgery',
          treatment: 'Arthroscopic procedure to repair torn meniscus or other knee issues',
          recovery: '4-6 weeks for full recovery',
          risks: 'Infection, blood clots, knee stiffness'
        },
        'Physical Therapy': {
          description: 'Rehabilitation to improve physical function',
          treatment: 'Exercises and techniques to restore movement and strength',
          recovery: 'Varies based on condition',
          risks: 'Minimal risks, possible temporary discomfort'
        },
        'Cataract Surgery': {
          description: 'Removal of cloudy lens in the eye',
          treatment: 'Phacoemulsification with IOL implantation',
          recovery: '1-2 weeks for initial recovery',
          risks: 'Infection, bleeding, retinal detachment'
        },
        'Insulin Therapy': {
          description: 'Treatment for diabetes',
          treatment: 'Regular insulin injections to control blood sugar levels',
          recovery: 'Ongoing management',
          risks: 'Hypoglycemia, weight gain, injection site reactions'
        },
        'Cesarean Section': {
          description: 'Surgical delivery of a baby',
          treatment: 'Abdominal and uterine incision to deliver baby',
          recovery: '6-8 weeks for full recovery',
          risks: 'Infection, bleeding, blood clots, surgical complications'
        },
        'Cognitive Behavioral Therapy': {
          description: 'Psychotherapy for mental health conditions',
          treatment: 'Therapy sessions to modify thought patterns and behaviors',
          recovery: 'Varies based on condition',
          risks: 'Temporary emotional discomfort'
        },
        'Coronary Artery Bypass Graft': {
          description: 'Surgery to improve blood flow to the heart',
          treatment: 'Creating new routes for blood flow using grafts',
          recovery: '6-12 weeks for initial recovery',
          risks: 'Infection, bleeding, heart attack, stroke'
        },
        'Chemotherapy': {
          description: 'Treatment for cancer using drugs',
          treatment: 'Administration of drugs to kill cancer cells',
          recovery: 'Varies based on treatment protocol',
          risks: 'Nausea, hair loss, fatigue, immune suppression'
        },
        'Total Hip Replacement': {
          description: 'Surgery to replace damaged hip joint',
          treatment: 'Removal of damaged joint and replacement with prosthetic components',
          recovery: '3-6 months for full recovery',
          risks: 'Infection, blood clots, dislocation, implant failure'
        },
        'Radiation Therapy': {
          description: 'Treatment for cancer using radiation',
          treatment: 'Targeted radiation to destroy cancer cells',
          recovery: 'Varies based on treatment protocol',
          risks: 'Skin changes, fatigue, specific organ-related side effects'
        }
      },
      programTypeOptions: [
        {
          id: 1,
          name: 'Rehabilitation',
          description: 'Programs focused on restoring physical function and mobility',
          specifications: [
            'Physical therapy sessions',
            'Occupational therapy',
            'Speech therapy',
            'Cognitive rehabilitation'
          ],
          offerings: [
            'Individualized treatment plans',
            'Progress tracking',
            'Home exercise programs',
            'Assistive device training'
          ]
        },
        {
          id: 2,
          name: 'Wellness',
          description: 'Programs focused on maintaining and improving overall health',
          specifications: [
            'Nutrition counseling',
            'Fitness programs',
            'Stress management',
            'Preventive screenings'
          ],
          offerings: [
            'Group classes',
            'Personal coaching',
            'Health assessments',
            'Wellness challenges'
          ]
        },
        {
          id: 3,
          name: 'Preventive Care',
          description: 'Programs designed to prevent disease and promote health',
          specifications: [
            'Immunizations',
            'Health screenings',
            'Risk assessments',
            'Lifestyle counseling'
          ],
          offerings: [
            'Annual check-ups',
            'Preventive screenings',
            'Health education',
            'Risk reduction strategies'
          ]
        },
        {
          id: 4,
          name: 'Chronic Disease Management',
          description: 'Programs for managing ongoing health conditions',
          specifications: [
            'Medication management',
            'Symptom monitoring',
            'Lifestyle modifications',
            'Regular check-ups'
          ],
          offerings: [
            'Disease-specific education',
            'Self-management tools',
            'Remote monitoring',
            'Care coordination'
          ]
        },
        {
          id: 5,
          name: 'Mental Health',
          description: 'Programs focused on psychological and emotional well-being',
          specifications: [
            'Individual therapy',
            'Group therapy',
            'Medication management',
            'Stress reduction techniques'
          ],
          offerings: [
            'Crisis intervention',
            'Ongoing counseling',
            'Support groups',
            'Mindfulness training'
          ]
        },
        {
          id: 6,
          name: 'Pain Management',
          description: 'Programs for managing acute and chronic pain',
          specifications: [
            'Pain assessment',
            'Medication management',
            'Physical therapy',
            'Alternative therapies'
          ],
          offerings: [
            'Individualized pain plans',
            'Non-pharmacological approaches',
            'Interventional procedures',
            'Psychological support'
          ]
        }
      ],
      transitions: [
        {
          id: 1,
          type: 'discharge',
          name: 'Hospital to Home',
          date: '2023-06-15',
          from: 'Memorial Hospital',
          to: 'Home',
          coordinator: 'Dr. Emily Wilson',
          status: 'Completed',
          reason: 'Patient has recovered sufficiently to continue care at home with outpatient follow-up',
          documents: [
            { name: 'Discharge Summary.pdf', type: 'pdf' },
            { name: 'Medication List.pdf', type: 'pdf' },
            { name: 'Home Care Instructions.pdf', type: 'pdf' }
          ],
          careTeam: [
            { name: 'Dr. Emily Wilson', role: 'Primary Care Physician' },
            { name: 'Sarah Johnson', role: 'Discharge Nurse' },
            { name: 'Michael Brown', role: 'Home Health Coordinator' }
          ]
        },
        {
          id: 2,
          type: 'referral',
          name: 'Specialist Referral',
          date: '2023-07-10',
          from: 'Primary Care',
          to: 'Cardiology Department',
          coordinator: 'Dr. James Miller',
          status: 'In Progress',
          reason: 'Evaluation of abnormal ECG findings and chest pain',
          documents: [
            { name: 'Referral Form.pdf', type: 'pdf' },
            { name: 'Recent ECG Results.pdf', type: 'pdf' }
          ],
          careTeam: [
            { name: 'Dr. James Miller', role: 'Primary Care Physician' },
            { name: 'Dr. Robert Chen', role: 'Cardiologist' }
          ]
        },
        {
          id: 3,
          type: 'transfer',
          name: 'Facility Transfer',
          date: '2023-08-05',
          from: 'Acute Care Hospital',
          to: 'Rehabilitation Center',
          coordinator: 'Lisa Martinez, RN',
          status: 'Scheduled',
          reason: 'Continued physical therapy and rehabilitation following hip replacement',
          documents: [
            { name: 'Transfer Form.pdf', type: 'pdf' },
            { name: 'Therapy Plan.pdf', type: 'pdf' },
            { name: 'Medical History.pdf', type: 'pdf' }
          ],
          careTeam: [
            { name: 'Dr. Sarah Thompson', role: 'Orthopedic Surgeon' },
            { name: 'Lisa Martinez', role: 'Care Coordinator' },
            { name: 'John Davis', role: 'Physical Therapist' }
          ]
        }
      ],
      wellnessData: {
        activityData: {
          dailySteps: 6540,
          stepsGoal: 10000,
          stepsProgress: 65,
          stepsChange: 12,
          recentActivities: [
            {
              name: 'Morning Walk',
              details: '3,200 steps • 25 mins',
              time: 'Today, 7:30 AM',
              type: 'walking'
            },
            {
              name: 'Yoga Session',
              details: 'Flexibility • 45 mins',
              time: 'Yesterday, 6:00 PM',
              type: 'yoga'
            },
            {
              name: 'Cycling',
              details: '5.2 miles • 32 mins',
              time: 'Yesterday, 10:30 AM',
              type: 'cycling'
            },
            {
              name: 'Swimming',
              details: '20 laps • 40 mins',
              time: 'May 20, 5:30 PM',
              type: 'swimming'
            }
          ]
        },
        sleepData: {
          averageHours: 7.2,
          hoursGoal: 8,
          sleepProgress: 80,
          sleepChange: -3
        },
        nutritionData: {
          grade: 'B+',
          gradeChange: 1,
          categories: {
            vegetables: 70,
            protein: 45,
            carbs: 60,
            fat: 30,
            water: 80
          }
        },
        wellnessScore: {
          current: 78,
          change: 5
        }
      },
      deviceForm: {
        name: '',
        type: 'smartwatch',
        model: '',
        manufacturer: '',
        serialNumber: '',
        lastSynced: new Date().toISOString(),
        status: 'connected',
        batteryLevel: 100,
        notes: ''
      },
      connectedDevices: [
        {
          id: 1,
          name: 'Smart Watch Pro',
          type: 'smartwatch',
          model: 'Series 7',
          manufacturer: 'Apple',
          serialNumber: 'SW12345678',
          lastSynced: '10 minutes ago',
          status: 'connected',
          batteryLevel: 85,
          icon: 'fas fa-watch',
          iconBg: 'bg-soft-primary',
          iconColor: 'text-primary',
          stats: [
            { name: 'Heart Rate', value: '72', unit: '', icon: 'fas fa-heartbeat', color: 'text-danger' },
            { name: 'Steps', value: '8,542', unit: '', icon: 'fas fa-shoe-prints', color: 'text-primary' },
            { name: 'Calories', value: '420', unit: '', icon: 'fas fa-fire', color: 'text-warning' }
          ]
        },
        {
          id: 2,
          name: 'Continuous Glucose Monitor',
          type: 'glucosemonitor',
          model: 'G6',
          manufacturer: 'Dexcom',
          serialNumber: 'CGM87654321',
          lastSynced: '30 minutes ago',
          status: 'connected',
          batteryLevel: 65,
          icon: 'fas fa-tint',
          iconBg: 'bg-soft-danger',
          iconColor: 'text-danger',
          currentGlucose: '142',
          glucoseUnit: 'mg/dL',
          dailyAverage: '135',
          target: '70-120'
        },
        {
          id: 3,
          name: 'Blood Pressure Monitor',
          type: 'bpmonitor',
          model: 'BPM Connect',
          manufacturer: 'Withings',
          serialNumber: 'BPM98765432',
          lastSynced: '2 hours ago',
          status: 'connected',
          batteryLevel: 72,
          icon: 'fas fa-heart',
          iconBg: 'bg-soft-info',
          iconColor: 'text-info',
          lastReading: '138/85',
          unit: 'mmHg',
          pulse: '72',
          pulseUnit: 'bpm',
          statusText: 'Elevated'
        }
      ],
      treatments: [
        {
          id: 1,
          type: 'surgical',
          name: 'Appendectomy',
          date: '2023-05-15',
          provider: 'Dr. John Smith',
          description: 'Surgical removal of inflamed appendix',
          prescriptions: [],
          surgicalDetails: {
            procedure: ['Laparoscopic appendectomy'],
            location: 'Main OR',
            anesthesia: 'General',
            duration: '45 minutes',
            complications: 'None',
            surgeon: 'Dr. John Smith',
            assistants: 'Dr. Emily Rodriguez',
            preOpDiagnosis: 'Acute appendicitis',
            postOpDiagnosis: 'Confirmed acute appendicitis',
            implants: 'None',
            bloodLoss: 'Minimal (<50ml)',
            painLevel: 6,
            recoveryTime: '2 weeks',
            followUpDate: '2023-05-29',
            followUpInstructions: 'Return for suture removal and wound check',
            operationTheaterDuration: '2 hours',
            equipment: ['Laparoscope', 'Surgical stapler', 'Electrocautery device'],
            rentedEquipment: [
              {
                name: 'Advanced Imaging System',
                cost: '1200',
                duration: '1 day'
              },
              {
                name: 'Specialized Surgical Robot',
                cost: '5000',
                duration: '2 days'
              },
              {
                name: 'Portable Ultrasound',
                cost: '800',
                duration: '1 day'
              }
            ],
            teamMembers: {
              nurseCount: 3,
              nurses: ['Nurse Sarah Johnson', 'Nurse Michael Brown', 'Nurse Lisa Chen'],
              assistantDoctorCount: 1,
              assistantDoctors: ['Dr. Emily Rodriguez'],
              seniorDoctorCount: 1,
              seniorDoctors: ['Dr. John Smith']
            }
          }
        },
        {
          id: 2,
          type: 'non-surgical',
          name: 'Antibiotic Treatment',
          date: '2023-06-10',
          provider: 'Dr. Sarah Johnson',
          description: 'Treatment for bacterial infection',
          prescriptions: [],
          nonSurgicalDetails: {
            treatmentType: 'medication',
            frequency: 'Twice daily',
            duration: '10 days',
            dosage: '500mg',
            route: 'Oral',
            medicationName: 'Amoxicillin',
            medicationClass: 'Penicillin antibiotic',
            manufacturer: 'Generic',
            sideEffects: 'Diarrhea, nausea, rash',
            contraindications: 'Penicillin allergy',
            therapyGoals: 'Eliminate bacterial infection',
            therapyProgress: 'Good response after 3 days',
            homeInstructions: 'Take with food, complete entire course',
            refills: 0,
            pharmacyName: 'City Pharmacy',
            pharmacyPhone: '555-123-4567'
          }
        },
        {
          id: 3,
          type: 'surgical',
          name: 'Knee Arthroscopy',
          date: '2023-07-22',
          provider: 'Dr. Michael Chen',
          description: 'Repair of torn meniscus',
          prescriptions: [],
          surgicalDetails: {
            procedure: ['Arthroscopic meniscectomy'],
            location: 'Outpatient Surgery Center',
            anesthesia: 'Regional',
            duration: '60 minutes',
            complications: 'Minor swelling',
            surgeon: 'Dr. Michael Chen',
            assistants: 'Dr. Robert Williams',
            preOpDiagnosis: 'Medial meniscus tear',
            postOpDiagnosis: 'Confirmed medial meniscus tear with minor cartilage damage',
            implants: 'None',
            bloodLoss: 'Minimal (<25ml)',
            painLevel: 5,
            recoveryTime: '4-6 weeks',
            followUpDate: '2023-08-05',
            followUpInstructions: 'Begin physical therapy within 1 week',
            operationTheaterDuration: '1 hour',
            equipment: ['Arthroscope', 'Shaver', 'Probe', 'Fluid management system'],
            teamMembers: {
              nurseCount: 2,
              nurses: ['Nurse Jennifer Adams', 'Nurse David Wilson'],
              assistantDoctorCount: 1,
              assistantDoctors: ['Dr. Robert Williams'],
              seniorDoctorCount: 1,
              seniorDoctors: ['Dr. Michael Chen']
            }
          }
        },
        {
          id: 4,
          type: 'non-surgical',
          name: 'Physical Therapy',
          date: '2023-08-05',
          provider: 'Jane Wilson, PT',
          description: 'Rehabilitation following knee surgery',
          prescriptions: [],
          nonSurgicalDetails: {
            treatmentType: 'physical',
            frequency: 'Three times weekly',
            duration: '6 weeks',
            dosage: 'N/A',
            route: 'N/A',
            medicationName: 'N/A',
            medicationClass: 'N/A',
            manufacturer: 'N/A',
            sideEffects: 'Temporary increased pain, swelling',
            contraindications: 'Acute inflammation',
            therapyGoals: 'Restore knee mobility and strength',
            therapyProgress: 'Gradual improvement in range of motion',
            homeInstructions: 'Daily home exercises, ice after activity',
            refills: 0,
            pharmacyName: 'N/A',
            pharmacyPhone: 'N/A'
          }
        },
        {
          id: 5,
          type: 'surgical',
          name: 'Cataract Surgery',
          date: '2023-09-10',
          provider: 'Dr. Lisa Wong',
          description: 'Removal of clouded lens and implantation of artificial lens',
          prescriptions: [],
          surgicalDetails: {
            procedure: ['Phacoemulsification with IOL implantation'],
            location: 'Eye Surgery Center',
            anesthesia: 'Local with sedation',
            duration: '30 minutes',
            complications: 'None',
            surgeon: 'Dr. Lisa Wong',
            assistants: 'Dr. James Taylor',
            preOpDiagnosis: 'Nuclear cataract, right eye',
            postOpDiagnosis: 'Successful cataract removal with IOL placement',
            implants: 'Acrylic intraocular lens (IOL)',
            bloodLoss: 'Minimal',
            painLevel: 2,
            recoveryTime: '2-4 weeks',
            followUpDate: '2023-09-11',
            followUpInstructions: 'Eye shield at night for one week, no heavy lifting',
            operationTheaterDuration: '1 hour',
            equipment: ['Phacoemulsification machine', 'Microscope', 'IOL inserter'],
            teamMembers: {
              nurseCount: 1,
              nurses: ['1 ophthalmic nurse'],
              assistantDoctorCount: 1,
              assistantDoctors: ['Dr. James Taylor'],
              seniorDoctorCount: 1,
              seniorDoctors: ['Dr. Lisa Wong']
            }
          }
        },
        {
          id: 6,
          type: 'non-surgical',
          name: 'Insulin Therapy',
          date: '2023-09-15',
          provider: 'Dr. Maria Garcia',
          description: 'Management of Type 2 Diabetes',
          prescriptions: [],
          nonSurgicalDetails: {
            treatmentType: 'medication',
            frequency: 'Twice daily',
            duration: 'Ongoing',
            dosage: '10 units morning, 15 units evening',
            route: 'Subcutaneous injection',
            medicationName: 'Insulin Glargine',
            medicationClass: 'Long-acting insulin',
            manufacturer: 'Sanofi',
            sideEffects: 'Hypoglycemia, injection site reactions',
            contraindications: 'None',
            therapyGoals: 'Maintain blood glucose between 80-130 mg/dL',
            therapyProgress: 'Improved morning glucose readings',
            homeInstructions: 'Monitor blood glucose 4x daily, adjust dose as directed',
            refills: 3,
            pharmacyName: 'MedPlus Pharmacy',
            pharmacyPhone: '555-987-6543'
          }
        },
        {
          id: 7,
          type: 'surgical',
          name: 'Cesarean Section',
          date: '2023-10-02',
          provider: 'Dr. Jennifer Adams',
          description: 'Delivery of baby via abdominal incision',
          prescriptions: [],
          surgicalDetails: {
            procedure: ['Lower segment cesarean section'],
            location: 'Labor & Delivery OR',
            anesthesia: 'Spinal',
            duration: '75 minutes',
            complications: 'None',
            surgeon: 'Dr. Jennifer Adams',
            assistants: 'Dr. Thomas Brown, Midwife Sarah Johnson',
            preOpDiagnosis: 'Fetal distress, failure to progress',
            postOpDiagnosis: 'Successful delivery, healthy infant',
            implants: 'None',
            bloodLoss: 'Approximately 800ml',
            painLevel: 7,
            recoveryTime: '6-8 weeks',
            followUpDate: '2023-10-16',
            followUpInstructions: 'No heavy lifting, incision care instructions provided',
            operationTheaterDuration: '2 hours',
            equipment: ['Surgical instruments', 'Fetal monitor', 'Suction device', 'Warming unit for infant'],
            teamMembers: {
              nurseCount: 4,
              nurses: ['L&D nurse 1', 'L&D nurse 2', 'Scrub nurse', 'Circulating nurse'],
              assistantDoctorCount: 1,
              assistantDoctors: ['Dr. Thomas Brown'],
              seniorDoctorCount: 2,
              seniorDoctors: ['Dr. Jennifer Adams', 'Anesthesiologist Dr. Maria Lopez']
            }
          }
        },
        {
          id: 8,
          type: 'non-surgical',
          name: 'Cognitive Behavioral Therapy',
          date: '2023-10-10',
          provider: 'Dr. David Cohen, PhD',
          description: 'Treatment for anxiety disorder',
          prescriptions: [],
          nonSurgicalDetails: {
            treatmentType: 'therapy',
            frequency: 'Weekly sessions',
            duration: '12 weeks',
            dosage: 'N/A',
            route: 'N/A',
            medicationName: 'N/A',
            medicationClass: 'N/A',
            manufacturer: 'N/A',
            sideEffects: 'Temporary increase in anxiety during exposure exercises',
            contraindications: 'N/A',
            therapyGoals: 'Reduce anxiety symptoms, develop coping strategies',
            therapyProgress: 'Improved response to anxiety triggers',
            homeInstructions: 'Daily thought journaling, practice relaxation techniques',
            refills: 0,
            pharmacyName: 'N/A',
            pharmacyPhone: 'N/A'
          }
        },
        {
          id: 9,
          type: 'surgical',
          name: 'Coronary Artery Bypass Graft',
          date: '2023-11-05',
          provider: 'Dr. Richard Lee',
          description: 'Triple bypass surgery to improve blood flow to heart',
          prescriptions: [],
          surgicalDetails: {
            procedure: ['CABG x3 with saphenous vein grafts'],
            location: 'Cardiovascular OR',
            anesthesia: 'General',
            duration: '4 hours 15 minutes',
            complications: 'Post-op atrial fibrillation, resolved',
            surgeon: 'Dr. Richard Lee',
            assistants: 'Dr. Susan Kim, Dr. Mark Johnson',
            preOpDiagnosis: 'Triple vessel coronary artery disease',
            postOpDiagnosis: 'Successful revascularization',
            implants: 'None',
            bloodLoss: 'Approximately 750ml',
            painLevel: 8,
            recoveryTime: '8-12 weeks',
            followUpDate: '2023-11-19',
            followUpInstructions: 'Cardiac rehabilitation program, sternal precautions',
            operationTheaterDuration: '5+ hours',
            equipment: ['Heart-lung machine', 'Cardiac monitoring equipment', 'Vein harvesting tools', 'Sternal saw'],
            teamMembers: {
              nurseCount: 4,
              nurses: ['Cardiac scrub nurse 1', 'Cardiac scrub nurse 2', 'Circulating nurse 1', 'Circulating nurse 2'],
              assistantDoctorCount: 2,
              assistantDoctors: ['Dr. Susan Kim', 'Dr. Mark Johnson'],
              seniorDoctorCount: 3,
              seniorDoctors: ['Dr. Richard Lee', 'Cardiac Anesthesiologist Dr. James Wilson', 'Perfusionist Dr. Lisa Chen']
            }
          }
        },
        {
          id: 10,
          type: 'non-surgical',
          name: 'Chemotherapy',
          date: '2023-11-15',
          provider: 'Dr. Olivia Martinez',
          description: 'Treatment for stage II breast cancer',
          prescriptions: [],
          nonSurgicalDetails: {
            treatmentType: 'medication',
            frequency: 'Every 3 weeks',
            duration: '4 cycles',
            dosage: 'Doxorubicin 60mg/m², Cyclophosphamide 600mg/m²',
            route: 'Intravenous',
            medicationName: 'AC Regimen (Doxorubicin/Cyclophosphamide)',
            medicationClass: 'Anthracycline/Alkylating agent',
            manufacturer: 'Various',
            sideEffects: 'Nausea, hair loss, fatigue, neutropenia',
            contraindications: 'Pregnancy, severe heart disease',
            therapyGoals: 'Eradicate microscopic disease after surgery',
            therapyProgress: 'Tolerating treatment with moderate side effects',
            homeInstructions: 'Hydration, anti-nausea medication schedule, neutropenic precautions',
            refills: 0,
            pharmacyName: 'Cancer Center Pharmacy',
            pharmacyPhone: '555-789-0123'
          }
        },
        {
          id: 11,
          type: 'surgical',
          name: 'Total Hip Replacement',
          date: '2023-12-01',
          provider: 'Dr. Andrew Wilson',
          description: 'Replacement of damaged hip joint with prosthetic implant',
          prescriptions: [],
          surgicalDetails: {
            procedure: ['Total hip arthroplasty, anterior approach'],
            location: 'Orthopedic OR',
            anesthesia: 'Spinal with sedation',
            duration: '90 minutes',
            complications: 'None',
            surgeon: 'Dr. Andrew Wilson',
            assistants: 'Dr. Patricia Moore',
            preOpDiagnosis: 'End-stage osteoarthritis, right hip',
            postOpDiagnosis: 'Successful total hip arthroplasty',
            implants: 'Ceramic-on-polyethylene prosthesis',
            bloodLoss: 'Approximately 350ml',
            painLevel: 7,
            recoveryTime: '3-6 months',
            followUpDate: '2023-12-15',
            followUpInstructions: 'Hip precautions, physical therapy 3x weekly',
            operationTheaterDuration: '3 hours',
            equipment: ['Specialized hip arthroplasty instruments', 'Fluoroscopy', 'Power tools', 'Hip prosthesis components'],
            teamMembers: {
              nurseCount: 2,
              nurses: ['Scrub nurse', 'Circulating nurse'],
              assistantDoctorCount: 2,
              assistantDoctors: ['Dr. Patricia Moore', 'Orthopedic resident Dr. Michael Lee'],
              seniorDoctorCount: 2,
              seniorDoctors: ['Dr. Andrew Wilson', 'Anesthesiologist Dr. Sarah Thompson']
            }
          }
        },
        {
          id: 12,
          type: 'non-surgical',
          name: 'Radiation Therapy',
          date: '2023-12-10',
          provider: 'Dr. Samuel Thompson',
          description: 'Adjuvant treatment following lumpectomy for breast cancer',
          prescriptions: [],
          nonSurgicalDetails: {
            treatmentType: 'radiation',
            frequency: 'Daily (Mon-Fri)',
            duration: '6 weeks',
            dosage: '50 Gy in 25 fractions + 10 Gy boost',
            route: 'External beam',
            medicationName: 'N/A',
            medicationClass: 'N/A',
            manufacturer: 'N/A',
            sideEffects: 'Skin irritation, fatigue, breast swelling',
            contraindications: 'Pregnancy, prior radiation to same area',
            therapyGoals: 'Reduce risk of local recurrence',
            therapyProgress: 'Completing treatment as planned, mild skin reaction',
            homeInstructions: 'Gentle skin care, avoid sun exposure to treated area',
            refills: 0,
            pharmacyName: 'N/A',
            pharmacyPhone: 'N/A'
          }
        }
      ],
      referralSearch: '',
      title: "Patient Dashboard",
      items: [
        {
          text: "Nazox"
        },
        {
          text: "Patient Dashboard",
          active: true
        }
      ],
      page: {
        title: "Form Wizard",
        meta: [{ name: "description", content: appConfig.description }]
      },
      tabs: [
        {
          name: 'Assessment / Screening',
          icon: 'fas fa-clipboard-check',
          color: '#556ee6',
          description: 'Patient assessment and screening information'
        },
        {
          name: 'Care Management',
          icon: 'fas fa-user-md',
          color: '#34c38f',
          description: 'Manage patient care plans and interventions'
        },
        {
          name: 'Treatment',
          icon: 'fas fa-pills',
          color: '#f1b44c',
          description: 'Treatment plans and procedures'
        },
        {
          name: 'Transitions',
          icon: 'fas fa-exchange-alt',
          color: '#50a5f1',
          description: 'Care transitions and handoffs'
        },
        {
          name: 'Wellness',
          icon: 'fas fa-heartbeat',
          color: '#f46a6a',
          description: 'Patient wellness and lifestyle'
        },
        {
          name: 'Clinical Data',
          icon: 'fas fa-chart-line',
          color: '#74788d',
          description: 'Clinical measurements and lab results'
        },
        {
          name: 'Documents',
          icon: 'fas fa-file-medical',
          color: '#6f42c1',
          description: 'Patient documents and records'
        },
        {
          name: 'Devices',
          icon: 'fas fa-laptop-medical',
          color: '#20c997',
          description: 'Medical devices and equipment'
        },
      ],
      activeTab: 0,
      selectedCondition: '',
      diagnosisCode: 'E08.11- Diabetes mellitus due to underlying condition with ketoacidosis with coma',
      selectedProgram: 'CCM',
      assessmentStarted: false,
      diabetesGoals: [
        'Lower my HgbA1c to <= 7 %',
        'Lower my daily blood sugar level to Before meals: 80 - 130 mg/dL'
      ],
      otherGoals: [
        'Be independent in ADLs',
        'Independence in Dressing',
        'Control my blood sugars',
        'Lower my HgbA1C',
        'Feel better',
        'Have more energy',
        'Other'
      ],
      editingRow: -1, // Track which row is being edited
      editedContent: '', // Store the edited content
      editedGoals: [], // Store individual goals when editing
      carePlanData: [
        {
          patientInfo: `
            <strong>Goals Important to the Patient</strong><br/>
            • Lower my HgbA1C<br/>
            • Control my blood sugars<br/>
            • Lower my HgbA1c to <= 7%<br/>
            • Lower my daily blood sugar level to before meal 80 – 130mg/dl<br/>
            • Be independent in ADLs<br/>
            • Have more energy<br/>
            • Independence in Dressing
          `,
          ccmUpdate: '',
          isEditing: false
        },
        {
          patientInfo: `
            <strong>Medications</strong><br/>
            • Crestor<br/>
            • Advair Diskus<br/>
            • Synthroid<br/>
            • Lipitor<br/>
            • Forget to take medicines more than once per week<br/>
            • I sometimes forget to refill my prescriptions<br/>
            • Sometimes I stop taking my medicines when I feel better without discussing with my doctor<br/>
            • Sometimes I stop taking my medicines when I feel worse without discussing with my doctor<br/>
            • I sometimes report side effects to my doctor
          `,
          ccmUpdate: ''
        },
        {
          patientInfo: `
            <strong>Allergies</strong><br/>
            • penicillin
          `,
          ccmUpdate: ''
        },
        {
          patientInfo: `
            <strong>Vitals</strong><br/>
            • Height: feet inches<br/>
            • Weight: 190<br/>
            • BMI<br/>
            • Blood pressure<br/>
            • HgbA1C: 8
          `,
          ccmUpdate: ''
        },
        {
          patientInfo: `
            <strong>Potential Barriers</strong><br/>
            • Can’t stop eating foods I know I shouldn’t eat<br/>
            • Prescribed medicines didn’t stop the neuropathy pain<br/>
            • Fear<br/>
            • Housing issues
          `,
          ccmUpdate: ''
        },
        {
          patientInfo: `
            <strong>Problems / Symptoms</strong><br/>
            • Hypoglycemic symptoms<br/>
            • Numbness in feet<br/>
            • Pain<br/>
            • Chest pain
          `,
          ccmUpdate: ''
        },



        {
          patientInfo: `
            <strong>Support</strong><br/>
            • Glen – Brother<br/>
            • Megan – Wife
          `,
          ccmUpdate: ''
        }
      ],
      carePlan: [
        {
          title: "Goals Important to the Patient",
          items: [
            "Lower my HgbA1C",
            "Control my blood sugars",
            "Lower my HgbA1c to <= 7%",
            "Lower my daily blood sugar level to before meal 80 – 130mg/dl",
            "Be independent in ADLs",
            "Have more energy",
            "Independence in Dressing"
          ],
          providerNotes: ""
        },
        {
          title: "Potential Barriers",
          items: [
            "Can’t stop eating foods I know I shouldn’t eat",
            "Prescribed medicines didn’t stop the neuropathy pain",
            "Fear",
            "Housing issues"
          ],
          providerNotes: ""
        },
        {
          title: "Problems / Symptoms",
          items: [
            "Hypoglycemic symptoms",
            "Numbness in feet",
            "Pain",
            "Pain Chest"
          ],
          providerNotes: ""
        },
        {
          title: "Allergies",
          items: [
            "Select from pre-defined list (recommended)",
            "Penicillin"
          ],
          providerNotes: ""
        },
        {
          title: "Medications",
          items: [
            "Crestor",
            "Advair Diskus",
            "Synthroid",
            "Lipitor",
            "Forget to take medicines more than once per week",
            "I sometimes forget to refill my prescriptions",
            "Sometimes I stop taking my medicines when I feel better without discussing with my doctor",
            "Sometimes I stop taking my medicines when I feel worse without discussing with my doctor",
            "I sometimes report side effects to my doctor"
          ],
          providerNotes: ""
        },
        {
          title: "Numbers to Track",
          items: [
            "Height feet inches",
            "Weight 190",
            "BMI",
            "Blood pressure",
            "HgbA1C: 8"
          ],
          providerNotes: ""
        },
        {
          title: "Support",
          items: [
            "Glen – Brother",
            "Megan - Wife"
          ],
          providerNotes: ""
        },
        {
          title: "Expected Outcomes",
          items: [
            "Slow or stop the complications from diabetes",
            "Feel better",
            "Other",
            "Live Longer"
          ],
          providerNotes: ""
        }
      ],
      weightData: [
        { date: '2025-04-01', value: 70 },
        { date: '2025-04-05', value: 69.5 },
        { date: '2025-04-10', value: 69.8 },
        { date: '2025-04-15', value: 68.9 },
        { date: '2025-04-20', value: 68.7 },
        { date: '2025-04-25', value: 68.5 },
        { date: '2025-04-30', value: 68.2 },
        { date: '2025-05-05', value: 67.9 }
      ],
      bloodPressureData: [
        { date: '2025-04-01', systolic: 130, diastolic: 85 },
        { date: '2025-04-05', systolic: 128, diastolic: 84 },
        { date: '2025-04-10', systolic: 132, diastolic: 86 },
        { date: '2025-04-15', systolic: 126, diastolic: 82 },
        { date: '2025-04-20', systolic: 125, diastolic: 80 },
        { date: '2025-04-25', systolic: 124, diastolic: 79 },
        { date: '2025-04-30', systolic: 122, diastolic: 78 },
        { date: '2025-05-05', systolic: 120, diastolic: 78 }
      ],
      heartRateData: [
        { date: '2025-04-01', value: 78 },
        { date: '2025-04-05', value: 76 },
        { date: '2025-04-10', value: 80 },
        { date: '2025-04-15', value: 75 },
        { date: '2025-04-20', value: 72 },
        { date: '2025-04-25', value: 74 },
        { date: '2025-04-30', value: 73 },
        { date: '2025-05-05', value: 70 }
      ],
      glucoseData: [
        { date: '2025-04-01', value: 140 },
        { date: '2025-04-05', value: 135 },
        { date: '2025-04-10', value: 142 },
        { date: '2025-04-15', value: 138 },
        { date: '2025-04-20', value: 132 },
        { date: '2025-04-25', value: 130 },
        { date: '2025-04-30', value: 128 },
        { date: '2025-05-05', value: 125 }
      ],
      charts: {
        weight: null,
        bloodPressure: null,
        heartRate: null,
        glucose: null
      },
      auditLogs: [
        {
          username: "admin",
          ipAddress: "192.168.1.10",
          change: "Updated patient HgbA1c from 8.2 to 7.5",
          timestamp: "2025-04-30 10:15:23",
          action: "update",
          status: "success",
          details: "Lab results updated after quarterly check-up"
        },
        {
          username: "nurse01",
          ipAddress: "192.168.1.12",
          change: "Added new medication: Metformin",
          timestamp: "2025-04-30 09:47:00",
          action: "add",
          status: "success",
          details: "Prescribed by Dr. Johnson for diabetes management"
        },
        {
          username: "doctor02",
          ipAddress: "192.168.1.15",
          change: "Updated blood pressure reading",
          timestamp: "2025-04-29 14:30:45",
          action: "update",
          status: "success",
          details: "Recorded during routine check-up"
        },
        {
          username: "admin",
          ipAddress: "192.168.1.10",
          change: "Modified patient contact information",
          timestamp: "2025-04-28 11:20:15",
          action: "update",
          status: "warning",
          details: "Updated phone number and emergency contact"
        },
        {
          username: "nurse03",
          ipAddress: "192.168.1.18",
          change: "Scheduled follow-up appointment",
          timestamp: "2025-04-27 16:05:30",
          action: "add",
          status: "success",
          details: "Follow-up for medication review in 2 weeks"
        },
        {
          username: "system",
          ipAddress: "192.168.1.1",
          change: "Automated health record backup",
          timestamp: "2025-04-26 01:00:00",
          action: "system",
          status: "info",
          details: "Daily backup completed successfully"
        },
        {
          username: "doctor01",
          ipAddress: "192.168.1.20",
          change: "Added new diagnosis: Hypertension",
          timestamp: "2025-04-25 09:15:45",
          action: "add",
          status: "warning",
          details: "Based on consistent elevated blood pressure readings"
        }
      ],
      logFields: [
        { key: 'timestamp', label: 'Date & Time', sortable: true },
        { key: 'username', label: 'User', sortable: true },
        { key: 'change', label: 'Activity', sortable: true },
        { key: 'action', label: 'Action Type', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'details', label: 'Details' },
        { key: 'actions', label: 'Actions' }
      ],
      userName: 'Name_User',
      noteDate: new Date().toISOString().substr(0, 10),
      currentPage: 1,
      notes: {
        concerns: '',
        interventions: '',
        goals: '',
        careTeam: '',
        other: '',
        appointment: ''
      },
      patientNotes: [
        {
          id: 1,
          doctor: 'Dr. John Smith',
          hospital: 'General Hospital',
          date: '2023-05-15',
          content: 'Patient reported mild chest pain. Advised to monitor blood pressure daily and follow up in 2 weeks.'
        },
        {
          id: 2,
          doctor: 'Dr. Sarah Johnson',
          hospital: 'City Medical Clinic',
          date: '2023-04-22',
          content: 'Prescribed new medication for diabetes management. Patient to report any side effects.'
        },
        {
          id: 3,
          doctor: 'Dr. Michael Brown',
          hospital: 'Community Health Center',
          date: '2023-03-10',
          content: 'Reviewed lab results. Cholesterol levels improved. Continue with current diet and exercise plan.'
        }
      ],
      showCreateNoteModal: false,
      newNote: {
        doctor: '',
        hospital: '',
        content: '',
        date: new Date().toISOString().substr(0, 10)
      }
    };
  },
  methods:{
    addTag(newTag) {
      // Add the new tag to the options list
      this.treatmentNames.push(newTag);
      // Select the new tag
      this.treatmentForm.name = newTag;
    },
    getMaxSteps() {
      if (this.activeMedicalTab === 'Medical History') {
        return 4; // Past Medical History, Family History, Medication History, Social History
      } else if (this.activeMedicalTab === 'Physical Examination') {
        return 3; // Vital Signs, System Examination, Assessment
      } else if (this.activeMedicalTab === 'Social & Environmental') {
        return 4; // Occupation, Lifestyle, Living Situation, Social Support
      }
      return 4; // Default
    },
    addFamilyMember() {
      // Validate that required fields are filled
      if (!this.assessmentForm.familyHistory.currentMember.relationship) {
        this.$bvToast.toast('Please select a relationship', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      // Create a copy of the current member
      const newMember = { ...this.assessmentForm.familyHistory.currentMember };

      // Add the member to the array
      this.assessmentForm.familyHistory.members.push(newMember);

      // Reset the current member form
      this.assessmentForm.familyHistory.currentMember = {
        relationship: '',
        age: '',
        status: 'Living',
        conditions: [],
        customCondition: '',
        notes: ''
      };
    },

    removeFamilyMember(index) {
      this.assessmentForm.familyHistory.members.splice(index, 1);
    },

    addSupportPerson() {
      // Ensure the name field exists in the currentSupportPerson object
      if (this.assessmentForm.socialEnvironmental.currentSupportPerson.name === undefined) {
        this.$set(this.assessmentForm.socialEnvironmental.currentSupportPerson, 'name', '');
      }

      // Validate that required fields are filled
      if (!this.assessmentForm.socialEnvironmental.currentSupportPerson.name) {
        this.$bvToast.toast('Please enter a name', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if (!this.assessmentForm.socialEnvironmental.currentSupportPerson.relationship) {
        this.$bvToast.toast('Please select a relationship', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      // Create a copy of the current support person
      const newPerson = { ...this.assessmentForm.socialEnvironmental.currentSupportPerson };

      // Add the person to the array
      this.assessmentForm.socialEnvironmental.supportPersons.push(newPerson);

      // Reset the current support person form
      this.assessmentForm.socialEnvironmental.currentSupportPerson = {
        name: '',
        relationship: '',
        mobile: '',
        frequency: 'Weekly',
        mealPreparation: false,
        emergencyContact: false,
        transportation: false,
        homeMaintenance: false,
        notes: ''
      };
    },

    removeSupportPerson(index) {
      this.assessmentForm.socialEnvironmental.supportPersons.splice(index, 1);
    },

    saveAssessment() {
      // Here you would typically save the assessment to your backend
      console.log('Saving assessment:', this.assessmentForm);
      console.log('Assessment type:', this.activeMedicalTab);

      // Show success message
      this.$bvToast.toast(`${this.activeMedicalTab} assessment saved successfully!`, {
        title: 'Success',
        variant: 'success',
        solid: true
      });

      // Close the modal
      this.showAssessmentModal = false;
    },
    
    viewAssessmentDetails(assessment) {
      // Set the selected assessment
      this.selectedAssessment = assessment;
      
      // Show the assessment details modal
      this.showAssessmentDetailsModal = true;
      
      console.log('Viewing assessment details:', assessment);
    },

    addDevice() {
      // Validate form fields
      if (!this.deviceForm.name) {
        this.$bvToast.toast('Please enter a device name', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if (!this.deviceForm.model) {
        this.$bvToast.toast('Please enter a model number', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if (!this.deviceForm.manufacturer) {
        this.$bvToast.toast('Please enter a manufacturer', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      // Generate a new device ID
      const newId = this.connectedDevices.length > 0
        ? Math.max(...this.connectedDevices.map(device => device.id)) + 1
        : 1;

      // Set icon and colors based on device type
      let icon = 'fas fa-laptop-medical';
      let iconBg = 'bg-soft-primary';
      let iconColor = 'text-primary';

      switch(this.deviceForm.type) {
        case 'smartwatch':
          icon = 'fas fa-watch';
          iconBg = 'bg-soft-primary';
          iconColor = 'text-primary';
          break;
        case 'glucosemonitor':
          icon = 'fas fa-tint';
          iconBg = 'bg-soft-danger';
          iconColor = 'text-danger';
          break;
        case 'bpmonitor':
          icon = 'fas fa-heart';
          iconBg = 'bg-soft-info';
          iconColor = 'text-info';
          break;
        case 'ecgmonitor':
          icon = 'fas fa-heartbeat';
          iconBg = 'bg-soft-warning';
          iconColor = 'text-warning';
          break;
        case 'pulseoximeter':
          icon = 'fas fa-lungs';
          iconBg = 'bg-soft-success';
          iconColor = 'text-success';
          break;
        case 'thermometer':
          icon = 'fas fa-thermometer-half';
          iconBg = 'bg-soft-danger';
          iconColor = 'text-danger';
          break;
      }

      // Create a new device object
      const newDevice = {
        id: newId,
        name: this.deviceForm.name,
        type: this.deviceForm.type,
        model: this.deviceForm.model,
        manufacturer: this.deviceForm.manufacturer,
        serialNumber: this.deviceForm.serialNumber,
        lastSynced: 'Just now',
        status: this.deviceForm.status,
        batteryLevel: this.deviceForm.batteryLevel,
        icon: icon,
        iconBg: iconBg,
        iconColor: iconColor,
        stats: [
          { name: 'Status', value: this.deviceForm.status === 'connected' ? 'Connected' : 'Disconnected', icon: 'fas fa-signal', color: 'text-primary' }
        ]
      };

      // Add type-specific properties
      if (this.deviceForm.type === 'smartwatch') {
        newDevice.stats.push(
          { name: 'Heart Rate', value: '0', unit: 'bpm', icon: 'fas fa-heartbeat', color: 'text-danger' },
          { name: 'Steps', value: '0', unit: '', icon: 'fas fa-shoe-prints', color: 'text-primary' },
          { name: 'Calories', value: '0', unit: '', icon: 'fas fa-fire', color: 'text-warning' }
        );
      } else if (this.deviceForm.type === 'glucosemonitor') {
        newDevice.currentGlucose = '0';
        newDevice.glucoseUnit = 'mg/dL';
        newDevice.dailyAverage = '0';
        newDevice.target = '70-120';
      } else if (this.deviceForm.type === 'bpmonitor') {
        newDevice.lastReading = '0/0';
        newDevice.unit = 'mmHg';
        newDevice.pulse = '0';
        newDevice.pulseUnit = 'bpm';
        newDevice.statusText = 'Not Available';
      }

      // Add the new device to the list
      this.connectedDevices.push(newDevice);

      // Show success message
      this.$bvToast.toast('Device added successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });

      // Reset the form
      this.deviceForm = {
        name: '',
        type: 'smartwatch',
        model: '',
        manufacturer: '',
        serialNumber: '',
        lastSynced: new Date().toISOString(),
        status: 'connected',
        batteryLevel: 100,
        notes: ''
      };

      // Close the modal
      this.showDeviceModal = false;

      // Reset the form and step
      this.currentAssessmentStep = 1;

      // Reset the form based on the assessment type
      this.assessmentForm = {
        pastMedicalHistory: {
          conditions: [],
          customCondition: '',
          diagnosisDate: '',
          status: 'Active',
          notes: ''
        },
        familyHistory: {
          members: [],
          currentMember: {
            relationship: '',
            age: '',
            status: 'Living',
            conditions: [],
            customCondition: '',
            notes: ''
          }
        },
        medicationHistory: {
          medicationName: '',
          dosage: '',
          frequency: '',
          startDate: '',
          endDate: '',
          purpose: '',
          prescriber: '',
          status: 'Current',
          notes: ''
        },
        socialHistory: {
          tobaccoUse: 'Never',
          alcoholUse: 'Never',
          drugUse: 'Never',
          exercise: 'None',
          diet: '',
          occupation: '',
          livingArrangement: '',
          familySupport: '',
          notes: ''
        },
        physicalExamination: {
          height: '',
          weight: '',
          bmi: '',
          temperature: '',
          pulse: '',
          respiratoryRate: '',
          bloodPressure: '',
          oxygenSaturation: '',
          generalAppearance: '',
          skin: '',
          heent: '',
          neck: '',
          cardiovascular: '',
          respiratory: '',
          gastrointestinal: '',
          musculoskeletal: '',
          neurological: '',
          psychiatric: '',
          notes: ''
        },
        socialEnvironmental: {
          housingStatus: '',
          livingArrangement: '',
          transportationAccess: '',
          foodSecurity: '',
          financialStability: '',
          educationLevel: '',
          employmentStatus: '',
          socialSupport: '',
          communityEngagement: '',
          safetyRisks: '',
          environmentalExposures: '',
          notes: '',
          supportPersons: [],
          currentSupportPerson: {
            name: '',
            relationship: '',
            mobile: '',
            frequency: 'Weekly',
            mealPreparation: false,
            emergencyContact: false,
            transportation: false,
            homeMaintenance: false,
            notes: ''
          },
          supportScore: 82,
          familySupport: 'Excellent',
          communitySupport: 'Good',
          professionalSupport: 'Good',
          summaryAssessment: 'Patient has a strong support network, primarily from spouse and adult children. Active in church community which provides additional social connections. Professional healthcare team is well-established with good coordination.',
          keyStrengths: [
            'Spouse provides consistent daily support',
            'Adult children visit weekly and assist with transportation',
            'Active church membership provides social engagement'
          ],
          potentialGaps: [
            'Limited backup transportation options',
            'Spouse is sole caregiver with minimal respite'
          ],
          recommendations: {
            caregiverSupport: 'Explore respite care options for spouse to prevent caregiver burnout. Consider adult day program 1-2 days/week.',
            transportationResources: 'Connect with senior transportation services as backup option when family is unavailable. Provide information on local senior ride programs.',
            socialEngagement: 'Encourage participation in senior center activities to expand social network beyond family and church. Consider diabetes support group.',
            technologySupport: 'Explore video calling options to maintain connection with grandchildren who live out of state. Consider basic smartphone training.'
          }
        }
      };
    },
    saveReviewNote() {
      // Here you would typically save the note to your backend
      console.log('Saving review note:', this.reviewNoteText);
      // For demo purposes, just close the modal
      this.showReviewNoteModal = false;
      // Reset the form
      this.reviewNoteText = '';
    },
    saveNewNote() {
      // Validate required fields
      if (!this.newNote.doctor || !this.newNote.hospital || !this.newNote.content) {
        this.$bvToast.toast('Please fill in all required fields', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      // Create a new note object
      const note = {
        id: this.patientNotes.length > 0 ? Math.max(...this.patientNotes.map(n => n.id)) + 1 : 1,
        doctor: this.newNote.doctor,
        hospital: this.newNote.hospital,
        date: this.newNote.date,
        content: this.newNote.content
      };

      // Add the note to the beginning of the array
      this.patientNotes.unshift(note);

      // Show success message
      this.$bvToast.toast('Note created successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });

      // Close the modal
      this.showCreateNoteModal = false;

      // Reset the form
      this.newNote = {
        doctor: '',
        hospital: '',
        content: '',
        date: new Date().toISOString().substr(0, 10)
      };
    },
    saveTreatmentTest() {
      // Here you would typically save the treatment/test to your backend
      console.log('Saving treatment/test:', this.treatmentTestForm);
      // For demo purposes, just close the modal
      this.showTreatmentTestModal = false;
      // Reset the form
      this.treatmentTestForm = {
        treatmentType: '',
        testName: '',
        description: '',
        date: '',
        provider: '',
        notes: ''
      };
    },
    openTreatmentModal() {
      // Reset the form before opening the modal
      this.resetTreatmentForm();
      this.showTreatmentModal = true;
    },
    saveTreatment() {
      // Here you would typically save the treatment to your backend
      console.log('Saving treatment:', this.treatmentForm);

      // Validate required fields based on treatment type
      let isValid = true;
      let errorMessage = '';

      if (this.treatmentForm.type === 'surgical') {
        // Validate surgical fields
        if (!this.treatmentForm.name) {
          isValid = false;
          errorMessage = 'Please fill in all required fields for surgical treatment';
        }
      } else if (this.treatmentForm.type === 'non-surgical') {
        // Validate non-surgical fields
        if (!this.treatmentForm.nonSurgicalDetails.programTypes || this.treatmentForm.nonSurgicalDetails.programTypes.length === 0) {
          isValid = false;
          errorMessage = 'Please fill in all required fields for non-surgical treatment';
        }
      } else if (this.treatmentForm.type === 'others') {
        // Validate diagnosis fields
        if (!this.treatmentForm.othersDetails.category || !this.treatmentForm.othersDetails.specificType || !this.treatmentForm.othersDetails.description) {
          isValid = false;
          errorMessage = 'Please fill in all required fields for diagnosis';
        }
      }

      if (!isValid) {
        // Show error message
        this.$bvToast.toast(errorMessage, {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      // For demo purposes, add the treatment to the treatments array
      const newTreatment = {
        id: this.treatments.length + 1,
        type: this.treatmentForm.type,
        name: this.treatmentForm.name || (this.treatmentForm.type === 'others' ? this.treatmentForm.othersDetails.specificType : ''),
        notes: this.treatmentForm.notes
      };

      // Add the appropriate details based on treatment type
      if (this.treatmentForm.type === 'surgical') {
        newTreatment.surgicalDetails = { ...this.treatmentForm.surgicalDetails };
      } else if (this.treatmentForm.type === 'non-surgical') {
        newTreatment.nonSurgicalDetails = { ...this.treatmentForm.nonSurgicalDetails };
      } else if (this.treatmentForm.type === 'others') {
        newTreatment.othersDetails = { ...this.treatmentForm.othersDetails };
      }

      // Add to the beginning of the array to show newest first
      this.treatments.unshift(newTreatment);

      // Close the modal
      this.showTreatmentModal = false;
      this.showTreatmentWizard = false;

      // Reset the form
      this.resetTreatmentForm();

      // Show success message
      this.$bvToast.toast('Treatment saved successfully', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    resetTreatmentForm() {
      // Reset services and addedTreatments
      this.services = [];
      this.addedTreatments = [];
      this.selectAllTreatments = false;
      this.newService = {
        type: "",
        name: []
      };

      this.treatmentForm = {
        type: 'surgical',
        name: '',
        notes: '',
        prescriptions: [],
        surgicalDetails: {
          procedure: [],
          location: '',
          anesthesia: '',
          duration: '',
          complications: '',
          surgeon: '',
          assistants: '',
          preOpDiagnosis: '',
          postOpDiagnosis: '',
          implants: '',
          bloodLoss: '',
          painLevel: 0,
          recoveryTime: '',
          followUpDate: '',
          followUpInstructions: '',
          operationTheaterDuration: '',
          equipment: [],
          rentedEquipment: [],
          teamMembers: {
            nurseCount: 0,
            nurses: [],
            assistantDoctorCount: 0,
            assistantDoctors: [],
            seniorDoctorCount: 0,
            seniorDoctors: []
          }
        },
        nonSurgicalDetails: {
          treatmentType: '',
          programTypes: [], // Array to store selected program types
          frequency: '',
          duration: '',
          dosage: '',
          route: '',
          medicationName: '',
          medicationClass: '',
          manufacturer: '',
          sideEffects: '',
          contraindications: '',
          therapyGoals: '',
          therapyProgress: '',
          homeInstructions: '',
          refills: 0,
          pharmacyName: '',
          pharmacyPhone: ''
        },
        othersDetails: {
          category: '',
          specificType: '',
          description: '',
          duration: '',
          frequency: '',
          specialInstructions: '',
          additionalNotes: ''
        }
      };
      this.selectedTreatmentType = '';
      this.showTreatmentWizard = false;
    },

    /**
     * Add a new service to the services array
     */
    addService() {
      if (this.newService.type && this.newService.name.length > 0) {
        this.services.push({
          id: Date.now(), // Unique ID for each service
          type: this.newService.type,
          name: this.newService.name
        });
        // Reset new service form
        this.newService = {
          type: "",
          name: []
        };
      }
    },

    /**
     * Remove a service from the services array
     */
    removeService(index) {
      this.services.splice(index, 1);
    },

    /**
     * Edit a service in the services array
     */
    editService(index) {
      const service = this.services[index];
      this.newService = {
        type: service.type,
        name: [...service.name] // Create a copy of the array
      };
      this.removeService(index);
    },

    /**
     * Add a new treatment to the addedTreatments array
     */
    addTreatment() {
      if (this.treatmentForm.name && this.treatmentForm.description && this.services.length > 0) {
        // Create a new treatment object
        const newTreatment = {
          id: Date.now(), // Unique ID for each treatment
          name: this.treatmentForm.name,
          description: this.treatmentForm.description,
          services: JSON.parse(JSON.stringify(this.services)), // Deep copy of services
          selected: false
        };

        // Add the treatment to the addedTreatments array
        this.addedTreatments.push(newTreatment);

        // Reset the form fields but keep the services
        this.treatmentForm.name = '';
        this.treatmentForm.description = '';

        // Show success message
        this.$bvToast.toast('Treatment added successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      }
    },

    /**
     * Remove a treatment from the addedTreatments array
     */
    removeTreatment(index) {
      this.addedTreatments.splice(index, 1);

      // Update selectAllTreatments if no treatments are selected
      if (this.addedTreatments.length === 0) {
        this.selectAllTreatments = false;
      }
    },

    /**
     * Toggle select all treatments
     */
    toggleSelectAllTreatments() {
      // Set all treatment selected properties to match selectAllTreatments
      this.addedTreatments.forEach(treatment => {
        treatment.selected = this.selectAllTreatments;
      });
    },

    /**
     * Get service options based on selected service type
     */
    getServiceOptions() {
      if (this.newService.type === 'Medical') {
        return this.medicalServiceOptions;
      } else if (this.newService.type === 'Medical Support') {
        return this.medicalSupportServiceOptions;
      } else if (this.newService.type === 'Non Medical') {
        return this.nonMedicalServiceOptions;
      }
      return [];
    },

    selectTreatmentType(type) {
      this.selectedTreatmentType = type;

      // Reset the treatment form type based on selection
      if (type === 'treatment') {
        // Default to surgical when treatment is selected
        this.treatmentForm.type = 'surgical';
      } else if (type === 'programs') {
        // For programs, we'll use the wizard and set type to non-surgical
        this.treatmentForm.type = 'non-surgical';
        this.showTreatmentWizard = true; // Immediately show the wizard

        // Initialize frequency and duration for any existing program types
        this.initializeProgramTypeFields(this.treatmentForm.nonSurgicalDetails.programTypes);
      } else if (type === 'diagnosis') {
        // For diagnosis, we'll set type to others
        this.treatmentForm.type = 'others';
      }
    },
    toggleAddOnService(serviceId) {
      // Check if the service is already selected
      const index = this.wellnessEntryForm.addOnServices.indexOf(serviceId);

      if (index === -1) {
        // If not selected, add it
        this.wellnessEntryForm.addOnServices.push(serviceId);
      } else {
        // If already selected, remove it
        this.wellnessEntryForm.addOnServices.splice(index, 1);
      }
    },

    togglePackageSelection(pkg) {
      // Check if the package is already selected
      const index = this.wellnessEntryForm.selectedPackages.findIndex(p => p.id === pkg.id);

      if (index === -1) {
        // If not selected, add it
        this.wellnessEntryForm.selectedPackages.push(pkg);
      } else {
        // If already selected, remove it
        this.wellnessEntryForm.selectedPackages.splice(index, 1);
      }
    },

    editPackage(pkg) {
      // In a real application, this would open a form or modal to edit the package details
      // For now, we'll just show a toast message
      this.$bvToast.toast(`Editing package: ${pkg.name}`, {
        title: 'Edit Package',
        variant: 'info',
        solid: true
      });
    },

    editProgramType(programType) {
      // In a real application, this would open a form or modal to edit the program type details
      // For now, we'll just show a toast message
      this.$bvToast.toast(`Editing program type: ${programType.name}`, {
        title: 'Edit Program Type',
        variant: 'info',
        solid: true
      });
    },

    removeProgramType(index) {
      // Remove the program type at the specified index
      this.treatmentForm.nonSurgicalDetails.programTypes.splice(index, 1);

      // Show success message
      this.$bvToast.toast('Program type removed', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },

    initializeProgramTypeFields(selectedProgramTypes) {
      // Initialize frequency and duration for each program type if not already set
      if (selectedProgramTypes && selectedProgramTypes.length > 0) {
        selectedProgramTypes.forEach(programType => {
          if (!Object.prototype.hasOwnProperty.call(programType, 'frequency')) {
            this.$set(programType, 'frequency', '');
          }
          if (!Object.prototype.hasOwnProperty.call(programType, 'duration')) {
            this.$set(programType, 'duration', '');
          }
        });
      }
    },

    isPackageSelected(packageId) {
      // Check if a package is selected
      return this.wellnessEntryForm.selectedPackages.some(p => p.id === packageId);
    },

    calculateTotalPrice() {
      let total = 0;

      // Add the price of all selected packages
      this.wellnessEntryForm.selectedPackages.forEach(pkg => {
        total += pkg.price;
      });

      // Add the prices of selected add-on services
      this.wellnessEntryForm.addOnServices.forEach(serviceId => {
        const service = this.wellnessAddOnServices.find(s => s.id === serviceId);
        if (service) {
          total += service.price;
        }
      });

      return total;
    },

    submitWellnessEntry() {
      // Here you would typically save the wellness entry to your backend
      console.log('Submitting wellness entry:', {
        packages: this.wellnessEntryForm.selectedPackages,
        addOnServices: this.wellnessEntryForm.addOnServices.map(id =>
          this.wellnessAddOnServices.find(s => s.id === id)
        ),
        totalPrice: this.calculateTotalPrice()
      });

      // Show success message
      this.$bvToast.toast('Wellness packages added successfully', {
        title: 'Success',
        variant: 'success',
        solid: true
      });

      // Reset the form
      this.wellnessEntryForm = {
        selectedPackages: [],
        addOnServices: []
      };

      // Close the modal
      this.showWellnessEntryModal = false;
    },

    handlePrescriptionUpload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          // Store file information
          this.treatmentForm.prescriptions.push({
            name: file.name,
            type: file.type,
            size: file.size,
            lastModified: file.lastModified,
            // In a real application, you would upload the file to a server
            // and store the URL or file ID here
            data: URL.createObjectURL(file) // Create a temporary URL for preview
          });
        }

        // Show success message
        this.$bvToast.toast(`${files.length} prescription file(s) uploaded successfully`, {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      }
    },
    removePrescription(index) {
      // Remove the prescription at the specified index
      this.treatmentForm.prescriptions.splice(index, 1);

      // Show success message
      this.$bvToast.toast('Prescription file removed', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    addProcedure() {
      if (this.selectedProcedure && !this.treatmentForm.surgicalDetails.procedure.includes(this.selectedProcedure)) {
        this.treatmentForm.surgicalDetails.procedure.push(this.selectedProcedure);
        this.selectedProcedure = ''; // Reset selection
      }
    },
    removeProcedure(index) {
      this.treatmentForm.surgicalDetails.procedure.splice(index, 1);
    },
    getProcedureDetails(procedureName) {
      return this.procedureDetails[procedureName] || {
        description: 'No description available',
        treatment: 'No treatment information available',
        recovery: 'No recovery information available',
        risks: 'No risk information available'
      };
    },
    getTreatmentTypeIcon(type) {
      return type === 'surgical'
        ? 'fas fa-procedures'
        : 'fas fa-pills';
    },
    getTreatmentTypeClass(type) {
      return type === 'surgical'
        ? 'badge-soft-danger'
        : 'badge-soft-primary';
    },
    getTransitionTypeIcon(type) {
      switch(type) {
        case 'discharge':
          return 'fas fa-hospital-alt';
        case 'referral':
          return 'fas fa-user-md';
        case 'transfer':
          return 'fas fa-ambulance';
        default:
          return 'fas fa-exchange-alt';
      }
    },
    getTransitionStatusClass(status) {
      switch(status) {
        case 'Completed':
          return 'badge-soft-success';
        case 'In Progress':
          return 'badge-soft-primary';
        case 'Scheduled':
          return 'badge-soft-warning';
        case 'Cancelled':
          return 'badge-soft-danger';
        default:
          return 'badge-soft-secondary';
      }
    },
    openTransitionModal() {
      // Reset the form before opening the modal
      this.resetTransitionForm();
      this.showTransitionModal = true;
    },

    resetTransitionForm() {
      this.transitionForm = {
        selectedPrograms: [],
        patientInfo: {
          name: '',
          age: '',
          gender: '',
          condition: '',
          admissionDate: new Date().toISOString().substr(0, 10),
          dischargeDate: ''
        },
        addOnServices: [],
        selectedProgramDetails: null
      };
    },

    toggleTransitionAddOnService(serviceId) {
      // Check if the service is already selected
      const index = this.transitionForm.addOnServices.indexOf(serviceId);

      if (index === -1) {
        // If not selected, add it
        this.transitionForm.addOnServices.push(serviceId);
      } else {
        // If already selected, remove it
        this.transitionForm.addOnServices.splice(index, 1);
      }
    },

    toggleProgramSelection(program) {
      // Check if the program is already selected
      const index = this.transitionForm.selectedPrograms.findIndex(p => p.id === program.id);

      if (index === -1) {
        // If not selected, add it
        this.transitionForm.selectedPrograms.push(program);
      } else {
        // If already selected, remove it
        this.transitionForm.selectedPrograms.splice(index, 1);
      }
    },

    viewProgramDetails(program) {
      // Set the selected program details for viewing
      this.transitionForm.selectedProgramDetails = program;
    },

    clearProgramDetails() {
      // Clear the selected program details
      this.transitionForm.selectedProgramDetails = null;
    },

    isProgramSelected(programId) {
      // Check if a program is selected
      return this.transitionForm.selectedPrograms.some(p => p.id === programId);
    },

    calculateTransitionTotalPrice() {
      let total = 0;

      // Add the price of all selected programs
      this.transitionForm.selectedPrograms.forEach(program => {
        total += program.price;
      });

      // Add the prices of selected add-on services
      this.transitionForm.addOnServices.forEach(serviceId => {
        const service = this.transitionCareAddOnServices.find(s => s.id === serviceId);
        if (service) {
          total += service.price;
        }
      });

      return total;
    },

    submitTransitionForm() {
      // Here you would typically save the transition to your backend
      console.log('Submitting transition form:', {
        programs: this.transitionForm.selectedPrograms,
        patientInfo: this.transitionForm.patientInfo,
        addOnServices: this.transitionForm.addOnServices.map(id =>
          this.transitionCareAddOnServices.find(s => s.id === id)
        ),
        totalPrice: this.calculateTransitionTotalPrice()
      });

      // For demo purposes, create a transition for each selected program
      this.transitionForm.selectedPrograms.forEach(program => {
        const newTransition = {
          id: this.transitions.length + 1,
          type: 'admission',
          name: `${program.tier}: ${program.name}`,
          date: this.transitionForm.patientInfo.admissionDate,
          from: 'Referral',
          to: 'Rehabilitation Center',
          coordinator: 'Dr. Emily Wilson',
          status: 'Scheduled',
          reason: this.transitionForm.patientInfo.condition,
          documents: [],
          careTeam: [
            { name: 'Dr. Emily Wilson', role: 'Primary Care Physician' },
            { name: 'Sarah Johnson', role: 'Rehabilitation Nurse' }
          ]
        };

        // Add to the beginning of the array to show newest first
        this.transitions.unshift(newTransition);
      });

      // Show success message
      this.$bvToast.toast('Transition care entries added successfully', {
        title: 'Success',
        variant: 'success',
        solid: true
      });

      // Reset the form
      this.resetTransitionForm();

      // Close the modal
      this.showTransitionModal = false;
    },
    formatTreatmentDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    updateNurseCount() {
      const count = this.treatmentForm.surgicalDetails.teamMembers.nurseCount;
      const currentNurses = this.treatmentForm.surgicalDetails.teamMembers.nurses;

      // If increasing count, add empty entries
      if (count > currentNurses.length) {
        for (let i = currentNurses.length; i < count; i++) {
          currentNurses.push('');
        }
      }
      // If decreasing count, remove excess entries
      else if (count < currentNurses.length) {
        this.treatmentForm.surgicalDetails.teamMembers.nurses = currentNurses.slice(0, count);
      }
    },
    updateAssistantDoctorCount() {
      const count = this.treatmentForm.surgicalDetails.teamMembers.assistantDoctorCount;
      const currentDoctors = this.treatmentForm.surgicalDetails.teamMembers.assistantDoctors;

      // If increasing count, add empty entries
      if (count > currentDoctors.length) {
        for (let i = currentDoctors.length; i < count; i++) {
          currentDoctors.push('');
        }
      }
      // If decreasing count, remove excess entries
      else if (count < currentDoctors.length) {
        this.treatmentForm.surgicalDetails.teamMembers.assistantDoctors = currentDoctors.slice(0, count);
      }
    },
    updateSeniorDoctorCount() {
      const count = this.treatmentForm.surgicalDetails.teamMembers.seniorDoctorCount;
      const currentDoctors = this.treatmentForm.surgicalDetails.teamMembers.seniorDoctors;

      // If increasing count, add empty entries
      if (count > currentDoctors.length) {
        for (let i = currentDoctors.length; i < count; i++) {
          currentDoctors.push('');
        }
      }
      // If decreasing count, remove excess entries
      else if (count < currentDoctors.length) {
        this.treatmentForm.surgicalDetails.teamMembers.seniorDoctors = currentDoctors.slice(0, count);
      }
    },
    removeNurse(index) {
      this.treatmentForm.surgicalDetails.teamMembers.nurses.splice(index, 1);
      this.treatmentForm.surgicalDetails.teamMembers.nurseCount--;
    },
    removeAssistantDoctor(index) {
      this.treatmentForm.surgicalDetails.teamMembers.assistantDoctors.splice(index, 1);
      this.treatmentForm.surgicalDetails.teamMembers.assistantDoctorCount--;
    },
    removeSeniorDoctor(index) {
      this.treatmentForm.surgicalDetails.teamMembers.seniorDoctors.splice(index, 1);
      this.treatmentForm.surgicalDetails.teamMembers.seniorDoctorCount--;
    },
    addRentedEquipment() {
      // Add a new empty rented equipment item
      this.treatmentForm.surgicalDetails.rentedEquipment.push({
        name: '',
        cost: '',
        duration: ''
      });
    },
    removeRentedEquipment(index) {
      // Remove the rented equipment item at the specified index
      this.treatmentForm.surgicalDetails.rentedEquipment.splice(index, 1);
    },
    saveReferral() {
      // Here you would typically save the referral to your backend
      console.log('Saving referral with search:', this.referralSearch);
      // For demo purposes, just close the modal
      this.showReferralModal = false;
      // Reset the form
      this.referralSearch = '';
    },
    startAssessment() {
      // Show toast notification indicating enrollment is complete and care plan is being created
      this.$bvToast.toast(`${this.selectedProgram} enrollment completed. Creating care plan...`, {
        title: `${this.selectedProgram} Care Plan`,
        variant: 'success',
        solid: true
      });

      // Set assessmentStarted to true to show the form wizard
      this.assessmentStarted = true;
    },
    enrollProgram(program) {
      this.selectedProgram = program;
      this.$bvModal.show('modal-xl');
      this.$bvToast.toast(`${program} enrollment initiated. Please select a condition to continue.`, {
        title: `${program} Enrollment`,
        variant: 'success',
        solid: true
      });
    },
    // Start editing a specific row
    startEditing(index) {
      // Reset any previously editing row
      this.carePlanData.forEach(row => {
        // Use Vue.set to ensure reactivity if the property doesn't exist
        this.$set(row, 'isEditing', false);
      });

      // Set the current row to editing mode
      this.$set(this.carePlanData[index], 'isEditing', true);

      // Initialize with empty input fields
      // Count the number of bullet points in the patientInfo to determine how many input fields to create
      const content = this.carePlanData[index].patientInfo;
      const goalLines = content.split('<br/>').filter(line => line.trim().startsWith('•'));
      // Create an array of empty strings with the same length as goalLines
      this.editedGoals = Array(goalLines.length).fill('');
    },

    // Save the edited content
    saveEditing(index) {
      // For all sections, reconstruct the HTML content from individual goals
      const updatedContent = this.editedGoals
        .filter(goal => goal.trim() !== '') // Remove empty goals
        .map(goal => `<span style="font-size: inherit; font-family: inherit; color: inherit;">• ${goal}</span>`)
        .join('<br/>');

      // Update the row content
      this.$set(this.carePlanData[index], 'ccmUpdate', updatedContent);

      // Exit editing mode
      this.$set(this.carePlanData[index], 'isEditing', false);

      // Reset the edited goals
      this.editedGoals = [];
    },

    // Cancel editing
    cancelEditing() {
      // Reset all rows to non-editing mode
      this.carePlanData.forEach(row => {
        this.$set(row, 'isEditing', false);
      });

      // Reset the edited content
      this.editedContent = '';

      // Reset the edited goals
      this.editedGoals = [];
    },
    openImageUploadModal() {
      this.showImageUploadModal = true;
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.avatarImage = e.target.result;
          this.showImageUploadModal = false;
        };
        reader.readAsDataURL(file);
      }
    },
    formatDate(date) {
      const d = new Date(date);
      return d.toLocaleDateString();
    },
    viewLogDetails(log) {
      // Here you would typically show a modal with the log details
      console.log('Viewing log details:', log);
      this.$bvToast.toast('Viewing details for log entry', {
        title: 'Log Details',
        variant: 'info',
        solid: true
      });
    },

    exportLogEntry(log) {
      // Here you would typically export the log entry to a file
      console.log('Exporting log entry:', log);
      this.$bvToast.toast('Log entry exported successfully', {
        title: 'Export',
        variant: 'success',
        solid: true
      });
    },

    renderChart() {
      // Weight Chart
      if (this.$refs.weightChart) {
        const weightCtx = this.$refs.weightChart.getContext("2d");
        this.charts.weight = new Chart(weightCtx, {
          type: "line",
          data: {
            labels: this.weightData.map(entry => this.formatDate(entry.date)),
            datasets: [
              {
                label: "Body Weight (kg)",
                data: this.weightData.map(entry => entry.value),
                fill: true,
                lineTension: 0.3,
                backgroundColor: "rgba(85, 110, 230, 0.2)",
                borderColor: "rgba(85, 110, 230, 1)",
                pointBackgroundColor: "#fff",
                pointBorderColor: "#556ee6",
                pointHoverBackgroundColor: "#556ee6",
                pointHoverBorderColor: "#fff"
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false
                  }
                }
              ]
            }
          }
        });
      }

      // Blood Pressure Chart
      if (this.$refs.bpChart) {
        const bpCtx = this.$refs.bpChart.getContext("2d");
        this.charts.bloodPressure = new Chart(bpCtx, {
          type: "line",
          data: {
            labels: this.bloodPressureData.map(entry => this.formatDate(entry.date)),
            datasets: [
              {
                label: "Systolic",
                data: this.bloodPressureData.map(entry => entry.systolic),
                fill: false,
                lineTension: 0.3,
                backgroundColor: "rgba(241, 180, 76, 0.2)",
                borderColor: "rgba(241, 180, 76, 1)",
                pointBackgroundColor: "#fff",
                pointBorderColor: "#f1b44c",
                pointHoverBackgroundColor: "#f1b44c",
                pointHoverBorderColor: "#fff"
              },
              {
                label: "Diastolic",
                data: this.bloodPressureData.map(entry => entry.diastolic),
                fill: false,
                lineTension: 0.3,
                backgroundColor: "rgba(52, 195, 143, 0.2)",
                borderColor: "rgba(52, 195, 143, 1)",
                pointBackgroundColor: "#fff",
                pointBorderColor: "#34c38f",
                pointHoverBackgroundColor: "#34c38f",
                pointHoverBorderColor: "#fff"
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false
                  }
                }
              ]
            }
          }
        });
      }

      // Heart Rate Chart
      if (this.$refs.hrChart) {
        const hrCtx = this.$refs.hrChart.getContext("2d");
        this.charts.heartRate = new Chart(hrCtx, {
          type: "line",
          data: {
            labels: this.heartRateData.map(entry => this.formatDate(entry.date)),
            datasets: [
              {
                label: "Heart Rate (bpm)",
                data: this.heartRateData.map(entry => entry.value),
                fill: true,
                lineTension: 0.3,
                backgroundColor: "rgba(244, 106, 106, 0.2)",
                borderColor: "rgba(244, 106, 106, 1)",
                pointBackgroundColor: "#fff",
                pointBorderColor: "#f46a6a",
                pointHoverBackgroundColor: "#f46a6a",
                pointHoverBorderColor: "#fff"
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false
                  }
                }
              ]
            }
          }
        });
      }

      // Glucose Chart
      if (this.$refs.glucoseChart) {
        const glucoseCtx = this.$refs.glucoseChart.getContext("2d");
        this.charts.glucose = new Chart(glucoseCtx, {
          type: "line",
          data: {
            labels: this.glucoseData.map(entry => this.formatDate(entry.date)),
            datasets: [
              {
                label: "Blood Glucose (mg/dL)",
                data: this.glucoseData.map(entry => entry.value),
                fill: true,
                lineTension: 0.3,
                backgroundColor: "rgba(80, 165, 241, 0.2)",
                borderColor: "rgba(80, 165, 241, 1)",
                pointBackgroundColor: "#fff",
                pointBorderColor: "#50a5f1",
                pointHoverBackgroundColor: "#50a5f1",
                pointHoverBorderColor: "#fff"
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false
                  }
                }
              ]
            }
          }
        });
      }
    }
  },
  mounted() {
    this.renderChart();
  },
  computed: {
    averageWeight() {
      if (!this.weightData.length) return 0;
      const total = this.weightData.reduce((sum, entry) => sum + entry.value, 0);
      return (total / this.weightData.length).toFixed(2);
    },
    paginatedTreatments() {
      const start = (this.treatmentCurrentPage - 1) * this.treatmentPerPage;
      const end = start + this.treatmentPerPage;
      return this.treatments.slice(start, end);
    },
    totalTreatmentPages() {
      return Math.ceil(this.treatments.length / this.treatmentPerPage);
    }
  },

};
</script>

<style scoped>
/* Vue Multiselect Custom Styles */
.multiselect {
  min-height: 38px;
}

.multiselect__tags {
  min-height: 38px;
  padding: 6px 8px;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
  background: #fff;
}

.multiselect__placeholder {
  padding-top: 0;
  margin-bottom: 0;
}

.multiselect__input, .multiselect__single {
  margin-bottom: 0;
  padding: 0;
}

.multiselect__tag {
  background: #556ee6;
  margin-bottom: 0;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background: #4458b8;
}

.multiselect--active {
  z-index: 1000;
}

/* Custom styles for improved multiselect appearance */
.custom-multiselect {
  margin-bottom: 0.5rem;
}

.custom-multiselect .multiselect__tags {
  border-radius: 0.375rem;
  border: 1px solid #ced4da;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.custom-multiselect .multiselect__tags:hover {
  border-color: #a9b6d0;
}

.custom-multiselect.multiselect--active .multiselect__tags {
  border-color: #556ee6;
  box-shadow: 0 0 0 0.2rem rgba(85, 110, 230, 0.25);
}

.custom-multiselect .multiselect__content-wrapper {
  border-radius: 0 0 0.375rem 0.375rem;
  border-color: #ced4da;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.custom-multiselect .multiselect__option--highlight {
  background: #556ee6;
}

.custom-multiselect .multiselect__option--selected.multiselect__option--highlight {
  background: #f46a6a;
}

.health-info-card {
  transition: all 0.3s ease;
  height: 100%;
}

.health-info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.health-icon-container {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-light-primary {
  background-color: rgba(85, 110, 230, 0.1);
}

.bg-light-info {
  background-color: rgba(52, 195, 239, 0.1);
}

.bg-light-success {
  background-color: rgba(52, 195, 143, 0.1);
}

.goal-item, .notification-item, .follow-up-item {
  transition: all 0.2s ease;
}

.goal-item:hover, .notification-item:hover, .follow-up-item:hover {
  transform: translateX(5px);
}

/* Vital Signs Styles */
.vital-card {
  border: none;
  border-radius: 0.75rem;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.vital-card-weight {
  border-left: 3px solid #556ee6;
}

.vital-card-bp {
  border-left: 3px solid #f1b44c;
}

.vital-card-hr {
  border-left: 3px solid #f46a6a;
}

.vital-card-glucose {
  border-left: 3px solid #50a5f1;
}

.vital-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 1.25rem;
  transition: all 0.3s ease;
}

.vital-icon-weight {
  background-color: rgba(85, 110, 230, 0.15);
  color: #556ee6;
}

.vital-icon-bp {
  background-color: rgba(241, 180, 76, 0.15);
  color: #f1b44c;
}

.vital-icon-hr {
  background-color: rgba(244, 106, 106, 0.15);
  color: #f46a6a;
}

.vital-icon-glucose {
  background-color: rgba(80, 165, 241, 0.15);
  color: #50a5f1;
}

.shadow-hover {
  transition: all 0.3s ease;
}

.shadow-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.18);
}

.bg-soft-warning {
  background-color: rgba(241, 180, 76, 0.18);
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.18);
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.18);
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.18);
}

.text-success {
  color: #34c38f !important;
}

.text-warning {
  color: #f1b44c !important;
}

.text-danger {
  color: #f46a6a !important;
}

.text-info {
  color: #50a5f1 !important;
}

.text-primary {
  color: #556ee6 !important;
}

.btn-soft-primary {
  background-color: rgba(85, 110, 230, 0.15);
  border-color: transparent;
  color: #556ee6;
  transition: all 0.3s ease;
}

.btn-soft-primary:hover {
  background-color: #556ee6;
  color: #fff;
}

.btn-soft-info {
  background-color: rgba(80, 165, 241, 0.15);
  border-color: transparent;
  color: #50a5f1;
  transition: all 0.3s ease;
}

.btn-soft-info:hover {
  background-color: #50a5f1;
  color: #fff;
}

.vital-table {
  max-height: 300px;
  overflow-y: auto;
}

.vital-table-row {
  transition: all 0.2s ease;
}

.vital-table-row:hover {
  background-color: rgba(248, 249, 250, 0.7);
}

/* Audit Logs Styles */
.audit-logs-container {
  animation: fadeIn 0.5s ease-in-out;
}

.audit-time-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(85, 110, 230, 0.1);
  color: #556ee6;
}

.audit-user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(52, 195, 143, 0.1);
  color: #34c38f;
  font-weight: bold;
}

.audit-logs-table th {
  font-weight: 600;
  color: #495057;
}

.audit-logs-table td {
  vertical-align: middle;
  padding: 0.75rem;
}

.search-box {
  position: relative;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.filter-chips .badge {
  cursor: pointer;
  transition: all 0.2s ease;
}

.filter-chips .badge:hover {
  background-color: #e9ecef;
}

/* Animation for vital signs */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes slideInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animate-vital {
  animation: slideInUp 0.5s ease forwards;
  opacity: 0;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- Patient Summary Card - Compact Layout -->
              <div class="col-12">
                <div class="patient-summary-card p-2">
                  <div class="row">
                    <!-- Column 1: Patient Info -->
                    <div class="col-md-4">
                      <div class="patient-info-section mb-0">
                        <div class="section-header mb-1">
                          <h6 class="section-title"><i class="fas fa-info-circle text-primary mr-2"></i>Patient Info</h6>
                        </div>
                        <div class="section-content">
                          <div class="d-flex align-items-center mb-1">
                            <div style="width: 40px; height: 40px; border: 2px solid #0d6efd; border-radius: 50%; overflow: hidden; display: flex; align-items: center; justify-content: center; position: relative;" class="avatar-container me-2">
                              <img :src="avatarImage" alt="Avatar" style="width: 100%; height: 100%; object-fit: cover;">
                            </div>
                            <div>
                              <h6 class="mb-0 fw-bold">JOHN, 55 Yr, M</h6>
                              <span class="badge badge-soft-primary me-1">CCM</span>
                            </div>
                          </div>
                          <div class="info-item">
                            <i class="fas fa-id-card text-info mr-2"></i>
                            <span>MRI: 587456</span>
                          </div>
                          <div class="info-item">
                            <i class="fas fa-phone-alt text-success mr-2"></i>
                            <span>8093143673</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Column 2: Medical & Medications -->
                    <div class="col-md-5">
                      <div class="patient-medical-section mb-0">
                        <div class="section-header mb-1">
                          <h6 class="section-title"><i class="fas fa-heartbeat text-danger mr-2"></i>Medical & Medications</h6>
                        </div>
                        <div class="section-content">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="condition-item">
                                <i class="fas fa-procedures text-danger mr-2"></i>
                                <span>Diabetes</span>
                              </div>
                              <div class="condition-item">
                                <i class="fas fa-heart text-warning mr-2"></i>
                                <span>Hypertension</span>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="medication-item">
                                <i class="fas fa-capsules" style="color: #0dcaf0; margin-right: 8px;"></i>
                                <span>Insulin 20u</span>
                              </div>
                              <div class="medication-item">
                                <i class="fas fa-syringe" style="color: #f1b44c; margin-right: 8px;"></i>
                                <span>Metformin 500mg</span>
                              </div>
                              <div class="medication-item">
                                <i class="fas fa-tablets" style="color: #34c38f; margin-right: 8px;"></i>
                                <span>Lisinopril 10mg</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Column 3: Consulting -->
                    <div class="col-md-3">
                      <div class="patient-consulting-section mb-0">
                        <div class="section-header mb-1">
                          <h6 class="section-title"><i class="fas fa-user-md text-primary mr-2"></i>Consulting</h6>
                        </div>
                        <div class="section-content">
                          <div class="consulting-item">
                            <i class="fas fa-user-md" style="color: #556ee6; margin-right: 8px;"></i>
                            <span>Dr. Johnson</span>
                          </div>
                          <div class="consulting-item">
                            <i class="fas fa-calendar-check text-primary mr-2"></i>
                            <span>Last: 15/05/23</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <EarningReport />
          </div>
        </div>
        <Vitals />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="custom-tabs-container">
              <ul class="nav nav-tabs custom-tabs" role="tablist">
                <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                  <a
                    class="nav-link"
                    :class="{ active: activeTab === index }"
                    @click="activeTab = index"
                    :style="activeTab === index ? { borderTopColor: tab.color } : {}"
                    href="javascript:void(0);"
                    role="tab"
                  >
                    <span class="tab-icon" :style="{ backgroundColor: tab.color }">
                      <i :class="tab.icon"></i>
                    </span>
                    <span class="d-none d-md-inline-block ml-2">{{ tab.name }}</span>
                    <span class="tab-indicator" :style="{ backgroundColor: tab.color }"></span>
                  </a>
                </li>
              </ul>

              <div class="tab-content p-3 text-muted">
                <div class="tab-pane" :class="{ active: activeTab === index, show: activeTab === index }" v-for="(tab, index) in tabs" :key="index">
                  <div v-if="tab.name === 'Assessment / Screening'">
                    <div class="d-flex align-items-center mb-4 justify-content-between">
                      <div class="d-flex align-items-center">
                        <i :class="tab.icon" :style="{ color: tab.color }" class="mr-2 font-size-24"></i>
                        <h4 class="mb-0">{{ tab.name }}</h4>
                        <span class="badge badge-soft-primary ml-2">{{ tab.description }}</span>
                      </div>
                      <button class="btn btn-primary" @click="showAssessmentModal = true">
                        <i class="fas fa-plus-circle mr-1"></i> Create Assessment
                      </button>
                    </div>
                    
                    <!-- Assessment List Table -->
                    <div class="card shadow-sm mb-4">
                      <div class="card-body p-0">
                        <div class="table-responsive assessment-table">
                          <b-table 
                            :items="assessmentList" 
                            :fields="assessmentFields" 
                            hover 
                            responsive
                            class="mb-0 assessment-list-table"
                            show-empty
                            empty-text="No assessments found"
                            sort-by="date"
                            sort-desc
                          >
                            <!-- Date column -->
                            <template #cell(date)="data">
                              <div class="d-flex align-items-center">
                                <div class="assessment-date-icon me-2">
                                  <i class="ri-calendar-line"></i>
                                </div>
                                <div>
                                  <div class="fw-medium">{{ data.value }}</div>
                                </div>
                              </div>
                            </template>

                            <!-- Type column -->
                            <template #cell(type)="data">
                              <span :class="[
                                'badge rounded-pill px-2 py-1',
                                data.value === 'Medical History' ? 'bg-soft-primary text-primary' : 
                                data.value === 'Physical Examination' ? 'bg-soft-success text-success' : 
                                'bg-soft-info text-info'
                              ]">
                                {{ data.value }}
                              </span>
                            </template>

                            <!-- Status column -->
                            <template #cell(status)="data">
                              <span :class="[
                                'badge rounded-pill px-2 py-1',
                                data.value === 'Completed' ? 'bg-soft-success text-success' : 
                                data.value === 'In Progress' ? 'bg-soft-warning text-warning' : 
                                'bg-soft-danger text-danger'
                              ]">
                                {{ data.value }}
                              </span>
                            </template>

                            <!-- Actions column -->
                            <template #cell(actions)="data">
                              <div class="d-flex">
                                <button class="btn btn-sm btn-soft-primary me-1" title="View Details" @click="viewAssessmentDetails(data.item)">
                                  <i class="ri-eye-line"></i> View
                                </button>
                              </div>
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                </div>
                <div v-if="tab.name === 'Care Management'">
                  <div class="d-flex align-items-center mb-4">
                    <i :class="tab.icon" :style="{ color: tab.color }" class="mr-2 font-size-24"></i>
                    <h4 class="mb-0">{{ tab.name }}</h4>
                    <span class="badge badge-soft-success ml-2">{{ tab.description }}</span>
                  </div>
                  <b-row class="g-3">
                    <!-- All buttons in one row -->
                    <b-col md="12">
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="button-items d-flex align-items-center gap-2">
                          <b-button variant="primary" @click="enrollProgram('CCM')">CCM Enroll</b-button>
                          <b-button variant="info" @click="enrollProgram('BHI')">BHI Enroll</b-button>
                          <b-button variant="warning" @click="enrollProgram('RPM')">RPM Enroll</b-button>
                        </div>

                        <div class="d-flex align-items-center">
                          <!-- Grouped buttons -->
                          <b-button-group class="mr-2">
                            <b-button variant="outline-primary" class="d-flex align-items-center">
                              <i class="fas fa-print mr-1"></i> Print / Preview
                            </b-button>

                            <b-button variant="outline-danger" disabled class="d-flex align-items-center">
                              <i class="fas fa-times-circle mr-1"></i> N/A
                            </b-button>

                            <b-button variant="info" class="d-flex align-items-center" v-b-modal.modal-xl>
                              <i class="fas fa-phone-alt mr-1"></i> Call Status
                            </b-button>
                          </b-button-group>

                          <b-button
                              variant="success"
                              class="d-flex align-items-center"
                              v-b-modal.modal-xl
                          >
                            <i class="fas fa-clipboard-check mr-2"></i> New Care Plan
                          </b-button>
                        </div>
                      </div>
                    </b-col>
                  </b-row>



                  <div class="col-sm-6 col-md-4 col-xl-3">
                    <div class="my-4 text-center">

                      <b-modal
                          id="modal-xl"
                          size="xl"
                          :title="`${selectedProgram} Enrollment`"
                          title-class="font-18"
                          hide-footer
                      >
                        <div class="mb-4" v-if="!assessmentStarted">
                          <div class="form-group">
                            <label for="conditionSelect" class="form-label">Select Condition</label>
                            <select id="conditionSelect" v-model="selectedCondition" class="form-control" @change="onConditionChange">
                              <option disabled value="">Please select</option>
                              <option>Diabetes</option>
                              <option>Hypertension</option>
                              <option>Obesity</option>
                              <option>Depression</option>
                            </select>
                          </div>

                          <div v-if="selectedCondition" class="mt-3">
                            <div class="form-group">
                              <label class="form-label">ICD / Diagnosis Code</label>
                              <input type="text" v-model="diagnosisCode" class="form-control" readonly />
                            </div>

                            <div class="form-group mt-3">
                              <label for="programSelect" class="form-label">Program</label>
                              <select id="programSelect" v-model="selectedProgram" class="form-control">
                                <option>CCM</option>
                                <option>BHI</option>
                                <option>RPM</option>
                              </select>
                            </div>

                            <div class="text-end mt-4">
                              <b-button variant="success" @click="startAssessment">Complete Enrollment & Create Care Plan</b-button>
                            </div>
                          </div>
                        </div>
                        <!-- Start of Form Wizard inside Modal -->
                        <div v-if="assessmentStarted">
                        <form-wizard color="#556ee6">
                          <tab-content icon="mdi mdi-account-circle" title="Goals">
                            <div class="row">
                              <div class="col-12">
                                <p class="mb-4">
                                  To help manage your Diabetes, let's choose some personal health goals to focus on.
                                  Here are some common goals that diabetes patients strive for.
                                  Which ones are the most important to you?
                                </p>

                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal1" />
                                      <label class="form-check-label" for="goal1">
                                        Lower my HgbA1C
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal2" />
                                      <label class="form-check-label" for="goal2">
                                        Control my blood sugar
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal3" />
                                      <label class="form-check-label" for="goal3">
                                        Have fewer or no hypoglycemic episodes
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal4" />
                                      <label class="form-check-label" for="goal4">
                                        Be able to stop any more vision loss
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal5" />
                                      <label class="form-check-label" for="goal5">
                                        Other Diabetes goals
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal6" />
                                      <label class="form-check-label" for="goal6">
                                        Not applicable
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </tab-content>
                          <tab-content icon="mdi mdi-face-profile" title="Barrier">
                            <div class="row">
                              <div class="col-12">
                                <p class="mb-4">
                                  To help manage your Diabetes, let's choose some personal health goals to focus on.
                                  Here are some common goals that diabetes patients strive for.
                                  Which ones are the most important to you?
                                </p>

                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal1" />
                                      <label class="form-check-label" for="goal1">
                                        Lower my HgbA1C
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal2" />
                                      <label class="form-check-label" for="goal2">
                                        Control my blood sugar
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal3" />
                                      <label class="form-check-label" for="goal3">
                                        Have fewer or no hypoglycemic episodes
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal4" />
                                      <label class="form-check-label" for="goal4">
                                        Be able to stop any more vision loss
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal5" />
                                      <label class="form-check-label" for="goal5">
                                        Other Diabetes goals
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal6" />
                                      <label class="form-check-label" for="goal6">
                                        Not applicable
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </tab-content>

                          <tab-content icon="mdi mdi-face-profile" title="Symptom's">
                            <div class="row">
                              <div class="col-12">
                                <p class="mb-4">
                                  To help manage your Diabetes, let's choose some personal health goals to focus on.
                                  Here are some common goals that diabetes patients strive for.
                                  Which ones are the most important to you?
                                </p>

                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal1" />
                                      <label class="form-check-label" for="goal1">
                                        Lower my HgbA1C
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal2" />
                                      <label class="form-check-label" for="goal2">
                                        Control my blood sugar
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal3" />
                                      <label class="form-check-label" for="goal3">
                                        Have fewer or no hypoglycemic episodes
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal4" />
                                      <label class="form-check-label" for="goal4">
                                        Be able to stop any more vision loss
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal5" />
                                      <label class="form-check-label" for="goal5">
                                        Other Diabetes goals
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal6" />
                                      <label class="form-check-label" for="goal6">
                                        Not applicable
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </tab-content>
                          <tab-content icon="mdi mdi-face-profile" title="Intervention's">
                            <div class="row">
                              <div class="col-12">
                                <p class="mb-4">
                                  To help manage your Diabetes, let's choose some personal health goals to focus on.
                                  Here are some common goals that diabetes patients strive for.
                                  Which ones are the most important to you?
                                </p>

                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal1" />
                                      <label class="form-check-label" for="goal1">
                                        Lower my HgbA1C
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal2" />
                                      <label class="form-check-label" for="goal2">
                                        Control my blood sugar
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal3" />
                                      <label class="form-check-label" for="goal3">
                                        Have fewer or no hypoglycemic episodes
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal4" />
                                      <label class="form-check-label" for="goal4">
                                        Be able to stop any more vision loss
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal5" />
                                      <label class="form-check-label" for="goal5">
                                        Other Diabetes goals
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal6" />
                                      <label class="form-check-label" for="goal6">
                                        Not applicable
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </tab-content>
                          <tab-content icon="mdi mdi-face-profile" title="Allergies">
                            <div class="row">
                              <div class="col-12">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                  <h5 class="text-primary fw-bold mb-0">
                                    Let's list everything that you're allergic to.
                                  </h5>
                                  <button class="btn btn-success">New Allergy</button>
                                </div>
                                <!-- No known allergies checkbox -->
                                <div class="form-check mb-3">
                                  <input class="form-check-input" type="checkbox" id="noKnownAllergies" />
                                  <label class="form-check-label fw-bold" for="noKnownAllergies">
                                    Patient has no known Allergies
                                  </label>
                                </div>

                                <!-- Allergy table -->
                                <div class="table-responsive mb-3">
                                  <table class="table table-bordered">
                                    <thead class="table-light">
                                    <tr>
                                      <th>Allergy</th>
                                      <th>Category</th>
                                      <th>Reaction</th>
                                      <th>Active</th>
                                      <th>Critical</th>
                                      <th>Identified</th>
                                      <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                      <td>Penicillin</td>
                                      <td>medication</td>
                                      <td></td>
                                      <td>Yes</td>
                                      <td>No</td>
                                      <td></td>
                                      <td>
                                        <button class="btn btn-outline-secondary btn-sm me-1">Edit</button>
                                        <button class="btn btn-danger btn-sm">Remove</button>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <!-- Pagination -->
                                <nav>
                                  <ul class="pagination">
                                    <li class="page-item disabled"><a class="page-link">Previous</a></li>
                                    <li class="page-item active"><a class="page-link">1</a></li>
                                    <li class="page-item"><a class="page-link">Next</a></li>
                                  </ul>
                                </nav>

                                <!-- Not Applicable checkbox -->
                                <div class="form-check mt-3">
                                  <input class="form-check-input" type="checkbox" id="notApplicable" />
                                  <label class="form-check-label text-primary fw-bold" for="notApplicable">
                                    Not Applicable
                                  </label>
                                </div>
                              </div>
                            </div>
                          </tab-content>

                          <tab-content icon="mdi mdi-face-profile" title="Medication">
                            <div class="row">
                              <div class="col-12">
                                <p class="mb-4">
                                  To help manage your Diabetes, let's choose some personal health goals to focus on.
                                  Here are some common goals that diabetes patients strive for.
                                  Which ones are the most important to you?
                                </p>

                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal1" />
                                      <label class="form-check-label" for="goal1">
                                        Lower my HgbA1C
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal2" />
                                      <label class="form-check-label" for="goal2">
                                        Control my blood sugar
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal3" />
                                      <label class="form-check-label" for="goal3">
                                        Have fewer or no hypoglycemic episodes
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal4" />
                                      <label class="form-check-label" for="goal4">
                                        Be able to stop any more vision loss
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal5" />
                                      <label class="form-check-label" for="goal5">
                                        Other Diabetes goals
                                      </label>
                                    </div>

                                    <div class="form-check mb-2">
                                      <input class="form-check-input" type="checkbox" id="goal6" />
                                      <label class="form-check-label" for="goal6">
                                        Not applicable
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </tab-content>
                          <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                            <div class="row">
                              <div class="col-12">
                                <div class="text-center">
                                  <h2 class="mt-0">
                                    <i class="mdi mdi-check-all"></i>
                                  </h2>
                                  <h3 class="mt-0">Thank you!</h3>

                                  <p class="w-75 mb-2 mx-auto">
                                    Quisque nec turpis at urna dictum luctus. Suspendisse convallis dignissim eros at volutpat.
                                  </p>

                                  <div class="mb-3">
                                    <div class="custom-control custom-checkbox">
                                      <input id="customCheck1" type="checkbox" class="custom-control-input" />
                                      <label class="custom-control-label" for="customCheck1">
                                        I agree with the Terms and Conditions
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </tab-content>

                        </form-wizard>
                        </div>
                        <!-- End of Form Wizard inside Modal -->
                      </b-modal>

                    </div>
                  </div>
                  <div class="row">
                    <!-- Conditions Information Card -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 info-card info-card-primary shadow-hover">
                        <div class="card-header bg-gradient-primary text-white">
                          <div class="d-flex align-items-center">
                            <div class="info-card-icon">
                              <i class="fas fa-heartbeat"></i>
                            </div>
                            <h5 class="my-0 ml-2">Conditions Information</h5>
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="info-card-content">
                            <div class="mb-3">
                              <label class="text-muted small text-uppercase">CCM Conditions</label>
                              <div class="d-flex align-items-center mt-2">
                                <span class="badge-pill badge-soft-primary mr-2">1</span>
                                <span class="diabetes-text">
                                  <i class="fas fa-syringe mr-1"></i> Diabetes [E08.11]
                                </span>
                              </div>
                            </div>
                            <div class="mb-3">
                              <label class="text-muted small text-uppercase">Other Conditions</label>
                              <div class="d-flex align-items-center mt-2">
                                <span class="badge-pill badge-soft-secondary">0</span>
                              </div>
                            </div>
                            <a href="#" class="btn btn-sm btn-primary btn-animated btn-hover-shadow">
                              <i class="fas fa-list-ul mr-1"></i> View all conditions
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Enrollment Information Card -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 info-card info-card-success shadow-hover">
                        <div class="card-header bg-gradient-success text-white">
                          <div class="d-flex align-items-center">
                            <div class="info-card-icon">
                              <i class="fas fa-clipboard-check"></i>
                            </div>
                            <h5 class="my-0 ml-2">Enrollment Information</h5>
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="info-card-content">
                            <div class="mb-3">
                              <label class="text-muted small text-uppercase">Current Status</label>
                              <div class="d-flex align-items-center mt-2">
                                <span class="status-indicator active mr-2"></span>
                                <span class="status-text active">ACTIVE</span>
                              </div>
                            </div>
                            <div class="mb-3">
                              <label class="text-muted small text-uppercase">Enrollment Date</label>
                              <div class="d-flex align-items-center mt-2">
                                <i class="far fa-calendar-alt text-success mr-2"></i>
                                <span>06/22/2022</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Program Specifics Card -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 info-card info-card-info shadow-hover">
                        <div class="card-header bg-gradient-info text-white">
                          <div class="d-flex align-items-center">
                            <div class="info-card-icon">
                              <i class="fas fa-user-md"></i>
                            </div>
                            <h5 class="my-0 ml-2">Program Specifics</h5>
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="info-card-content">
                            <div class="mb-3">
                              <label class="text-muted small text-uppercase">Care Team</label>
                              <div class="d-flex align-items-center mt-2">
                                <div class="team-member">
                                  <i class="fas fa-user-nurse text-info mr-2"></i>
                                  <span><strong>Care Manager:</strong> Nidia Carrasco</span>
                                </div>
                              </div>
                              <div class="d-flex align-items-center mt-2">
                                <div class="team-member">
                                  <i class="fas fa-stethoscope text-info mr-2"></i>
                                  <span><strong>Provider:</strong> Dr. Liz Poe</span>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex justify-content-around">
                              <div class="program-stat">
                                <label class="text-muted small">Months in CCM</label>
                                <div class="stat-value">0</div>
                              </div>
                              <div class="program-stat">
                                <label class="text-muted small">Months > 20 min</label>
                                <div class="stat-value">0</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                    <b-tab active>
                      <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                        <span class="d-none d-sm-inline-block">Care Plan Review</span>
                      </template>
                      <div class="row">
                        <div class="col-md-12">
                          <b-card header-class="bg-gradient-primary text-white" class="border-0 shadow-lg care-plan-card mb-4">
                            <template v-slot:header>
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                  <div class="care-plan-icon">
                                    <i class="mdi mdi-bullseye-arrow"></i>
                                  </div>
                                  <h5 class="my-0 ml-2">
                                    Care Plan Review
                                  </h5>
                                </div>
                                <div class="d-flex header-buttons">
                                  <b-button
                                    variant="light"
                                    size="sm"
                                    class="mr-2 header-action-btn"
                                    @click="showReviewNoteModal = true"
                                  >
                                    <i class="fas fa-sticky-note mr-1"></i> Review Note
                                  </b-button>
                                  <b-button
                                    variant="light"
                                    size="sm"
                                    class="mr-2 header-action-btn"
                                    @click="showTreatmentTestModal = true"
                                  >
                                    <i class="fas fa-procedures mr-1"></i> Treatment / Test
                                  </b-button>
                                  <b-button
                                    variant="light"
                                    size="sm"
                                    class="header-action-btn"
                                    @click="showReferralModal = true"
                                  >
                                    <i class="fas fa-share-square mr-1"></i> Referral
                                  </b-button>
                                </div>
                              </div>
                            </template>
                            <div class="care-plan-info p-3">
                              <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="card-title mb-0 font-weight-bold">Patient Care Plan</h5>
                                <div class="care-plan-meta">
                                  <span class="badge badge-soft-primary mr-2"><i class="far fa-calendar-alt mr-1"></i> Started: 06/05/2025</span>
                                  <span class="badge badge-soft-info mr-2"><i class="far fa-clock mr-1"></i> Updated: 06/05/2025</span>
                                  <span class="badge badge-soft-success"><i class="far fa-user mr-1"></i> By: Dr. Liz</span>
                                </div>
                              </div>
                              <p class="card-text">
                                This patient Care Plan Summary reflects information from the latest Care Plan Assessment.
                                Access to the initial Care Plan is available on the Assessment Tab on Patient Record page.
                                Any changes to the information can be applied through an update to the assessment.
                                Goal's and barriers are automatically added to the Care Plan Progress Section and should be tracked individually in real time.
                              </p>
                            </div>
                          </b-card>
                          <div class="table-responsive care-plan-table-container">
                            <table class="table table-bordered table-hover shadow-sm care-plan-table">
                              <thead>
                              <tr>
                                <th style="width: 50%" class="th-patient">Patient Centered Care Plan</th>
                                <th style="width: 40%" class="th-updates">CCM Conditions Updates</th>
                                <th style="width: 10%" class="th-action">Action</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(row, index) in carePlanData" :key="index"
                                  :class="{'bg-soft-light': row.isEditing, 'care-plan-row': true}"
                                  :data-category="index === 0 ? 'goals' : index === 1 ? 'barriers' : index === 2 ? 'symptoms' : index === 3 ? 'allergies' : 'other'">
                                <td v-html="row.patientInfo" class="align-middle care-plan-info-cell"></td>
                                <td class="align-middle">
                                  <!-- Show individual input fields for all sections -->
                                  <div v-if="row.isEditing">
                                    <div class="form-group mb-0 edit-container">
                                      <div v-for="(goal, goalIndex) in editedGoals" :key="goalIndex" class="mb-2">
                                        <div class="input-group">
                                          <div class="input-group-prepend">
                                            <span class="input-group-text">•</span>
                                          </div>
                                          <input
                                            type="text"
                                            class="form-control animated-border"
                                            v-model="editedGoals[goalIndex]"
                                            placeholder=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else class="update-content care-plan-info-cell" v-html="row.ccmUpdate || '<div class=\'no-updates\'>No updates added <i class=\'ri-information-line ml-1\'></i></div>'"></div>
                                </td>
                                <td class="align-middle text-center">
                                  <!-- Show Save button when editing, otherwise show Update button -->
                                  <div v-if="row.isEditing" class="d-flex flex-column gap-2">
                                    <b-button
                                      variant="success"
                                      size="sm"
                                      class="mb-2 btn-animated"
                                      @click="saveEditing(index)"
                                    >
                                      <i class="ri-save-line align-middle mr-1"></i> Save
                                    </b-button>
                                    <b-button
                                      variant="outline-secondary"
                                      size="sm"
                                      class="btn-animated"
                                      @click="cancelEditing()"
                                    >
                                      <i class="ri-close-line align-middle mr-1"></i> Cancel
                                    </b-button>
                                  </div>
                                  <b-button
                                    v-else
                                    variant="primary"
                                    size="sm"
                                    @click="startEditing(index)"
                                    class="btn-hover-shadow btn-animated"
                                  >
                                    <i class="ri-edit-line align-middle mr-1"></i> Update
                                  </b-button>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </b-tab>

                    <b-tab>
                      <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-heartbeat"></i>
                  </span>
                        <span class="d-none d-sm-inline-block">Patient Vital</span>
                      </template>

                      <!-- Vital Signs Summary Cards -->
                      <div class="row mt-3">
                        <div class="col-md-3">
                          <div class="card vital-card vital-card-weight shadow-hover animate-vital">
                            <div class="card-body">
                              <div class="d-flex align-items-center mb-3">
                                <div class="vital-icon-container vital-icon-weight">
                                  <i class="ri-scales-3-line"></i>
                                </div>
                                <div class="ms-3">
                                  <h5 class="mb-0 font-weight-bold">Body Weight</h5>
                                  <p class="text-muted small mb-0">Last 30 days</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-baseline">
                                <h2 class="mb-0 font-weight-bold">{{ weightData[weightData.length - 1].value }} kg</h2>
                                <span class="ms-2 badge bg-soft-success text-success">
                                  <i class="ri-arrow-down-line"></i> 
                                  {{ (weightData[0].value - weightData[weightData.length - 1].value).toFixed(1) }} kg
                                </span>
                              </div>
                              <p class="text-muted small mb-0 mt-2">
                                <i class="ri-information-line"></i> 
                                Average: {{ averageWeight }} kg
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="card vital-card vital-card-bp shadow-hover animate-vital" style="animation-delay: 0.1s">
                            <div class="card-body">
                              <div class="d-flex align-items-center mb-3">
                                <div class="vital-icon-container vital-icon-bp">
                                  <i class="ri-heart-pulse-line"></i>
                                </div>
                                <div class="ms-3">
                                  <h5 class="mb-0 font-weight-bold">Blood Pressure</h5>
                                  <p class="text-muted small mb-0">Last 30 days</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-baseline">
                                <h2 class="mb-0 font-weight-bold">
                                  {{ bloodPressureData[bloodPressureData.length - 1].systolic }}/{{ bloodPressureData[bloodPressureData.length - 1].diastolic }}
                                </h2>
                                <span class="ms-2 badge bg-soft-success text-success">
                                  <i class="ri-arrow-down-line"></i> 
                                  {{ bloodPressureData[0].systolic - bloodPressureData[bloodPressureData.length - 1].systolic }}
                                </span>
                              </div>
                              <p class="text-muted small mb-0 mt-2">
                                <i class="ri-information-line"></i> 
                                Normal range: 120/80 mmHg
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="card vital-card vital-card-hr shadow-hover animate-vital" style="animation-delay: 0.2s">
                            <div class="card-body">
                              <div class="d-flex align-items-center mb-3">
                                <div class="vital-icon-container vital-icon-hr">
                                  <i class="ri-heart-2-line"></i>
                                </div>
                                <div class="ms-3">
                                  <h5 class="mb-0 font-weight-bold">Heart Rate</h5>
                                  <p class="text-muted small mb-0">Last 30 days</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-baseline">
                                <h2 class="mb-0 font-weight-bold">
                                  {{ heartRateData[heartRateData.length - 1].value }} <span class="fs-6">bpm</span>
                                </h2>
                                <span class="ms-2 badge bg-soft-success text-success">
                                  <i class="ri-arrow-down-line"></i> 
                                  {{ heartRateData[0].value - heartRateData[heartRateData.length - 1].value }}
                                </span>
                              </div>
                              <p class="text-muted small mb-0 mt-2">
                                <i class="ri-information-line"></i> 
                                Normal range: 60-100 bpm
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="card vital-card vital-card-glucose shadow-hover animate-vital" style="animation-delay: 0.3s">
                            <div class="card-body">
                              <div class="d-flex align-items-center mb-3">
                                <div class="vital-icon-container vital-icon-glucose">
                                  <i class="ri-test-tube-line"></i>
                                </div>
                                <div class="ms-3">
                                  <h5 class="mb-0 font-weight-bold">Blood Glucose</h5>
                                  <p class="text-muted small mb-0">Last 30 days</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-baseline">
                                <h2 class="mb-0 font-weight-bold">
                                  {{ glucoseData[glucoseData.length - 1].value }} <span class="fs-6">mg/dL</span>
                                </h2>
                                <span class="ms-2 badge bg-soft-success text-success">
                                  <i class="ri-arrow-down-line"></i> 
                                  {{ glucoseData[0].value - glucoseData[glucoseData.length - 1].value }}
                                </span>
                              </div>
                              <p class="text-muted small mb-0 mt-2">
                                <i class="ri-information-line"></i> 
                                Target: 70-130 mg/dL
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Weight Chart -->
                      <div class="card mt-4 shadow-hover animate-vital" style="animation-delay: 0.4s">
                        <div class="card-header d-flex justify-content-between align-items-center bg-light">
                          <div class="d-flex align-items-center">
                            <div class="vital-icon-container vital-icon-weight me-2">
                              <i class="ri-scales-3-line"></i>
                            </div>
                            <h5 class="mb-0 font-weight-bold">Body Weight</h5>
                          </div>
                          <div>
                            <button class="btn btn-sm btn-soft-primary me-2">
                              <i class="ri-calendar-line me-1"></i> Filter
                            </button>
                            <button class="btn btn-sm btn-soft-info">
                              <i class="ri-download-line me-1"></i> Export
                            </button>
                          </div>
                        </div>

                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="table-responsive vital-table">
                                <table class="table table-borderless table-hover">
                                  <thead class="table-light">
                                  <tr>
                                    <th>Date</th>
                                    <th>Value (kg)</th>
                                    <th>Change</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(entry, index) in weightData.slice().reverse()" :key="entry.date" class="vital-table-row">
                                    <td>{{ formatDate(entry.date) }}</td>
                                    <td class="font-weight-bold">{{ entry.value }}</td>
                                    <td>
                                      <span v-if="index < weightData.length - 1" 
                                            :class="entry.value < weightData.slice().reverse()[index + 1].value ? 'text-success' : 'text-danger'">
                                        <i :class="entry.value < weightData.slice().reverse()[index + 1].value ? 'ri-arrow-down-line' : 'ri-arrow-up-line'"></i>
                                        {{ Math.abs(entry.value - weightData.slice().reverse()[index + 1].value).toFixed(1) }}
                                      </span>
                                      <span v-else>-</span>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="mt-3 p-3 bg-light rounded">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                  <span class="text-muted">Average</span>
                                  <span class="font-weight-bold">{{ averageWeight }} kg</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                  <span class="text-muted">Minimum</span>
                                  <span class="font-weight-bold">{{ Math.min(...weightData.map(entry => entry.value)).toFixed(1) }} kg</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                  <span class="text-muted">Maximum</span>
                                  <span class="font-weight-bold">{{ Math.max(...weightData.map(entry => entry.value)).toFixed(1) }} kg</span>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-8">
                              <canvas ref="weightChart" height="300"></canvas>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Blood Pressure Chart -->
                      <div class="card mt-4 shadow-hover animate-vital" style="animation-delay: 0.5s">
                        <div class="card-header d-flex justify-content-between align-items-center bg-light">
                          <div class="d-flex align-items-center">
                            <div class="vital-icon-container vital-icon-bp me-2">
                              <i class="ri-heart-pulse-line"></i>
                            </div>
                            <h5 class="mb-0 font-weight-bold">Blood Pressure</h5>
                          </div>
                          <div>
                            <button class="btn btn-sm btn-soft-primary me-2">
                              <i class="ri-calendar-line me-1"></i> Filter
                            </button>
                            <button class="btn btn-sm btn-soft-info">
                              <i class="ri-download-line me-1"></i> Export
                            </button>
                          </div>
                        </div>

                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="table-responsive vital-table">
                                <table class="table table-borderless table-hover">
                                  <thead class="table-light">
                                  <tr>
                                    <th>Date</th>
                                    <th>Systolic</th>
                                    <th>Diastolic</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="entry in bloodPressureData.slice().reverse()" :key="entry.date" class="vital-table-row">
                                    <td>{{ formatDate(entry.date) }}</td>
                                    <td class="font-weight-bold">{{ entry.systolic }}</td>
                                    <td class="font-weight-bold">{{ entry.diastolic }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="mt-3 p-3 bg-light rounded">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                  <span class="text-muted">Latest Reading</span>
                                  <span class="font-weight-bold">{{ bloodPressureData[bloodPressureData.length - 1].systolic }}/{{ bloodPressureData[bloodPressureData.length - 1].diastolic }}</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                  <span class="text-muted">Status</span>
                                  <span class="badge bg-soft-success text-success px-2 py-1">Normal</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                  <span class="text-muted">Trend</span>
                                  <span class="text-success">
                                    <i class="ri-arrow-down-line"></i> Improving
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-8">
                              <canvas ref="bpChart" height="300"></canvas>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Heart Rate and Glucose Charts Row -->
                      <div class="row mt-4">
                        <div class="col-md-6">
                          <div class="card shadow-hover animate-vital" style="animation-delay: 0.6s">
                            <div class="card-header d-flex justify-content-between align-items-center bg-light">
                              <div class="d-flex align-items-center">
                                <div class="vital-icon-container vital-icon-hr me-2">
                                  <i class="ri-heart-2-line"></i>
                                </div>
                                <h5 class="mb-0 font-weight-bold">Heart Rate</h5>
                              </div>
                              <button class="btn btn-sm btn-soft-primary">
                                <i class="ri-more-2-fill"></i>
                              </button>
                            </div>

                            <div class="card-body">
                              <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                  <h3 class="mb-0">{{ heartRateData[heartRateData.length - 1].value }} <small>bpm</small></h3>
                                  <p class="text-muted mb-0">Latest Reading</p>
                                </div>
                                <div class="text-end">
                                  <span class="badge bg-soft-success text-success px-2 py-1">Normal</span>
                                  <p class="text-muted mb-0">Range: 60-100 bpm</p>
                                </div>
                              </div>
                              <canvas ref="hrChart" height="200"></canvas>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="card shadow-hover animate-vital" style="animation-delay: 0.7s">
                            <div class="card-header d-flex justify-content-between align-items-center bg-light">
                              <div class="d-flex align-items-center">
                                <div class="vital-icon-container vital-icon-glucose me-2">
                                  <i class="ri-test-tube-line"></i>
                                </div>
                                <h5 class="mb-0 font-weight-bold">Blood Glucose</h5>
                              </div>
                              <button class="btn btn-sm btn-soft-primary">
                                <i class="ri-more-2-fill"></i>
                              </button>
                            </div>

                            <div class="card-body">
                              <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                  <h3 class="mb-0">{{ glucoseData[glucoseData.length - 1].value }} <small>mg/dL</small></h3>
                                  <p class="text-muted mb-0">Latest Reading</p>
                                </div>
                                <div class="text-end">
                                  <span class="badge bg-soft-warning text-warning px-2 py-1">Monitor</span>
                                  <p class="text-muted mb-0">Target: 70-130 mg/dL</p>
                                </div>
                              </div>
                              <canvas ref="glucoseChart" height="200"></canvas>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
    <span class="d-inline-block d-sm-none">
      <i class="fas fa-history"></i>
    </span>
                        <span class="d-none d-sm-inline-block">Audit Logs</span>
                      </template>

                      <div class="audit-logs-container mt-3 animate-fade-in">
                        <!-- Header with filters and search -->
                        <div class="card mb-3 shadow-sm">
                          <div class="card-body">
                            <div class="row align-items-center">
                              <div class="col-md-6">
                                <h5 class="mb-md-0">
                                  <i class="ri-history-line me-2 text-primary"></i> System Activity Log
                                </h5>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex justify-content-md-end">
                                  <div class="search-box me-2">
                                    <div class="position-relative">
                                      <input type="text" class="form-control rounded" placeholder="Search logs...">
                                      <i class="ri-search-line search-icon"></i>
                                    </div>
                                  </div>
                                  <div class="btn-group">
                                    <button type="button" class="btn btn-soft-primary">
                                      <i class="ri-filter-3-line me-1"></i> Filter
                                    </button>
                                    <button type="button" class="btn btn-soft-info">
                                      <i class="ri-download-2-line me-1"></i> Export
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Filter chips -->
                        <div class="filter-chips mb-3">
                          <span class="badge rounded-pill bg-light text-dark me-2 mb-2 p-2">
                            <span>All Activities</span>
                            <i class="ri-close-line ms-1"></i>
                          </span>
                          <span class="badge rounded-pill bg-light text-dark me-2 mb-2 p-2">
                            <span>Last 7 Days</span>
                            <i class="ri-close-line ms-1"></i>
                          </span>
                          <span class="badge rounded-pill bg-light text-dark me-2 mb-2 p-2">
                            <span>All Users</span>
                            <i class="ri-close-line ms-1"></i>
                          </span>
                        </div>

                        <!-- Logs table -->
                        <div class="card shadow-sm">
                          <div class="card-body p-0">
                            <div class="table-responsive audit-table">
                              <b-table 
                                :items="auditLogs" 
                                :fields="logFields" 
                                hover 
                                responsive
                                class="mb-0 audit-logs-table"
                                show-empty
                                empty-text="No audit logs found"
                                sort-by="timestamp"
                                sort-desc
                              >
                                <!-- Timestamp column -->
                                <template #cell(timestamp)="data">
                                  <div class="d-flex align-items-center">
                                    <div class="audit-time-icon me-2">
                                      <i class="ri-time-line"></i>
                                    </div>
                                    <div>
                                      <div class="fw-medium">{{ new Date(data.value).toLocaleDateString() }}</div>
                                      <small class="text-muted">{{ new Date(data.value).toLocaleTimeString() }}</small>
                                    </div>
                                  </div>
                                </template>

                                <!-- Username column -->
                                <template #cell(username)="data">
                                  <div class="d-flex align-items-center">
                                    <div class="audit-user-avatar me-2">
                                      {{ data.value.charAt(0).toUpperCase() }}
                                    </div>
                                    <span class="fw-medium">{{ data.value }}</span>
                                  </div>
                                </template>

                                <!-- Change column -->
                                <template #cell(change)="data">
                                  <div class="audit-activity">{{ data.value }}</div>
                                </template>

                                <!-- Action column -->
                                <template #cell(action)="data">
                                  <span :class="[
                                    'badge rounded-pill px-2 py-1',
                                    data.value === 'add' ? 'bg-soft-success text-success' : 
                                    data.value === 'update' ? 'bg-soft-primary text-primary' : 
                                    data.value === 'delete' ? 'bg-soft-danger text-danger' : 
                                    'bg-soft-info text-info'
                                  ]">
                                    <i :class="[
                                      data.value === 'add' ? 'ri-add-line' : 
                                      data.value === 'update' ? 'ri-edit-line' : 
                                      data.value === 'delete' ? 'ri-delete-bin-line' : 
                                      'ri-information-line'
                                    ]"></i>
                                    {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }}
                                  </span>
                                </template>

                                <!-- Status column -->
                                <template #cell(status)="data">
                                  <span :class="[
                                    'badge rounded-pill px-2 py-1',
                                    data.value === 'success' ? 'bg-soft-success text-success' : 
                                    data.value === 'warning' ? 'bg-soft-warning text-warning' : 
                                    data.value === 'error' ? 'bg-soft-danger text-danger' : 
                                    'bg-soft-info text-info'
                                  ]">
                                    {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }}
                                  </span>
                                </template>

                                <!-- Details column -->
                                <template #cell(details)="data">
                                  <span class="text-muted">{{ data.value }}</span>
                                </template>

                                <!-- Actions column -->
                                <template #cell(actions)="data">
                                  <div class="d-flex">
                                    <button class="btn btn-sm btn-soft-primary me-1" title="View Details" @click="viewLogDetails(data.item)">
                                      <i class="ri-eye-line"></i>
                                    </button>
                                    <button class="btn btn-sm btn-soft-info" title="Export" @click="exportLogEntry(data.item)">
                                      <i class="ri-download-line"></i>
                                    </button>
                                  </div>
                                </template>
                              </b-table>
                            </div>
                          </div>
                          <div class="card-footer bg-light">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <span class="text-muted">Showing 1 to {{ auditLogs.length }} of {{ auditLogs.length }} entries</span>
                              </div>
                              <div>
                                <b-pagination
                                  v-model="currentPage"
                                  :total-rows="auditLogs.length"
                                  :per-page="10"
                                  aria-controls="audit-logs-table"
                                  class="mb-0"
                                ></b-pagination>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
    <span class="d-inline-block d-sm-none">
      <i class="fas fa-cog"></i>
    </span>
                        <span class="d-none d-sm-inline-block">Notes</span>
                      </template>
                      <div class="d-flex justify-content-between align-items-center mb-4">
                        <h5 class="mb-0">Patient Notes</h5>
                        <b-button variant="primary" @click="showCreateNoteModal = true">
                          <i class="ri-add-line align-middle mr-1"></i> Create Note
                        </b-button>
                      </div>

                      <div class="patient-notes-list">
                        <div 
                          v-for="(note, index) in patientNotes" 
                          :key="note.id" 
                          :class="['patient-note-card mb-4 shadow-hover animate-note', 
                                  index % 3 === 0 ? 'note-card-primary' : 
                                  index % 3 === 1 ? 'note-card-success' : 'note-card-info']"
                          :style="{ animationDelay: index * 0.1 + 's' }"
                        >
                          <div class="note-card-header">
                            <div class="d-flex align-items-center">
                              <div class="note-icon-container" :class="[
                                index % 3 === 0 ? 'note-icon-primary' : 
                                index % 3 === 1 ? 'note-icon-success' : 'note-icon-info'
                              ]">
                                <i :class="[
                                  index % 3 === 0 ? 'ri-file-text-line' : 
                                  index % 3 === 1 ? 'ri-heart-pulse-line' : 'ri-medicine-bottle-line'
                                ]"></i>
                              </div>
                              <div>
                                <h6 class="mb-1 font-weight-bold">{{ note.doctor }}</h6>
                                <p class="text-muted small mb-0">
                                  <i class="ri-hospital-line mr-1"></i>{{ note.hospital }}
                                </p>
                              </div>
                            </div>
                            <div class="text-right">
                              <span class="badge badge-soft-primary px-3 py-2 rounded-pill">
                                <i class="ri-calendar-line mr-1"></i>{{ new Date(note.date).toLocaleDateString() }}
                              </span>
                            </div>
                          </div>
                          <div class="note-card-body">
                            <p class="mb-0">{{ note.content }}</p>
                          </div>
                          <div class="note-card-footer">
                            <button class="btn btn-sm btn-soft-primary mr-2">
                              <i class="ri-eye-line mr-1"></i> View
                            </button>
                            <button class="btn btn-sm btn-soft-info">
                              <i class="ri-printer-line mr-1"></i> Print
                            </button>
                          </div>
                        </div>

                        <div v-if="patientNotes.length === 0" class="text-center py-4">
                          <div class="empty-notes-container">
                            <i class="ri-file-list-3-line empty-notes-icon"></i>
                            <p class="text-muted mb-0">No notes available</p>
                          </div>
                        </div>
                      </div>
                    </b-tab>

                    <!-- Other Notes Tab -->
                    <b-tab title="Other Notes">
                      <b-form-group label="User and Date">
                        <b-input-group>
                          <b-form-input v-model="userName" placeholder="Name"></b-form-input>
                          <b-form-datepicker v-model="noteDate" class="ml-2"></b-form-datepicker>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group label="Other notes to appear on this month's Care Plan">
                        <b-form-textarea v-model="notes.other" rows="3" />
                      </b-form-group>

                      <b-form-group label="Appointment Notes">
                        <b-form-textarea v-model="notes.appointment" rows="3" />
                      </b-form-group>

                    </b-tab>
                  </b-tabs>
                </div>

                  <div v-if="tab.name === 'Treatment'" class="treatment-tab">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <h4 class="mb-0 font-size-18">Patient Treatments</h4>
                      <button class="btn btn-primary" @click="openTreatmentModal">
                        <i class="fas fa-plus-circle mr-1"></i> Create Treatment
                      </button>
                    </div>

                    <!-- Treatment List -->
                    <div class="treatment-list">
                      <div v-if="treatments.length === 0" class="text-center py-5">
                        <div class="empty-treatments-container">
                          <i class="fas fa-procedures empty-treatments-icon mb-3" style="font-size: 3rem; color: #74788d;"></i>
                          <p class="text-muted mb-0">No treatments available</p>
                        </div>
                      </div>

                      <div v-else>
                        <div class="row">
                          <div v-for="treatment in paginatedTreatments" :key="treatment.id" class="col-lg-6 col-xl-6 mb-4">
                            <div class="card treatment-card h-100">
                              <div class="card-body">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                  <h5 class="card-title mb-0">
                                    <i :class="getTreatmentTypeIcon(treatment.type)" class="mr-2"></i>
                                    {{ treatment.name }}
                                  </h5>
                                  <span :class="['badge rounded-pill px-3 py-2', getTreatmentTypeClass(treatment.type)]">
                                    {{ treatment.type === 'surgical' ? 'Surgical' : 'Non-Surgical' }}
                                  </span>
                                </div>

                                <div class="treatment-details mb-3">
                                  <div class="row mb-2">
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Date:</strong></p>
                                      <p class="text-muted">{{ formatTreatmentDate(treatment.date) }}</p>
                                    </div>
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Provider:</strong></p>
                                      <p class="text-muted">{{ treatment.provider }}</p>
                                    </div>
                                  </div>

                                  <p class="mb-1"><strong>Description:</strong></p>
                                  <p class="text-muted mb-3">{{ treatment.description }}</p>

                                  <!-- Surgical Details -->
                                  <div v-if="treatment.type === 'surgical'" class="surgical-details">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Procedure:</strong></p>
                                        <div v-if="Array.isArray(treatment.surgicalDetails.procedure)">
                                          <p v-if="treatment.surgicalDetails.procedure.length === 0" class="text-muted">Not specified</p>
                                          <ul v-else class="list-unstyled mb-0">
                                            <li v-for="(proc, index) in treatment.surgicalDetails.procedure" :key="'procedure-' + index">
                                              <span class="procedure-item">{{ proc }}</span>
                                            </li>
                                          </ul>
                                        </div>
                                        <p v-else class="text-muted">{{ treatment.surgicalDetails.procedure || 'Not specified' }}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Location:</strong></p>
                                        <p class="text-muted">{{ treatment.surgicalDetails.location }}</p>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Anesthesia:</strong></p>
                                        <p class="text-muted">{{ treatment.surgicalDetails.anesthesia }}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Duration:</strong></p>
                                        <p class="text-muted">{{ treatment.surgicalDetails.duration }}</p>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Surgeon:</strong></p>
                                        <p class="text-muted">{{ treatment.surgicalDetails.surgeon }}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Complications:</strong></p>
                                        <p class="text-muted">{{ treatment.surgicalDetails.complications || 'None' }}</p>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Non-Surgical Details -->
                                  <div v-else class="non-surgical-details">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Treatment Type:</strong></p>
                                        <p class="text-muted">{{ treatment.nonSurgicalDetails.treatmentType }}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Frequency:</strong></p>
                                        <p class="text-muted">{{ treatment.nonSurgicalDetails.frequency }}</p>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Duration:</strong></p>
                                        <p class="text-muted">{{ treatment.nonSurgicalDetails.duration }}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Dosage:</strong></p>
                                        <p class="text-muted">{{ treatment.nonSurgicalDetails.dosage }}</p>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Medication:</strong></p>
                                        <p class="text-muted">{{ treatment.nonSurgicalDetails.medicationName !== 'N/A' ? treatment.nonSurgicalDetails.medicationName : 'None' }}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="mb-1"><strong>Route:</strong></p>
                                        <p class="text-muted">{{ treatment.nonSurgicalDetails.route }}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="treatment-actions">
                                  <button class="btn btn-sm btn-soft-primary mr-2 action-btn">
                                    <i class="ri-eye-line mr-1"></i> View Details
                                  </button>
                                  <button class="btn btn-sm btn-soft-info mr-2 action-btn">
                                    <i class="ri-printer-line mr-1"></i> Print
                                  </button>
                                  <button class="btn btn-sm btn-soft-success action-btn">
                                    <i class="ri-file-list-3-line mr-1"></i> Report
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Pagination -->
                        <div class="pagination-container mt-4">
                          <div class="pagination-info">
                            <span class="text-muted">
                              <i class="ri-information-line mr-1"></i>
                              Showing {{ (treatmentCurrentPage - 1) * treatmentPerPage + 1 }} to 
                              {{ Math.min(treatmentCurrentPage * treatmentPerPage, treatments.length) }} of {{ treatments.length }} treatments
                            </span>
                          </div>
                          <div class="pagination-controls">
                            <b-pagination
                              v-model="treatmentCurrentPage"
                              :total-rows="treatments.length"
                              :per-page="treatmentPerPage"
                              aria-controls="treatment-list"
                              class="mb-0 custom-pagination"
                              pills
                              size="md"
                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="tab.name === 'Transitions'" class="transitions-tab">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <h4 class="mb-0 font-size-18">Care Transitions</h4>
                      <button class="btn btn-primary" @click="openTransitionModal">
                        <i class="fas fa-plus-circle mr-1"></i> Add Transition
                      </button>
                    </div>

                    <!-- Transitions List -->
                    <div class="transitions-list">
                      <div v-if="transitions.length === 0" class="text-center py-5">
                        <div class="empty-transitions-container">
                          <i class="fas fa-exchange-alt empty-transitions-icon mb-3" style="font-size: 3rem; color: #74788d;"></i>
                          <p class="text-muted mb-0">No care transitions recorded</p>
                        </div>
                      </div>

                      <div v-else>
                        <div class="row">
                          <div v-for="transition in transitions" :key="transition.id" class="col-lg-6 col-xl-6 mb-4">
                            <div class="card transition-card h-100">
                              <div class="card-body">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                  <h5 class="card-title mb-0">
                                    <i :class="getTransitionTypeIcon(transition.type)" class="mr-2"></i>
                                    {{ transition.name }}
                                  </h5>
                                  <span :class="['badge rounded-pill px-3 py-2', getTransitionStatusClass(transition.status)]">
                                    {{ transition.status }}
                                  </span>
                                </div>

                                <div class="transition-details mb-3">
                                  <div class="row mb-2">
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Date:</strong></p>
                                      <p class="text-muted">{{ transition.date }}</p>
                                    </div>
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>From:</strong></p>
                                      <p class="text-muted">{{ transition.from }}</p>
                                    </div>
                                  </div>

                                  <div class="row mb-2">
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>To:</strong></p>
                                      <p class="text-muted">{{ transition.to }}</p>
                                    </div>
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Coordinator:</strong></p>
                                      <p class="text-muted">{{ transition.coordinator }}</p>
                                    </div>
                                  </div>

                                  <p class="mb-1"><strong>Reason:</strong></p>
                                  <p class="text-muted mb-3">{{ transition.reason }}</p>

                                  <!-- Transition Documents -->
                                  <div class="transition-documents mt-3">
                                    <h6 class="section-header mb-3">
                                      <i class="fas fa-file-medical mr-2"></i>
                                      Transition Documents
                                    </h6>
                                    <div class="document-list">
                                      <div v-if="transition.documents.length === 0" class="text-center py-2">
                                        <p class="text-muted mb-0">No documents available</p>
                                      </div>
                                      <div v-else class="row">
                                        <div v-for="(doc, index) in transition.documents" :key="index" class="col-md-6 mb-2">
                                          <div class="document-item p-2 rounded d-flex align-items-center">
                                            <i class="fas fa-file-pdf mr-2" style="color: #f46a6a;"></i>
                                            <span class="document-name">{{ doc.name }}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Care Team -->
                                  <div class="care-team mt-3">
                                    <h6 class="section-header mb-3">
                                      <i class="fas fa-user-friends mr-2"></i>
                                      Care Team
                                    </h6>
                                    <div class="team-list">
                                      <div v-if="transition.careTeam.length === 0" class="text-center py-2">
                                        <p class="text-muted mb-0">No care team members assigned</p>
                                      </div>
                                      <div v-else>
                                        <div v-for="(member, index) in transition.careTeam" :key="index" class="team-member mb-2 p-2 rounded d-flex align-items-center">
                                          <div class="member-avatar mr-2">
                                            <i class="fas fa-user-md" style="color: #556ee6;"></i>
                                          </div>
                                          <div class="member-info">
                                            <p class="mb-0 font-weight-medium">{{ member.name }}</p>
                                            <p class="mb-0 text-muted small">{{ member.role }}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="card-actions mt-3 pt-3 border-top">
                                  <button class="btn btn-sm btn-outline-primary mr-2">
                                    <i class="fas fa-edit mr-1"></i> Edit
                                  </button>
                                  <button class="btn btn-sm btn-outline-info mr-2">
                                    <i class="fas fa-file-download mr-1"></i> Documents
                                  </button>
                                  <button class="btn btn-sm btn-outline-success">
                                    <i class="fas fa-check-circle mr-1"></i> Complete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="tab.name === 'Wellness'" class="wellness-tab">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <h4 class="mb-0 font-size-18">Wellness & Lifestyle</h4>
                      <div>
                        <button class="btn btn-outline-primary mr-2">
                          <i class="fas fa-file-export mr-1"></i> Export Data
                        </button>
                        <button class="btn btn-primary" @click="showWellnessEntryModal = true">
                          <i class="fas fa-plus-circle mr-1"></i> Add Entry
                        </button>
                      </div>
                    </div>

                    <!-- Wellness Dashboard -->
                    <div class="row mb-4">
                      <!-- Wellness Score Card -->
                      <div class="col-xl-3 col-md-6 mb-4">
                        <div class="card wellness-score-card h-100">
                          <div class="card-body text-center">
                            <h5 class="card-title text-muted mb-3">Overall Wellness Score</h5>
                            <div class="wellness-score-circle mb-3">
                              <div class="score-value">78</div>
                            </div>
                            <div class="score-label text-success">
                              <i class="fas fa-arrow-up mr-1"></i> 5% from last month
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Activity Card -->
                      <div class="col-xl-3 col-md-6 mb-4">
                        <div class="card activity-card h-100">
                          <div class="card-body">
                            <h5 class="card-title text-muted mb-3">
                              <i class="fas fa-walking mr-2" style="color: #34c38f;"></i>
                              Physical Activity
                            </h5>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h2 class="mb-0">6,540</h2>
                              <span class="badge badge-soft-success px-2">
                                <i class="fas fa-arrow-up mr-1"></i> 12%
                              </span>
                            </div>
                            <p class="text-muted mb-0">Daily steps (avg)</p>
                            <div class="progress mt-3" style="height: 6px;">
                              <div class="progress-bar bg-success" role="progressbar" style="width: 65%;" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="d-flex justify-content-between mt-1">
                              <small class="text-muted">Goal: 10,000</small>
                              <small class="text-muted">65% complete</small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Sleep Card -->
                      <div class="col-xl-3 col-md-6 mb-4">
                        <div class="card sleep-card h-100">
                          <div class="card-body">
                            <h5 class="card-title text-muted mb-3">
                              <i class="fas fa-moon mr-2" style="color: #556ee6;"></i>
                              Sleep Quality
                            </h5>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h2 class="mb-0">7.2</h2>
                              <span class="badge badge-soft-danger px-2">
                                <i class="fas fa-arrow-down mr-1"></i> 3%
                              </span>
                            </div>
                            <p class="text-muted mb-0">Hours per night (avg)</p>
                            <div class="progress mt-3" style="height: 6px;">
                              <div class="progress-bar bg-primary" role="progressbar" style="width: 80%;" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="d-flex justify-content-between mt-1">
                              <small class="text-muted">Goal: 8 hours</small>
                              <small class="text-muted">80% of goal</small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Nutrition Card -->
                      <div class="col-xl-3 col-md-6 mb-4">
                        <div class="card nutrition-card h-100">
                          <div class="card-body">
                            <h5 class="card-title text-muted mb-3">
                              <i class="fas fa-apple-alt mr-2" style="color: #f1b44c;"></i>
                              Nutrition
                            </h5>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h2 class="mb-0">B+</h2>
                              <span class="badge badge-soft-success px-2">
                                <i class="fas fa-arrow-up mr-1"></i> 1 grade
                              </span>
                            </div>
                            <p class="text-muted mb-0">Diet quality score</p>
                            <div class="nutrition-bars mt-3 d-flex justify-content-between">
                              <div class="nutrition-bar text-center">
                                <div class="progress-vertical">
                                  <div class="progress-bar bg-success" role="progressbar" style="height: 70%;" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <small class="text-muted">Veg</small>
                              </div>
                              <div class="nutrition-bar text-center">
                                <div class="progress-vertical">
                                  <div class="progress-bar bg-warning" role="progressbar" style="height: 45%;" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <small class="text-muted">Prot</small>
                              </div>
                              <div class="nutrition-bar text-center">
                                <div class="progress-vertical">
                                  <div class="progress-bar bg-info" role="progressbar" style="height: 60%;" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <small class="text-muted">Carb</small>
                              </div>
                              <div class="nutrition-bar text-center">
                                <div class="progress-vertical">
                                  <div class="progress-bar bg-danger" role="progressbar" style="height: 30%;" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <small class="text-muted">Fat</small>
                              </div>
                              <div class="nutrition-bar text-center">
                                <div class="progress-vertical">
                                  <div class="progress-bar bg-primary" role="progressbar" style="height: 80%;" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <small class="text-muted">H2O</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Wellness Tabs -->
                    <div class="card">
                      <div class="card-body">
                        <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#wellness-activity" role="tab">
                              <i class="fas fa-running mr-1"></i> Activity
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#wellness-nutrition" role="tab">
                              <i class="fas fa-utensils mr-1"></i> Nutrition
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#wellness-sleep" role="tab">
                              <i class="fas fa-bed mr-1"></i> Sleep
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#wellness-stress" role="tab">
                              <i class="fas fa-brain mr-1"></i> Stress & Mindfulness
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#wellness-goals" role="tab">
                              <i class="fas fa-bullseye mr-1"></i> Goals
                            </a>
                          </li>
                        </ul>

                        <div class="tab-content p-3">
                          <!-- Activity Tab -->
                          <div class="tab-pane active" id="wellness-activity" role="tabpanel">
                            <div class="row">
                              <div class="col-lg-8">
                                <h5 class="font-size-15 mb-4">Activity Trends</h5>
                                <div class="activity-chart-placeholder" style="height: 300px; background-color: #f8f9fa; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
                                  <p class="text-muted mb-0">Activity chart will be displayed here</p>
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <h5 class="font-size-15 mb-4">Recent Activities</h5>
                                <div class="activity-timeline">
                                  <div class="activity-item">
                                    <div class="activity-dot bg-primary"></div>
                                    <div class="activity-content">
                                      <h6 class="font-size-14 mb-1">Morning Walk</h6>
                                      <p class="text-muted mb-1">3,200 steps • 25 mins</p>
                                      <small class="text-muted">Today, 7:30 AM</small>
                                    </div>
                                  </div>
                                  <div class="activity-item">
                                    <div class="activity-dot bg-success"></div>
                                    <div class="activity-content">
                                      <h6 class="font-size-14 mb-1">Yoga Session</h6>
                                      <p class="text-muted mb-1">Flexibility • 45 mins</p>
                                      <small class="text-muted">Yesterday, 6:00 PM</small>
                                    </div>
                                  </div>
                                  <div class="activity-item">
                                    <div class="activity-dot bg-warning"></div>
                                    <div class="activity-content">
                                      <h6 class="font-size-14 mb-1">Cycling</h6>
                                      <p class="text-muted mb-1">5.2 miles • 32 mins</p>
                                      <small class="text-muted">Yesterday, 10:30 AM</small>
                                    </div>
                                  </div>
                                  <div class="activity-item">
                                    <div class="activity-dot bg-info"></div>
                                    <div class="activity-content">
                                      <h6 class="font-size-14 mb-1">Swimming</h6>
                                      <p class="text-muted mb-1">20 laps • 40 mins</p>
                                      <small class="text-muted">May 20, 5:30 PM</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Other tabs content would go here -->
                          <div class="tab-pane" id="wellness-nutrition" role="tabpanel">
                            <p class="mb-0">Nutrition content will be displayed here</p>
                          </div>
                          <div class="tab-pane" id="wellness-sleep" role="tabpanel">
                            <p class="mb-0">Sleep content will be displayed here</p>
                          </div>
                          <div class="tab-pane" id="wellness-stress" role="tabpanel">
                            <p class="mb-0">Stress & Mindfulness content will be displayed here</p>
                          </div>
                          <div class="tab-pane" id="wellness-goals" role="tabpanel">
                            <p class="mb-0">Goals content will be displayed here</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="tab.name === 'Clinical Data'">
                    <div class="d-flex align-items-center mb-4 justify-content-between">
                      <div class="d-flex align-items-center">
                        <i :class="tab.icon" :style="{ color: tab.color }" class="mr-2 font-size-24"></i>
                        <h4 class="mb-0">{{ tab.name }}</h4>
                        <span class="badge badge-soft-secondary ml-2">{{ tab.description }}</span>
                      </div>
                    </div>

                    <div class="row">
                      <!-- Lab Results Card -->
                      <div class="col-lg-6">
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom d-flex align-items-center">
                            <h5 class="card-title mb-0"><i class="fas fa-flask mr-2 text-primary"></i> Lab Results</h5>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                  <i class="mdi mdi-dots-horizontal"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-end">
                                  <a class="dropdown-item" href="javascript: void(0);">View All</a>
                                  <a class="dropdown-item" href="javascript: void(0);">Export</a>
                                  <a class="dropdown-item" href="javascript: void(0);">Print</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover mb-0">
                                <thead>
                                  <tr>
                                    <th scope="col">Test Name</th>
                                    <th scope="col">Result</th>
                                    <th scope="col">Reference Range</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Hemoglobin A1C</td>
                                    <td><span class="font-weight-bold text-danger">7.2%</span></td>
                                    <td>4.0 - 5.6%</td>
                                    <td>May 15, 2023</td>
                                    <td><span class="badge bg-soft-danger text-danger">High</span></td>
                                  </tr>
                                  <tr>
                                    <td>Blood Glucose</td>
                                    <td><span class="font-weight-bold text-danger">142 mg/dL</span></td>
                                    <td>70 - 99 mg/dL</td>
                                    <td>May 15, 2023</td>
                                    <td><span class="badge bg-soft-danger text-danger">High</span></td>
                                  </tr>
                                  <tr>
                                    <td>Total Cholesterol</td>
                                    <td><span class="font-weight-bold text-warning">210 mg/dL</span></td>
                                    <td>&lt; 200 mg/dL</td>
                                    <td>May 15, 2023</td>
                                    <td><span class="badge bg-soft-warning text-warning">Borderline</span></td>
                                  </tr>
                                  <tr>
                                    <td>HDL Cholesterol</td>
                                    <td><span class="font-weight-bold">45 mg/dL</span></td>
                                    <td>> 40 mg/dL</td>
                                    <td>May 15, 2023</td>
                                    <td><span class="badge bg-soft-success text-success">Normal</span></td>
                                  </tr>
                                  <tr>
                                    <td>LDL Cholesterol</td>
                                    <td><span class="font-weight-bold text-warning">130 mg/dL</span></td>
                                    <td>&lt; 100 mg/dL</td>
                                    <td>May 15, 2023</td>
                                    <td><span class="badge bg-soft-warning text-warning">Borderline</span></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Vital Trends Card -->
                      <div class="col-lg-6">
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom d-flex align-items-center">
                            <h5 class="card-title mb-0"><i class="fas fa-chart-line mr-2 text-success"></i> Vital Trends</h5>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                  <i class="mdi mdi-dots-horizontal"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-end">
                                  <a class="dropdown-item" href="javascript: void(0);">Last 30 Days</a>
                                  <a class="dropdown-item" href="javascript: void(0);">Last 6 Months</a>
                                  <a class="dropdown-item" href="javascript: void(0);">Last Year</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="row mb-4">
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <div class="flex-shrink-0">
                                    <div class="avatar-xs">
                                      <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                        <i class="fas fa-heartbeat"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-grow-1 ms-3">
                                    <h5 class="font-size-15 mb-0">Blood Pressure</h5>
                                    <p class="text-muted mb-0">Latest: 138/85 mmHg</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <div class="flex-shrink-0">
                                    <div class="avatar-xs">
                                      <div class="avatar-title rounded-circle bg-soft-warning text-warning">
                                        <i class="fas fa-weight"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-grow-1 ms-3">
                                    <h5 class="font-size-15 mb-0">Weight</h5>
                                    <p class="text-muted mb-0">Latest: 82 kg</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="chart-container" style="height: 250px; position: relative;">
                              <div class="text-center py-5">
                                <i class="fas fa-chart-area fa-3x text-muted mb-3"></i>
                                <p class="text-muted">Interactive charts showing vital trends over time would appear here</p>
                                <p class="text-muted">Data includes Blood Pressure, Heart Rate, Weight, and Blood Glucose</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <!-- Imaging Results -->
                      <div class="col-lg-6">
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom">
                            <h5 class="card-title mb-0"><i class="fas fa-x-ray mr-2 text-info"></i> Imaging Results</h5>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-6 mb-3">
                                <div class="card border">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-info text-info">
                                          <i class="fas fa-lungs"></i>
                                        </span>
                                      </div>
                                      <h5 class="font-size-14 mb-0">Chest X-Ray</h5>
                                    </div>
                                    <p class="text-muted mb-0 font-size-13">Date: April 10, 2023</p>
                                    <p class="text-muted mb-0 font-size-13">Finding: Normal cardiac silhouette</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 mb-3">
                                <div class="card border">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-info text-info">
                                          <i class="fas fa-brain"></i>
                                        </span>
                                      </div>
                                      <h5 class="font-size-14 mb-0">Brain MRI</h5>
                                    </div>
                                    <p class="text-muted mb-0 font-size-13">Date: March 5, 2023</p>
                                    <p class="text-muted mb-0 font-size-13">Finding: No acute intracranial abnormality</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 mb-3">
                                <div class="card border">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-info text-info">
                                          <i class="fas fa-bone"></i>
                                        </span>
                                      </div>
                                      <h5 class="font-size-14 mb-0">Bone Density</h5>
                                    </div>
                                    <p class="text-muted mb-0 font-size-13">Date: January 15, 2023</p>
                                    <p class="text-muted mb-0 font-size-13">Finding: Mild osteopenia</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 mb-3">
                                <div class="card border">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-info text-info">
                                          <i class="fas fa-heart"></i>
                                        </span>
                                      </div>
                                      <h5 class="font-size-14 mb-0">Echocardiogram</h5>
                                    </div>
                                    <p class="text-muted mb-0 font-size-13">Date: February 20, 2023</p>
                                    <p class="text-muted mb-0 font-size-13">Finding: Normal left ventricular function</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Clinical Notes -->
                      <div class="col-lg-6">
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom">
                            <h5 class="card-title mb-0"><i class="fas fa-notes-medical mr-2 text-danger"></i> Clinical Notes</h5>
                          </div>
                          <div class="card-body">
                            <div class="clinical-note mb-3 p-3 border rounded">
                              <div class="d-flex align-items-center mb-2">
                                <h6 class="mb-0">Primary Care Visit</h6>
                                <span class="badge bg-soft-primary text-primary ml-2">Recent</span>
                                <small class="text-muted ml-auto">May 15, 2023</small>
                              </div>
                              <p class="mb-0 text-muted">Patient presents for routine diabetes follow-up. A1C remains elevated at 7.2%. Discussed importance of diet and exercise. Adjusted medication regimen. Will follow up in 3 months.</p>
                            </div>
                            <div class="clinical-note mb-3 p-3 border rounded">
                              <div class="d-flex align-items-center mb-2">
                                <h6 class="mb-0">Endocrinology Consult</h6>
                                <small class="text-muted ml-auto">March 10, 2023</small>
                              </div>
                              <p class="mb-0 text-muted">Comprehensive diabetes evaluation. Patient reports occasional hypoglycemic episodes. Recommended CGM. Adjusted insulin dosing schedule. Continue current oral medications.</p>
                            </div>
                            <div class="clinical-note mb-3 p-3 border rounded">
                              <div class="d-flex align-items-center mb-2">
                                <h6 class="mb-0">Cardiology Follow-up</h6>
                                <small class="text-muted ml-auto">February 5, 2023</small>
                              </div>
                              <p class="mb-0 text-muted">Routine follow-up for hypertension. BP well-controlled on current regimen. ECG shows normal sinus rhythm. Continue current medications and lifestyle modifications.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="tab.name === 'Documents'">
                    <div class="d-flex align-items-center mb-4 justify-content-between">
                      <div class="d-flex align-items-center">
                        <i :class="tab.icon" :style="{ color: tab.color }" class="mr-2 font-size-24"></i>
                        <h4 class="mb-0">{{ tab.name }}</h4>
                        <span class="badge badge-soft-purple ml-2">{{ tab.description }}</span>
                      </div>
                      <div>
                        <button class="btn btn-primary btn-sm mr-2">
                          <i class="fas fa-upload mr-1"></i> Upload Document
                        </button>
                        <button class="btn btn-light btn-sm">
                          <i class="fas fa-filter mr-1"></i> Filter
                        </button>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-3">
                        <!-- Document Categories -->
                        <div class="card border shadow-none mb-4">
                          <div class="card-header bg-transparent border-bottom">
                            <h5 class="card-title mb-0">Categories</h5>
                          </div>
                          <div class="card-body p-0">
                            <div class="list-group list-group-flush">
                              <a href="javascript:void(0);" class="list-group-item list-group-item-action active">
                                <i class="fas fa-folder mr-2"></i> All Documents
                                <span class="badge badge-soft-primary float-right">24</span>
                              </a>
                              <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                                <i class="fas fa-file-medical mr-2"></i> Medical Records
                                <span class="badge badge-soft-secondary float-right">8</span>
                              </a>
                              <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                                <i class="fas fa-file-prescription mr-2"></i> Prescriptions
                                <span class="badge badge-soft-secondary float-right">5</span>
                              </a>
                              <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                                <i class="fas fa-file-invoice mr-2"></i> Insurance
                                <span class="badge badge-soft-secondary float-right">4</span>
                              </a>
                              <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                                <i class="fas fa-file-alt mr-2"></i> Lab Reports
                                <span class="badge badge-soft-secondary float-right">3</span>
                              </a>
                              <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                                <i class="fas fa-file-image mr-2"></i> Imaging
                                <span class="badge badge-soft-secondary float-right">2</span>
                              </a>
                              <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                                <i class="fas fa-file mr-2"></i> Other
                                <span class="badge badge-soft-secondary float-right">2</span>
                              </a>
                            </div>
                          </div>
                        </div>

                        <!-- Recent Activity -->
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom">
                            <h5 class="card-title mb-0">Recent Activity</h5>
                          </div>
                          <div class="card-body">
                            <div class="activity-item d-flex align-items-center mb-3">
                              <div class="avatar-xs mr-3">
                                <span class="avatar-title rounded-circle bg-soft-primary text-primary">
                                  <i class="fas fa-upload"></i>
                                </span>
                              </div>
                              <div>
                                <p class="mb-0 font-size-14">You uploaded <strong>Discharge Summary.pdf</strong></p>
                                <small class="text-muted">2 hours ago</small>
                              </div>
                            </div>
                            <div class="activity-item d-flex align-items-center mb-3">
                              <div class="avatar-xs mr-3">
                                <span class="avatar-title rounded-circle bg-soft-success text-success">
                                  <i class="fas fa-share-alt"></i>
                                </span>
                              </div>
                              <div>
                                <p class="mb-0 font-size-14">Dr. Smith shared <strong>Lab Results.pdf</strong> with you</p>
                                <small class="text-muted">Yesterday</small>
                              </div>
                            </div>
                            <div class="activity-item d-flex align-items-center">
                              <div class="avatar-xs mr-3">
                                <span class="avatar-title rounded-circle bg-soft-warning text-warning">
                                  <i class="fas fa-eye"></i>
                                </span>
                              </div>
                              <div>
                                <p class="mb-0 font-size-14">You viewed <strong>Prescription.pdf</strong></p>
                                <small class="text-muted">3 days ago</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-9">
                        <!-- Document List -->
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom d-flex align-items-center">
                            <h5 class="card-title mb-0">All Documents</h5>
                            <div class="ms-auto">
                              <div class="btn-group" role="group">
                                <button type="button" class="btn btn-light btn-sm active">
                                  <i class="fas fa-th-large"></i>
                                </button>
                                <button type="button" class="btn btn-light btn-sm">
                                  <i class="fas fa-list"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <!-- Document Item -->
                              <div class="col-md-4 mb-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-sm mr-3">
                                        <span class="avatar-title rounded bg-soft-danger text-danger font-size-24">
                                          <i class="fas fa-file-pdf"></i>
                                        </span>
                                      </div>
                                      <div class="flex-grow-1">
                                        <h5 class="font-size-15 mb-0">Discharge Summary</h5>
                                        <p class="text-muted mb-0 font-size-13">PDF • 2.3 MB</p>
                                      </div>
                                      <div class="dropdown">
                                        <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                          <i class="mdi mdi-dots-vertical"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end">
                                          <a class="dropdown-item" href="javascript: void(0);">View</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Download</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Share</a>
                                        </div>
                                      </div>
                                    </div>
                                    <p class="text-muted mb-2 font-size-13">Hospital: Memorial Hospital</p>
                                    <p class="text-muted mb-0 font-size-13">Date: May 15, 2023</p>
                                  </div>
                                </div>
                              </div>

                              <!-- Document Item -->
                              <div class="col-md-4 mb-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-sm mr-3">
                                        <span class="avatar-title rounded bg-soft-primary text-primary font-size-24">
                                          <i class="fas fa-file-medical"></i>
                                        </span>
                                      </div>
                                      <div class="flex-grow-1">
                                        <h5 class="font-size-15 mb-0">Lab Results</h5>
                                        <p class="text-muted mb-0 font-size-13">PDF • 1.5 MB</p>
                                      </div>
                                      <div class="dropdown">
                                        <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                          <i class="mdi mdi-dots-vertical"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end">
                                          <a class="dropdown-item" href="javascript: void(0);">View</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Download</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Share</a>
                                        </div>
                                      </div>
                                    </div>
                                    <p class="text-muted mb-2 font-size-13">Lab: City Medical Lab</p>
                                    <p class="text-muted mb-0 font-size-13">Date: May 10, 2023</p>
                                  </div>
                                </div>
                              </div>

                              <!-- Document Item -->
                              <div class="col-md-4 mb-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-sm mr-3">
                                        <span class="avatar-title rounded bg-soft-success text-success font-size-24">
                                          <i class="fas fa-file-prescription"></i>
                                        </span>
                                      </div>
                                      <div class="flex-grow-1">
                                        <h5 class="font-size-15 mb-0">Prescription</h5>
                                        <p class="text-muted mb-0 font-size-13">PDF • 0.8 MB</p>
                                      </div>
                                      <div class="dropdown">
                                        <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                          <i class="mdi mdi-dots-vertical"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end">
                                          <a class="dropdown-item" href="javascript: void(0);">View</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Download</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Share</a>
                                        </div>
                                      </div>
                                    </div>
                                    <p class="text-muted mb-2 font-size-13">Doctor: Dr. James Wilson</p>
                                    <p class="text-muted mb-0 font-size-13">Date: May 5, 2023</p>
                                  </div>
                                </div>
                              </div>

                              <!-- Document Item -->
                              <div class="col-md-4 mb-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-sm mr-3">
                                        <span class="avatar-title rounded bg-soft-info text-info font-size-24">
                                          <i class="fas fa-file-image"></i>
                                        </span>
                                      </div>
                                      <div class="flex-grow-1">
                                        <h5 class="font-size-15 mb-0">X-Ray Report</h5>
                                        <p class="text-muted mb-0 font-size-13">PDF • 3.2 MB</p>
                                      </div>
                                      <div class="dropdown">
                                        <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                          <i class="mdi mdi-dots-vertical"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end">
                                          <a class="dropdown-item" href="javascript: void(0);">View</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Download</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Share</a>
                                        </div>
                                      </div>
                                    </div>
                                    <p class="text-muted mb-2 font-size-13">Facility: City Radiology</p>
                                    <p class="text-muted mb-0 font-size-13">Date: April 20, 2023</p>
                                  </div>
                                </div>
                              </div>

                              <!-- Document Item -->
                              <div class="col-md-4 mb-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-sm mr-3">
                                        <span class="avatar-title rounded bg-soft-warning text-warning font-size-24">
                                          <i class="fas fa-file-invoice"></i>
                                        </span>
                                      </div>
                                      <div class="flex-grow-1">
                                        <h5 class="font-size-15 mb-0">Insurance Claim</h5>
                                        <p class="text-muted mb-0 font-size-13">PDF • 1.1 MB</p>
                                      </div>
                                      <div class="dropdown">
                                        <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                          <i class="mdi mdi-dots-vertical"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end">
                                          <a class="dropdown-item" href="javascript: void(0);">View</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Download</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Share</a>
                                        </div>
                                      </div>
                                    </div>
                                    <p class="text-muted mb-2 font-size-13">Provider: Star Health Insurance</p>
                                    <p class="text-muted mb-0 font-size-13">Date: April 15, 2023</p>
                                  </div>
                                </div>
                              </div>

                              <!-- Document Item -->
                              <div class="col-md-4 mb-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3">
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="avatar-sm mr-3">
                                        <span class="avatar-title rounded bg-soft-secondary text-secondary font-size-24">
                                          <i class="fas fa-file-alt"></i>
                                        </span>
                                      </div>
                                      <div class="flex-grow-1">
                                        <h5 class="font-size-15 mb-0">Medical History</h5>
                                        <p class="text-muted mb-0 font-size-13">PDF • 2.7 MB</p>
                                      </div>
                                      <div class="dropdown">
                                        <a class="text-muted dropdown-toggle font-size-16" role="button" data-toggle="dropdown" aria-haspopup="true">
                                          <i class="mdi mdi-dots-vertical"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end">
                                          <a class="dropdown-item" href="javascript: void(0);">View</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Download</a>
                                          <a class="dropdown-item" href="javascript: void(0);">Share</a>
                                        </div>
                                      </div>
                                    </div>
                                    <p class="text-muted mb-2 font-size-13">Provider: Dr. Sarah Johnson</p>
                                    <p class="text-muted mb-0 font-size-13">Date: March 10, 2023</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="tab.name === 'Devices'">
                    <div class="d-flex align-items-center mb-4 justify-content-between">
                      <div class="d-flex align-items-center">
                        <i :class="tab.icon" :style="{ color: tab.color }" class="mr-2 font-size-24"></i>
                        <h4 class="mb-0">{{ tab.name }}</h4>
                        <span class="badge badge-soft-success ml-2">{{ tab.description }}</span>
                      </div>
                      <div>
                        <button class="btn btn-primary btn-sm" @click="showDeviceModal = true">
                          <i class="fas fa-plus-circle mr-1"></i> Add Device
                        </button>
                      </div>
                    </div>

                    <div class="row">
                      <!-- Connected Devices -->
                      <div class="col-lg-4">
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom">
                            <h5 class="card-title mb-0"><i class="fas fa-link mr-2 text-success"></i> Connected Devices</h5>
                          </div>
                          <div class="card-body">
                            <!-- Smart Watch -->
                            <div class="device-item mb-4">
                              <div class="d-flex align-items-center mb-3">
                                <div class="avatar-md mr-3">
                                  <span class="avatar-title rounded-circle bg-soft-primary">
                                    <i class="fas fa-watch text-primary font-size-24"></i>
                                  </span>
                                </div>
                                <div>
                                  <h5 class="mb-1">Smart Watch Pro</h5>
                                  <p class="text-muted mb-0">Last synced: 10 minutes ago</p>
                                </div>
                                <div class="ml-auto">
                                  <span class="badge bg-soft-success text-success">Connected</span>
                                </div>
                              </div>
                              <div class="device-stats">
                                <div class="row">
                                  <div class="col-4 text-center">
                                    <div class="device-stat-item">
                                      <h4 class="mb-1"><i class="fas fa-heartbeat text-danger mr-1"></i> 72</h4>
                                      <p class="text-muted mb-0 font-size-12">Heart Rate</p>
                                    </div>
                                  </div>
                                  <div class="col-4 text-center">
                                    <div class="device-stat-item">
                                      <h4 class="mb-1"><i class="fas fa-shoe-prints text-primary mr-1"></i> 8,542</h4>
                                      <p class="text-muted mb-0 font-size-12">Steps</p>
                                    </div>
                                  </div>
                                  <div class="col-4 text-center">
                                    <div class="device-stat-item">
                                      <h4 class="mb-1"><i class="fas fa-fire text-warning mr-1"></i> 420</h4>
                                      <p class="text-muted mb-0 font-size-12">Calories</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Glucose Monitor -->
                            <div class="device-item mb-4">
                              <div class="d-flex align-items-center mb-3">
                                <div class="avatar-md mr-3">
                                  <span class="avatar-title rounded-circle bg-soft-danger">
                                    <i class="fas fa-tint text-danger font-size-24"></i>
                                  </span>
                                </div>
                                <div>
                                  <h5 class="mb-1">Continuous Glucose Monitor</h5>
                                  <p class="text-muted mb-0">Last synced: 30 minutes ago</p>
                                </div>
                                <div class="ml-auto">
                                  <span class="badge bg-soft-success text-success">Connected</span>
                                </div>
                              </div>
                              <div class="device-stats">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                  <span class="text-muted">Current Glucose</span>
                                  <span class="font-weight-bold">142 mg/dL</span>
                                </div>
                                <div class="progress mb-3" style="height: 10px;">
                                  <div class="progress-bar bg-warning" role="progressbar" style="width: 65%;" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <small class="text-muted">Daily Average: 135 mg/dL</small>
                                  <small class="text-muted">Target: 70-120 mg/dL</small>
                                </div>
                              </div>
                            </div>

                            <!-- Blood Pressure Monitor -->
                            <div class="device-item">
                              <div class="d-flex align-items-center mb-3">
                                <div class="avatar-md mr-3">
                                  <span class="avatar-title rounded-circle bg-soft-info">
                                    <i class="fas fa-heart text-info font-size-24"></i>
                                  </span>
                                </div>
                                <div>
                                  <h5 class="mb-1">Blood Pressure Monitor</h5>
                                  <p class="text-muted mb-0">Last synced: 2 hours ago</p>
                                </div>
                                <div class="ml-auto">
                                  <span class="badge bg-soft-success text-success">Connected</span>
                                </div>
                              </div>
                              <div class="device-stats">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                  <span class="text-muted">Last Reading</span>
                                  <span class="font-weight-bold">138/85 mmHg</span>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <small class="text-muted">Pulse: 72 bpm</small>
                                  <small class="text-muted">Status: <span class="text-warning">Elevated</span></small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Real-time Monitoring -->
                      <div class="col-lg-8">
                        <div class="card border shadow-none">
                          <div class="card-header bg-transparent border-bottom d-flex align-items-center">
                            <h5 class="card-title mb-0"><i class="fas fa-chart-line mr-2 text-primary"></i> Real-time Monitoring</h5>
                            <div class="ms-auto">
                              <div class="btn-group" role="group">
                                <button type="button" class="btn btn-sm btn-light active">Day</button>
                                <button type="button" class="btn btn-sm btn-light">Week</button>
                                <button type="button" class="btn btn-sm btn-light">Month</button>
                              </div>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="row mb-4">
                              <div class="col-md-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3 text-center">
                                    <div class="avatar-sm mx-auto mb-3">
                                      <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16">
                                        <i class="fas fa-heartbeat"></i>
                                      </span>
                                    </div>
                                    <h5 class="font-size-15">Heart Rate</h5>
                                    <h4 class="mb-0">72 <small class="text-muted font-size-14">bpm</small></h4>
                                    <p class="text-muted mb-0 mt-2"><i class="fas fa-arrow-down text-danger mr-1"></i> 3 from yesterday</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3 text-center">
                                    <div class="avatar-sm mx-auto mb-3">
                                      <span class="avatar-title rounded-circle bg-soft-success text-success font-size-16">
                                        <i class="fas fa-shoe-prints"></i>
                                      </span>
                                    </div>
                                    <h5 class="font-size-15">Steps</h5>
                                    <h4 class="mb-0">8,542</h4>
                                    <p class="text-muted mb-0 mt-2"><i class="fas fa-arrow-up text-success mr-1"></i> 12% from yesterday</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3 text-center">
                                    <div class="avatar-sm mx-auto mb-3">
                                      <span class="avatar-title rounded-circle bg-soft-warning text-warning font-size-16">
                                        <i class="fas fa-tint"></i>
                                      </span>
                                    </div>
                                    <h5 class="font-size-15">Glucose</h5>
                                    <h4 class="mb-0">142 <small class="text-muted font-size-14">mg/dL</small></h4>
                                    <p class="text-muted mb-0 mt-2"><i class="fas fa-arrow-up text-danger mr-1"></i> 8 from last reading</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="card border mb-0">
                                  <div class="card-body p-3 text-center">
                                    <div class="avatar-sm mx-auto mb-3">
                                      <span class="avatar-title rounded-circle bg-soft-info text-info font-size-16">
                                        <i class="fas fa-bed"></i>
                                      </span>
                                    </div>
                                    <h5 class="font-size-15">Sleep</h5>
                                    <h4 class="mb-0">7.2 <small class="text-muted font-size-14">hrs</small></h4>
                                    <p class="text-muted mb-0 mt-2"><i class="fas fa-arrow-up text-success mr-1"></i> 0.5 from yesterday</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="real-time-chart-container" style="height: 300px; position: relative;">
                              <div class="text-center py-5">
                                <i class="fas fa-chart-line fa-3x text-muted mb-3"></i>
                                <p class="text-muted">Interactive real-time charts would appear here</p>
                                <p class="text-muted">Showing heart rate, glucose levels, and activity data from connected devices</p>
                              </div>
                            </div>

                            <div class="row mt-4">
                              <div class="col-md-6">
                                <div class="card border mb-0">
                                  <div class="card-header bg-transparent border-bottom">
                                    <h5 class="card-title mb-0">Activity Timeline</h5>
                                  </div>
                                  <div class="card-body p-3">
                                    <div class="activity-timeline">
                                      <div class="activity-item d-flex">
                                        <div class="activity-point bg-primary"></div>
                                        <div class="activity-content">
                                          <h6 class="font-size-14 mb-1">Morning Walk</h6>
                                          <p class="text-muted mb-0 font-size-13">7:30 AM - 8:15 AM</p>
                                          <p class="text-muted mb-0 font-size-13">3,200 steps • 2.1 miles • 180 calories</p>
                                        </div>
                                      </div>
                                      <div class="activity-item d-flex">
                                        <div class="activity-point bg-warning"></div>
                                        <div class="activity-content">
                                          <h6 class="font-size-14 mb-1">Glucose Alert</h6>
                                          <p class="text-muted mb-0 font-size-13">10:45 AM</p>
                                          <p class="text-muted mb-0 font-size-13">Blood glucose level: 165 mg/dL (High)</p>
                                        </div>
                                      </div>
                                      <div class="activity-item d-flex">
                                        <div class="activity-point bg-success"></div>
                                        <div class="activity-content">
                                          <h6 class="font-size-14 mb-1">Medication Reminder</h6>
                                          <p class="text-muted mb-0 font-size-13">12:00 PM</p>
                                          <p class="text-muted mb-0 font-size-13">Metformin 500mg taken</p>
                                        </div>
                                      </div>
                                      <div class="activity-item d-flex">
                                        <div class="activity-point bg-info"></div>
                                        <div class="activity-content">
                                          <h6 class="font-size-14 mb-1">Blood Pressure Check</h6>
                                          <p class="text-muted mb-0 font-size-13">2:30 PM</p>
                                          <p class="text-muted mb-0 font-size-13">Reading: 138/85 mmHg • Pulse: 72 bpm</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="card border mb-0">
                                  <div class="card-header bg-transparent border-bottom">
                                    <h5 class="card-title mb-0">Device Notifications</h5>
                                  </div>
                                  <div class="card-body p-3">
                                    <div class="notification-item d-flex align-items-center mb-3 p-2 border rounded">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-warning text-warning">
                                          <i class="fas fa-exclamation-triangle"></i>
                                        </span>
                                      </div>
                                      <div>
                                        <h6 class="font-size-14 mb-1">Glucose Alert</h6>
                                        <p class="text-muted mb-0 font-size-13">Blood glucose above target range (165 mg/dL)</p>
                                        <small class="text-muted">Today, 10:45 AM</small>
                                      </div>
                                    </div>
                                    <div class="notification-item d-flex align-items-center mb-3 p-2 border rounded">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-info text-info">
                                          <i class="fas fa-sync-alt"></i>
                                        </span>
                                      </div>
                                      <div>
                                        <h6 class="font-size-14 mb-1">Device Sync Complete</h6>
                                        <p class="text-muted mb-0 font-size-13">Smart Watch Pro data synchronized</p>
                                        <small class="text-muted">Today, 9:30 AM</small>
                                      </div>
                                    </div>
                                    <div class="notification-item d-flex align-items-center mb-3 p-2 border rounded">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-success text-success">
                                          <i class="fas fa-check-circle"></i>
                                        </span>
                                      </div>
                                      <div>
                                        <h6 class="font-size-14 mb-1">Daily Goal Achieved</h6>
                                        <p class="text-muted mb-0 font-size-13">You've reached your step goal of 8,000 steps</p>
                                        <small class="text-muted">Today, 4:15 PM</small>
                                      </div>
                                    </div>
                                    <div class="notification-item d-flex align-items-center p-2 border rounded">
                                      <div class="avatar-xs mr-3">
                                        <span class="avatar-title rounded-circle bg-soft-danger text-danger">
                                          <i class="fas fa-battery-quarter"></i>
                                        </span>
                                      </div>
                                      <div>
                                        <h6 class="font-size-14 mb-1">Low Battery</h6>
                                        <p class="text-muted mb-0 font-size-13">Glucose Monitor battery at 15%</p>
                                        <small class="text-muted">Today, 3:30 PM</small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <!--                <div v-else>-->
<!--                  &lt;!&ndash; Content for other tabs &ndash;&gt;-->
<!--                  <p class="mb-0">{{ tab.name }} content coming soon...</p>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Image Upload Modal -->
    <b-modal
      v-model="showImageUploadModal"
      title="Update Profile Picture"
      centered
      hide-footer
    >
      <div class="text-center">
        <p class="mb-4">Select a new profile picture</p>
        <div class="d-flex justify-content-center mb-4">
          <label for="profile-image-upload" class="btn btn-primary">
            Browse Image
            <input
              type="file"
              id="profile-image-upload"
              accept="image/*"
              @change="handleImageUpload"
              style="display: none;"
            >
          </label>
        </div>
        <button class="btn btn-secondary" @click="showImageUploadModal = false">Cancel</button>
      </div>
    </b-modal>

    <!-- Review Note Modal -->
    <b-modal
      v-model="showReviewNoteModal"
      title="Review Note"
      title-class="font-18"
      size="lg"
      hide-footer
      class="review-note-modal"
    >
      <div class="p-3">
        <div class="form-group">
          <label for="reviewNoteEditor" class="form-label">Add your review notes:</label>
          <ckeditor v-model="reviewNoteText" :editor="editor"></ckeditor>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showReviewNoteModal = false"
          >
            <i class="ri-close-line align-middle mr-1"></i> Cancel
          </b-button>
          <b-button
            variant="success"
            @click="saveReviewNote"
          >
            <i class="ri-save-line align-middle mr-1"></i> Save Note
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Create Note Modal -->
    <b-modal
      v-model="showCreateNoteModal"
      title="Create Note"
      title-class="font-18"
      size="lg"
      hide-footer
      class="create-note-modal"
    >
      <div class="p-3">
        <div class="form-row mb-3">
          <div class="col-md-6">
            <label for="noteDoctor" class="form-label">Doctor</label>
            <input type="text" id="noteDoctor" v-model="newNote.doctor" class="form-control" placeholder="Doctor Name">
          </div>
          <div class="col-md-6">
            <label for="noteHospital" class="form-label">Hospital/Clinic</label>
            <input type="text" id="noteHospital" v-model="newNote.hospital" class="form-control" placeholder="Hospital or Clinic Name">
          </div>
        </div>
        <div class="form-group">
          <label for="createNoteEditor" class="form-label">Note Content:</label>
          <ckeditor v-model="newNote.content" :editor="editor"></ckeditor>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showCreateNoteModal = false"
          >
            <i class="ri-close-line align-middle mr-1"></i> Cancel
          </b-button>
          <b-button
            variant="success"
            @click="saveNewNote"
          >
            <i class="ri-save-line align-middle mr-1"></i> Save Note
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Treatment / Test Modal -->
    <b-modal
      v-model="showTreatmentTestModal"
      title="Treatment / Test"
      title-class="font-18"
      size="lg"
      hide-footer
      class="treatment-test-modal"
    >
      <div class="p-3">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="treatmentType" class="form-label">Type</label>
            <select id="treatmentType" v-model="treatmentTestForm.treatmentType" class="form-control">
              <option value="" disabled selected>Select type</option>
              <option value="treatment">Treatment</option>
              <option value="test">Test</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="testName" class="form-label">Name</label>
            <input 
              type="text" 
              id="testName" 
              v-model="treatmentTestForm.testName" 
              class="form-control" 
              placeholder="Enter name"
            >
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="testDate" class="form-label">Date</label>
            <input 
              type="date" 
              id="testDate" 
              v-model="treatmentTestForm.date" 
              class="form-control"
            >
          </div>
          <div class="form-group col-md-6">
            <label for="provider" class="form-label">Provider</label>
            <input 
              type="text" 
              id="provider" 
              v-model="treatmentTestForm.provider" 
              class="form-control" 
              placeholder="Enter provider"
            >
          </div>
        </div>
        <div class="form-group">
          <label for="description" class="form-label">Description</label>
          <textarea 
            id="description" 
            v-model="treatmentTestForm.description" 
            class="form-control" 
            rows="3" 
            placeholder="Enter description"
          ></textarea>
        </div>
        <div class="form-group">
          <label for="notes" class="form-label">Notes</label>
          <textarea 
            id="notes" 
            v-model="treatmentTestForm.notes" 
            class="form-control" 
            rows="3" 
            placeholder="Enter notes"
          ></textarea>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showTreatmentTestModal = false"
          >
            <i class="ri-close-line align-middle mr-1"></i> Cancel
          </b-button>
          <b-button
            variant="success"
            @click="saveTreatmentTest"
          >
            <i class="ri-save-line align-middle mr-1"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Treatment Modal -->
    <b-modal
      v-model="showTreatmentModal"
      title="Create Treatment"
      title-class="font-18"
      size="lg"
      hide-footer
      class="treatment-modal"
      @hidden="resetTreatmentForm"
    >
      <div class="p-3">
        <!-- Treatment Type Selection -->
        <div class="treatment-type-selection mb-4">
          <h5 class="mb-3">Select Treatment Type</h5>
          <div class="row">
            <div class="col-md-6">
              <div 
                class="treatment-type-card p-3 text-center" 
                :class="{ 'active': selectedTreatmentType === 'treatment' }"
                @click="selectTreatmentType('treatment')"
              >
                <i class="fas fa-procedures mb-3" style="font-size: 2rem;"></i>
                <h5>Treatment</h5>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="treatment-type-card p-3 text-center"
                :class="{ 'active': selectedTreatmentType === 'programs' }"
                @click="selectTreatmentType('programs')"
              >
                <i class="fas fa-pills mb-3" style="font-size: 2rem;"></i>
                <h5>Treatment Programs</h5>
              </div>
            </div>
          </div>
        </div>

        <!-- Treatment Type Options -->
        <div v-if="selectedTreatmentType === 'treatment'" class="mb-4">
          <h6 class="mb-3">Select Treatment Option</h6>
          <div class="row">
            <div class="col-md-6">
              <div class="form-check mb-2">
                <input class="form-check-input" type="radio" name="treatmentOption" id="surgicalOption" value="surgical" v-model="treatmentForm.type">
                <label class="form-check-label" for="surgicalOption">
                  Surgical
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check mb-2">
                <input class="form-check-input" type="radio" name="treatmentOption" id="nonSurgicalOption" value="non-surgical" v-model="treatmentForm.type">
                <label class="form-check-label" for="nonSurgicalOption">
                  Non-Surgical
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Programs Wizard -->
        <div v-if="selectedTreatmentType === 'programs'" class="mb-4">
          <!-- Back to Treatment Type Selection Button -->
          <div class="mb-3">
            <button class="btn btn-outline-secondary" @click="resetTreatmentForm">
              <i class="fas fa-arrow-left mr-1"></i> Back to Treatment Types
            </button>
          </div>

          <form-wizard
            color="#28a745"
            title="Treatment Programs Wizard"
            subtitle="Complete the steps to create a treatment program"
            shape="circle"
            back-button-text="Previous"
            next-button-text="Next"
            finish-button-text="Submit"
            @on-complete="saveTreatment"
          >
            <!-- Step 1: Program Details -->
            <tab-content title="Program Details" icon="fas fa-clipboard-list">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="programType" class="form-label">Program Type</label>
                  <multiselect
                    id="programType"
                    v-model="treatmentForm.nonSurgicalDetails.programTypes"
                    :options="programTypeOptions"
                    :multiple="true"
                    :searchable="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Search and select program types"
                    label="name"
                    track-by="id"
                    class="program-type-multiselect"
                    @input="initializeProgramTypeFields"
                  >
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} program type(s) selected</span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                        <span class="option__small text-muted">{{ props.option.description }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
                <div class="form-group col-md-6">
                  <label for="programGoals" class="form-label">Program Goals</label>
                  <input 
                    type="text" 
                    id="programGoals" 
                    v-model="treatmentForm.nonSurgicalDetails.therapyGoals" 
                    class="form-control" 
                    placeholder="Enter program goals"
                    required
                  >
                </div>
              </div>

              <!-- Selected Program Types -->
              <div v-if="treatmentForm.nonSurgicalDetails.programTypes.length > 0" class="selected-program-types mt-4 mb-4">
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-check-circle mr-1"></i> Selected Program Types
                  <span class="badge badge-soft-primary ml-2">{{ treatmentForm.nonSurgicalDetails.programTypes.length }}</span>
                </h6>

                <!-- Program Type Cards -->
                <div class="row">
                  <div 
                    v-for="(programType, index) in treatmentForm.nonSurgicalDetails.programTypes" 
                    :key="'program-type-' + programType.id"
                    class="col-md-6 mb-3"
                  >
                    <div class="program-type-card p-3 border rounded shadow-sm h-100">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0 font-weight-bold">{{ programType.name }}</h6>
                        <div>
                          <button
                            type="button"
                            class="btn btn-sm btn-icon text-info p-0 mr-1"
                            @click="editProgramType(programType)"
                            title="Edit program type"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-icon text-danger p-0"
                            @click="removeProgramType(index)"
                            title="Remove program type"
                          >
                            <i class="fas fa-times-circle"></i>
                          </button>
                        </div>
                      </div>
                      <p class="text-muted small mb-2">{{ programType.description }}</p>

                      <!-- Specifications -->
                      <div class="program-specifications mb-2">
                        <p class="font-weight-bold mb-1 small">Specifications:</p>
                        <ul class="pl-3 mb-2">
                          <li v-for="(spec, specIndex) in programType.specifications" :key="specIndex" class="small mb-1">
                            {{ spec }}
                          </li>
                        </ul>
                      </div>

                      <!-- Offerings -->
                      <div class="program-offerings mb-2">
                        <p class="font-weight-bold mb-1 small">Offerings:</p>
                        <ul class="pl-3">
                          <li v-for="(offering, offeringIndex) in programType.offerings" :key="offeringIndex" class="small mb-1">
                            {{ offering }}
                          </li>
                        </ul>
                      </div>

                      <!-- Frequency and Duration -->
                      <div class="program-schedule mt-2">
                        <p class="font-weight-bold mb-1 small">Schedule:</p>
                        <div class="form-row">
                          <div class="form-group col-md-6 mb-2">
                            <label for="programFrequency" class="form-label small">Frequency</label>
                            <input 
                              type="text" 
                              :id="'programFrequency-' + index" 
                              v-model="programType.frequency" 
                              class="form-control form-control-sm" 
                              placeholder="E.g., 3 times per week"
                            >
                          </div>
                          <div class="form-group col-md-6 mb-2">
                            <label for="programDuration" class="form-label small">Duration</label>
                            <input 
                              type="text" 
                              :id="'programDuration-' + index" 
                              v-model="programType.duration" 
                              class="form-control form-control-sm" 
                              placeholder="E.g., 8 weeks"
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="programInstructions" class="form-label">Home Instructions</label>
                <textarea 
                  id="programInstructions" 
                  v-model="treatmentForm.nonSurgicalDetails.homeInstructions" 
                  class="form-control" 
                  rows="3" 
                  placeholder="Enter home instructions"
                ></textarea>
              </div>
            </tab-content>

            <!-- Step 2: Additional Information -->
            <tab-content title="Additional Information" icon="fas fa-plus-circle">
              <div class="form-group">
                <label for="programNotes" class="form-label">Additional Notes</label>
                <textarea 
                  id="programNotes" 
                  v-model="treatmentForm.notes" 
                  class="form-control" 
                  rows="4" 
                  placeholder="Enter any additional notes"
                ></textarea>
              </div>
              <div class="prescription-upload-section mb-4">
                <h5 class="mb-3">Upload Supporting Documents (Optional)</h5>
                <p class="text-muted mb-3">Upload any supporting documents for this program.</p>
                <div class="d-flex justify-content-center mb-3">
                  <label for="program-docs-upload" class="btn btn-primary">
                    <i class="fas fa-upload mr-1"></i> Browse Files
                    <input
                      type="file"
                      id="program-docs-upload"
                      accept="image/*,.pdf,.doc,.docx"
                      multiple
                      @change="handlePrescriptionUpload"
                      style="display: none;"
                    >
                  </label>
                </div>
                <div v-if="treatmentForm.prescriptions.length > 0" class="prescription-files-list">
                  <h6 class="mb-3">Uploaded Documents:</h6>
                  <div class="list-group">
                    <div 
                      v-for="(file, index) in treatmentForm.prescriptions" 
                      :key="index"
                      class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <i class="fas fa-file text-primary mr-2"></i>
                        {{ file.name }}
                      </div>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-danger" 
                        @click="removePrescription(index)"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </div>

        <!-- Form Wizard for Treatment Details -->
        <form-wizard
          v-if="selectedTreatmentType === 'treatment'"
          color="#556ee6"
          title=""
          subtitle=""
          shape="circle"
          back-button-text="Previous"
          next-button-text="Next"
          finish-button-text="Submit"
          @on-complete="saveTreatment"
        >
          <!-- Step 1: Basic Information -->
          <tab-content title="Basic Information" icon="fas fa-info-circle">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="treatmentName" class="form-label">Treatment Name</label>
                <multiselect 
                  id="treatmentName" 
                  v-model="treatmentForm.name" 
                  :options="treatmentNames"
                  :searchable="true"
                  :allow-empty="false"
                  :taggable="true"
                  @tag="addTag"
                  placeholder="Select or type treatment name"
                  required
                ></multiselect>
              </div>
              <div class="form-group col-md-6">
                <label for="treatmentDescription" class="form-label">Description</label>
                <input 
                  type="text" 
                  id="treatmentDescription" 
                  v-model="treatmentForm.description" 
                  class="form-control" 
                  placeholder="Enter brief description"
                  required
                >
              </div>
            </div>

            <!-- Services Section -->
            <div v-if="treatmentForm.type" class="col-12">
              <div class="card mb-3">
                <div class="card-header bg-light d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Services</h5>
                </div>
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="service-type">Service Type</label>
                        <multiselect
                          v-model="newService.type"
                          :options="serviceTypeOptions"
                          placeholder="Select service type"
                          :searchable="true"
                          :allow-empty="false"
                          class="custom-multiselect"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="service-name">Service Name <small class="text-muted">(Select multiple options)</small></label>
                        <multiselect
                          v-model="newService.name"
                          :options="getServiceOptions()"
                          :multiple="true"
                          :searchable="true"
                          :disabled="!newService.type"
                          placeholder="Select service name"
                          class="custom-multiselect"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="col-12 mt-4">
                      <div class="d-flex justify-content-end">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="addService"
                            :disabled="!newService.type || newService.name.length === 0"
                        >
                          Add Service
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Services List -->
                  <div v-if="services.length > 0" class="mt-3">
                    <h6 class="mb-3">Added Services</h6>
                    <div class="table-responsive">
                      <table class="table table-bordered table-hover">
                        <thead class="table-light">
                          <tr>
                            <th>Service Type</th>
                            <th>Service Name</th>
                            <th class="text-center" style="width: 120px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(service, index) in services" :key="service.id">
                            <td>{{ service.type }}</td>
                            <td>{{ service.name.join(', ') }}</td>
                            <td class="text-center">
                              <button type="button" class="btn btn-sm btn-outline-primary me-1" @click="editService(index)">
                                <i class="mdi mdi-pencil"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-outline-danger" @click="removeService(index)">
                                <i class="mdi mdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Add Treatment Button -->
            <div class="col-12 mt-4">
              <div class="d-flex justify-content-end">
                <button 
                  type="button" 
                  class="btn btn-primary" 
                  @click="addTreatment" 
                  :disabled="!treatmentForm.name || !treatmentForm.description || services.length === 0"
                >
                  Add Treatment
                </button>
              </div>
            </div>

            <!-- Treatments Table -->
            <div v-if="addedTreatments.length > 0" class="col-12 mt-4">
              <div class="card">
                <div class="card-header bg-soft-primary d-flex justify-content-between align-items-center">
                  <h5 class="mb-0 text-primary">
                    <i class="mdi mdi-clipboard-text-outline mr-1"></i> Added Treatments
                  </h5>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-bordered table-hover custom-table">
                      <thead class="table-light">
                        <tr>
                          <th style="width: 50px; vertical-align: middle;">
                            <div class="form-check d-flex justify-content-center align-items-center">
                              <input class="form-check-input position-static m-0" type="checkbox" v-model="selectAllTreatments" @change="toggleSelectAllTreatments">
                            </div>
                          </th>
                          <th class="font-weight-bold">Treatment Name</th>
                          <th class="font-weight-bold">Description</th>
                          <th class="font-weight-bold">Services</th>
                          <th class="text-center font-weight-bold" style="width: 80px">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(treatment, index) in addedTreatments" :key="index">
                          <td class="text-center align-middle">
                            <div class="form-check d-flex justify-content-center align-items-center">
                              <input class="form-check-input position-static m-0" type="checkbox" v-model="treatment.selected">
                            </div>
                          </td>
                          <td class="align-middle">{{ treatment.name }}</td>
                          <td class="align-middle">{{ treatment.description }}</td>
                          <td>
                            <div v-for="(service, sIndex) in treatment.services" :key="sIndex" class="mb-1">
                              <span class="badge bg-soft-primary text-primary p-2 rounded">
                                <i class="mdi mdi-medical-bag mr-1"></i>{{ service.type }}: {{ service.name.join(', ') }}
                              </span>
                            </div>
                          </td>
                          <td class="text-center align-middle">
                            <button type="button" class="btn btn-sm btn-soft-danger" @click="removeTreatment(index)">
                              <i class="mdi mdi-trash-can-outline mr-1"></i> Delete
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </tab-content>

          <!-- Step 2: Specific Details -->
          <tab-content title="Treatment Details" icon="fas fa-clipboard-list">
            <!-- Surgical Treatment Details -->
            <div v-if="treatmentForm.type === 'surgical'">
              <h5 class="mb-3">Surgical Details</h5>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="surgicalProcedure" class="form-label">Procedure</label>
                  <select 
                    id="surgicalProcedure" 
                    v-model="selectedProcedure" 
                    class="form-control"
                    @change="addProcedure"
                  >
                    <option value="" disabled selected>Select procedure</option>
                    <option v-for="(procedure, index) in treatmentNames" :key="index" :value="procedure">
                      {{ procedure }}
                    </option>
                  </select>

                  <!-- Display selected procedures as cards -->
                  <div v-if="treatmentForm.surgicalDetails.procedure.length > 0" class="mt-3">
                    <div v-for="(proc, index) in treatmentForm.surgicalDetails.procedure" :key="index" class="card procedure-card mb-3">
                      <div class="card-body p-3">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <h5 class="card-title mb-0 text-primary">{{ proc }}</h5>
                          <button type="button" class="btn btn-sm btn-icon btn-soft-danger" @click="removeProcedure(index)">
                            <i class="mdi mdi-close"></i>
                          </button>
                        </div>
                        <div class="procedure-details">
                          <p class="mb-1"><strong>Description:</strong> {{ getProcedureDetails(proc).description }}</p>
                          <p class="mb-1"><strong>Treatment:</strong> {{ getProcedureDetails(proc).treatment }}</p>
                          <p class="mb-1"><strong>Recovery:</strong> {{ getProcedureDetails(proc).recovery }}</p>
                          <p class="mb-0"><strong>Risks:</strong> {{ getProcedureDetails(proc).risks }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="surgicalLocation" class="form-label">Location</label>
                  <select 
                    id="surgicalLocation" 
                    v-model="treatmentForm.surgicalDetails.location" 
                    class="form-control"
                    required
                  >
                    <option value="" disabled selected>Select location</option>
                    <option value="Main OR">Main OR</option>
                    <option value="Outpatient Surgery Center">Outpatient Surgery Center</option>
                    <option value="Eye Surgery Center">Eye Surgery Center</option>
                    <option value="Labor & Delivery OR">Labor & Delivery OR</option>
                    <option value="Cardiovascular OR">Cardiovascular OR</option>
                    <option value="Orthopedic OR">Orthopedic OR</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="surgicalAnesthesia" class="form-label">Anesthesia</label>
                  <select 
                    id="surgicalAnesthesia" 
                    v-model="treatmentForm.surgicalDetails.anesthesia" 
                    class="form-control"
                    required
                  >
                    <option value="" disabled selected>Select anesthesia type</option>
                    <option value="General">General</option>
                    <option value="Local">Local</option>
                    <option value="Regional">Regional</option>
                    <option value="Sedation">Sedation</option>
                    <option value="None">None</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="surgicalDuration" class="form-label">Procedure Duration</label>
                  <input 
                    type="text" 
                    id="surgicalDuration" 
                    v-model="treatmentForm.surgicalDetails.duration" 
                    class="form-control" 
                    placeholder="Enter duration (e.g., 45 minutes)"
                    required
                  >
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="operationTheaterDuration" class="form-label">Operation Theater Duration</label>
                  <select 
                    id="operationTheaterDuration" 
                    v-model="treatmentForm.surgicalDetails.operationTheaterDuration" 
                    class="form-control"
                    required
                  >
                    <option value="" disabled selected>Select theater duration</option>
                    <option value="1 hour">1 hour</option>
                    <option value="2 hours">2 hours</option>
                    <option value="3 hours">3 hours</option>
                    <option value="4 hours">4 hours</option>
                    <option value="5+ hours">5+ hours</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="equipment" class="form-label">Equipment Used</label>
                  <select 
                    id="equipment" 
                    v-model="treatmentForm.surgicalDetails.equipment" 
                    class="form-control" 
                    multiple
                    required
                  >
                    <option value="Laparoscope">Laparoscope</option>
                    <option value="Surgical stapler">Surgical stapler</option>
                    <option value="Electrocautery device">Electrocautery device</option>
                    <option value="Arthroscope">Arthroscope</option>
                    <option value="Shaver">Shaver</option>
                    <option value="Probe">Probe</option>
                    <option value="Fluid management system">Fluid management system</option>
                    <option value="Phacoemulsification machine">Phacoemulsification machine</option>
                    <option value="Microscope">Microscope</option>
                    <option value="IOL inserter">IOL inserter</option>
                    <option value="Heart-lung machine">Heart-lung machine</option>
                    <option value="Cardiac monitoring equipment">Cardiac monitoring equipment</option>
                    <option value="Vein harvesting tools">Vein harvesting tools</option>
                    <option value="Sternal saw">Sternal saw</option>
                    <option value="Specialized hip arthroplasty instruments">Specialized hip arthroplasty instruments</option>
                    <option value="Fluoroscopy">Fluoroscopy</option>
                    <option value="Power tools">Power tools</option>
                    <option value="Hip prosthesis components">Hip prosthesis components</option>
                  </select>
                  <small class="form-text text-muted">Hold Ctrl/Cmd to select multiple items</small>
                </div>
              </div>

              <!-- Rented Equipment Section -->
              <h6 class="mt-3 mb-3">Rented Equipment</h6>
              <p class="text-muted mb-3">Add any equipment that was rented for this procedure, including cost and rental duration.</p>

              <div class="mb-3">
                <button 
                  type="button" 
                  class="btn btn-sm btn-primary" 
                  @click="addRentedEquipment"
                >
                  <i class="fas fa-plus mr-1"></i> Add Rented Equipment
                </button>
              </div>

              <div v-if="treatmentForm.surgicalDetails.rentedEquipment.length > 0" class="mb-4">
                <div 
                  v-for="(item, index) in treatmentForm.surgicalDetails.rentedEquipment" 
                  :key="'rented-' + index"
                  class="card mb-3 p-3"
                >
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0">Rented Item #{{ index + 1 }}</h6>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-danger" 
                      @click="removeRentedEquipment(index)"
                      title="Remove"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label :for="'rentedEquipmentName-' + index" class="form-label">Equipment Name</label>
                      <input 
                        type="text" 
                        :id="'rentedEquipmentName-' + index" 
                        v-model="item.name" 
                        class="form-control" 
                        placeholder="Enter equipment name"
                        required
                      >
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label :for="'rentedEquipmentCost-' + index" class="form-label">Cost</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">$</span>
                        </div>
                        <input 
                          type="number" 
                          :id="'rentedEquipmentCost-' + index" 
                          v-model="item.cost" 
                          class="form-control" 
                          placeholder="Enter cost"
                          min="0"
                          step="0.01"
                          required
                        >
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label :for="'rentedEquipmentDuration-' + index" class="form-label">Rental Duration</label>
                      <input 
                        type="text" 
                        :id="'rentedEquipmentDuration-' + index" 
                        v-model="item.duration" 
                        class="form-control" 
                        placeholder="e.g., 2 days, 1 week"
                        required
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="alert alert-light text-center mb-4">
                <i class="fas fa-info-circle mr-2"></i>
                No rented equipment added yet
              </div>

              <h6 class="mt-3 mb-3">Team Members Required</h6>
              <!-- Nurses Section -->
              <div class="form-group">
                <label for="nurseCount" class="form-label">Number of Nurses</label>
                <div class="d-flex align-items-center">
                  <input 
                    type="number" 
                    id="nurseCount" 
                    v-model.number="treatmentForm.surgicalDetails.teamMembers.nurseCount" 
                    class="form-control" 
                    min="0" 
                    max="3"
                    @change="updateNurseCount"
                    style="width: 100px;"
                  >
                  <span class="ml-2 text-muted">Maximum 3 nurses</span>
                </div>
              </div>

              <div v-if="treatmentForm.surgicalDetails.teamMembers.nurseCount > 0" class="mb-4">
                <div 
                  v-for="(nurse, index) in treatmentForm.surgicalDetails.teamMembers.nurses" 
                  :key="'nurse-' + index"
                  class="d-flex align-items-center mb-2"
                >
                  <input 
                    type="text" 
                    v-model="treatmentForm.surgicalDetails.teamMembers.nurses[index]" 
                    class="form-control" 
                    :placeholder="'Nurse ' + (index + 1) + ' name'"
                    required
                  >
                  <button 
                    type="button" 
                    class="btn btn-sm btn-danger ml-2" 
                    @click="removeNurse(index)"
                    title="Remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>

              <!-- Assistant Doctors Section -->
              <div class="form-group">
                <label for="assistantDoctorCount" class="form-label">Number of Assistant Doctors</label>
                <div class="d-flex align-items-center">
                  <input 
                    type="number" 
                    id="assistantDoctorCount" 
                    v-model.number="treatmentForm.surgicalDetails.teamMembers.assistantDoctorCount" 
                    class="form-control" 
                    min="0" 
                    max="3"
                    @change="updateAssistantDoctorCount"
                    style="width: 100px;"
                  >
                  <span class="ml-2 text-muted">Maximum 3 assistant doctors</span>
                </div>
              </div>

              <div v-if="treatmentForm.surgicalDetails.teamMembers.assistantDoctorCount > 0" class="mb-4">
                <div 
                  v-for="(doctor, index) in treatmentForm.surgicalDetails.teamMembers.assistantDoctors" 
                  :key="'assistant-' + index"
                  class="d-flex align-items-center mb-2"
                >
                  <input 
                    type="text" 
                    v-model="treatmentForm.surgicalDetails.teamMembers.assistantDoctors[index]" 
                    class="form-control" 
                    :placeholder="'Assistant Doctor ' + (index + 1) + ' name'"
                    required
                  >
                  <button 
                    type="button" 
                    class="btn btn-sm btn-danger ml-2" 
                    @click="removeAssistantDoctor(index)"
                    title="Remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>

              <!-- Senior Doctors Section -->
              <div class="form-group">
                <label for="seniorDoctorCount" class="form-label">Number of Senior Doctors</label>
                <div class="d-flex align-items-center">
                  <input 
                    type="number" 
                    id="seniorDoctorCount" 
                    v-model.number="treatmentForm.surgicalDetails.teamMembers.seniorDoctorCount" 
                    class="form-control" 
                    min="0" 
                    max="3"
                    @change="updateSeniorDoctorCount"
                    style="width: 100px;"
                  >
                  <span class="ml-2 text-muted">Maximum 3 senior doctors</span>
                </div>
              </div>

              <div v-if="treatmentForm.surgicalDetails.teamMembers.seniorDoctorCount > 0" class="mb-4">
                <div 
                  v-for="(doctor, index) in treatmentForm.surgicalDetails.teamMembers.seniorDoctors" 
                  :key="'senior-' + index"
                  class="d-flex align-items-center mb-2"
                >
                  <input 
                    type="text" 
                    v-model="treatmentForm.surgicalDetails.teamMembers.seniorDoctors[index]" 
                    class="form-control" 
                    :placeholder="'Senior Doctor ' + (index + 1) + ' name'"
                    required
                  >
                  <button 
                    type="button" 
                    class="btn btn-sm btn-danger ml-2" 
                    @click="removeSeniorDoctor(index)"
                    title="Remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>

              <div class="form-group">
                <label for="surgicalComplications" class="form-label">Complications</label>
                <textarea 
                  id="surgicalComplications" 
                  v-model="treatmentForm.surgicalDetails.complications" 
                  class="form-control" 
                  rows="3" 
                  placeholder="Enter any complications (if none, leave blank)"
                ></textarea>
              </div>
            </div>

            <!-- Non-Surgical Treatment Details -->
            <div v-else-if="treatmentForm.type === 'non-surgical'">
              <h5 class="mb-3">Non-Surgical Details</h5>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="nonSurgicalType" class="form-label">Treatment Type</label>
                  <select 
                    id="nonSurgicalType" 
                    v-model="treatmentForm.nonSurgicalDetails.treatmentType" 
                    class="form-control"
                    required
                  >
                    <option value="" disabled selected>Select treatment type</option>
                    <option value="medication">Medication</option>
                    <option value="physical">Physical Therapy</option>
                    <option value="occupational">Occupational Therapy</option>
                    <option value="speech">Speech Therapy</option>
                    <option value="radiation">Radiation Therapy</option>
                    <option value="chemo">Chemotherapy</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="nonSurgicalFrequency" class="form-label">Frequency</label>
                  <input 
                    type="text" 
                    id="nonSurgicalFrequency" 
                    v-model="treatmentForm.nonSurgicalDetails.frequency" 
                    class="form-control" 
                    placeholder="Enter frequency (e.g., Twice daily)"
                    required
                  >
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="nonSurgicalDuration" class="form-label">Duration</label>
                  <input 
                    type="text" 
                    id="nonSurgicalDuration" 
                    v-model="treatmentForm.nonSurgicalDetails.duration" 
                    class="form-control" 
                    placeholder="Enter duration (e.g., 10 days)"
                    required
                  >
                </div>
                <div class="form-group col-md-6">
                  <label for="nonSurgicalDosage" class="form-label">Dosage</label>
                  <input 
                    type="text" 
                    id="nonSurgicalDosage" 
                    v-model="treatmentForm.nonSurgicalDetails.dosage" 
                    class="form-control" 
                    placeholder="Enter dosage (if applicable)"
                  >
                </div>
              </div>
              <div class="form-group">
                <label for="nonSurgicalRoute" class="form-label">Route</label>
                <select 
                  id="nonSurgicalRoute" 
                  v-model="treatmentForm.nonSurgicalDetails.route" 
                  class="form-control"
                >
                  <option value="" disabled selected>Select route (if applicable)</option>
                  <option value="Oral">Oral</option>
                  <option value="Intravenous">Intravenous</option>
                  <option value="Intramuscular">Intramuscular</option>
                  <option value="Subcutaneous">Subcutaneous</option>
                  <option value="Topical">Topical</option>
                  <option value="Inhalation">Inhalation</option>
                  <option value="N/A">Not Applicable</option>
                </select>
              </div>
            </div>

            <!-- Placeholder for other treatment types that might be added in the future -->
            <div v-else>
              <div class="alert alert-info">
                <i class="fas fa-info-circle mr-2"></i>
                Please select a valid treatment type.
              </div>
            </div>
          </tab-content>

          <!-- Step 3: Medication -->
          <tab-content title="Medication" icon="fas fa-file-prescription">
            <div class="prescription-upload-section mb-4">
              <h5 class="mb-3">Upload Handwritten Medication Report / Prescriptions (Optional)</h5>
              <p class="text-muted mb-3">Upload scanned copies or photos of handwritten prescriptions or medical test if available.</p>

              <div class="prescription-upload-container mb-4">
                <div class="d-flex justify-content-center mb-3">
                  <label for="prescription-upload" class="btn btn-primary">
                    <i class="fas fa-upload mr-1"></i> Browse Files
                    <input
                      type="file"
                      id="prescription-upload"
                      accept="image/*,.pdf"
                      multiple
                      @change="handlePrescriptionUpload"
                      style="display: none;"
                    >
                  </label>
                </div>

                <div v-if="treatmentForm.prescriptions.length > 0" class="prescription-files-list">
                  <h6 class="mb-3">Uploaded Prescriptions:</h6>
                  <div class="list-group">
                    <div 
                      v-for="(file, index) in treatmentForm.prescriptions" 
                      :key="index"
                      class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <i class="fas fa-file-medical text-primary mr-2"></i>
                        {{ file.name }}
                      </div>
                      <button 
                        class="btn btn-sm btn-soft-danger" 
                        @click="removePrescription(index)"
                        title="Remove"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div v-else class="text-center text-muted">
                  <i class="fas fa-file-upload mb-2" style="font-size: 2rem;"></i>
                  <p>No prescriptions uploaded yet</p>
                </div>
              </div>
            </div>
          </tab-content>

          <!-- Step 4: Notes -->
          <tab-content title="Notes" icon="fas fa-sticky-note">
            <div class="form-group">
              <label for="treatmentNotes" class="form-label">Additional Notes</label>
              <textarea 
                id="treatmentNotes" 
                v-model="treatmentForm.notes" 
                class="form-control" 
                rows="5" 
                placeholder="Enter any additional notes about the treatment"
              ></textarea>
            </div>
          </tab-content>
        </form-wizard>

        <!-- Cancel Button -->
        <div class="text-center mt-3">
          <button class="btn btn-secondary" @click="showTreatmentModal = false">
            <i class="ri-close-line align-middle mr-1"></i> Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Referral Modal -->
    <b-modal
      v-model="showReferralModal"
      title="Referral"
      title-class="font-18"
      size="md"
      hide-footer
      class="referral-modal"
    >
      <div class="p-3">
        <div class="form-group">
          <label for="referralSearch" class="form-label">Search Provider</label>
          <div class="input-group">
            <input 
              type="text" 
              id="referralSearch" 
              v-model="referralSearch" 
              class="form-control" 
              placeholder="Search for provider..."
            >
            <div class="input-group-append">
              <button class="btn btn-primary" type="button">
                <i class="ri-search-line"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="referral-results mt-3">
          <p class="text-muted small">Search results will appear here</p>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showReferralModal = false"
          >
            <i class="ri-close-line align-middle mr-1"></i> Close
          </b-button>
          <b-button
            variant="success"
            @click="saveReferral"
          >
            <i class="ri-save-line align-middle mr-1"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Assessment Modal -->
    <b-modal
      v-model="showAssessmentModal"
      :title="'Create ' + activeMedicalTab + ' Assessment'"
      size="lg"
      hide-footer
      header-class="bg-primary text-white"
      body-class="p-0"
    >
      <div class="assessment-wizard">
        <!-- Wizard Progress -->
        <div class="assessment-wizard-progress">
          <div class="progress-container">
            <div class="progress">
              <div 
                class="progress-bar bg-primary" 
                role="progressbar" 
                :style="{ width: ((currentAssessmentStep / getMaxSteps()) * 100) + '%' }" 
                :aria-valuenow="(currentAssessmentStep / getMaxSteps()) * 100" 
                aria-valuemin="0" 
                aria-valuemax="100"
              ></div>
            </div>
            <div class="progress-steps">
              <!-- Medical History Steps -->
              <template v-if="activeMedicalTab === 'Medical History'">
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 1, 'completed': currentAssessmentStep > 1 }"
                  @click="currentAssessmentStep = 1"
                >
                  <div class="step-icon">
                    <i class="fas fa-history" v-if="currentAssessmentStep > 1"></i>
                    <span v-else>1</span>
                  </div>
                  <div class="step-label">Past Medical History</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 2, 'completed': currentAssessmentStep > 2 }"
                  @click="currentAssessmentStep = 2"
                >
                  <div class="step-icon">
                    <i class="fas fa-users" v-if="currentAssessmentStep > 2"></i>
                    <span v-else>2</span>
                  </div>
                  <div class="step-label">Family History</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 3, 'completed': currentAssessmentStep > 3 }"
                  @click="currentAssessmentStep = 3"
                >
                  <div class="step-icon">
                    <i class="fas fa-pills" v-if="currentAssessmentStep > 3"></i>
                    <span v-else>3</span>
                  </div>
                  <div class="step-label">Medication History</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 4, 'completed': currentAssessmentStep > 4 }"
                  @click="currentAssessmentStep = 4"
                >
                  <div class="step-icon">
                    <i class="fas fa-user-friends" v-if="currentAssessmentStep > 4"></i>
                    <span v-else>4</span>
                  </div>
                  <div class="step-label">Social History</div>
                </div>
              </template>

              <!-- Physical Examination Steps -->
              <template v-else-if="activeMedicalTab === 'Physical Examination'">
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 1, 'completed': currentAssessmentStep > 1 }"
                  @click="currentAssessmentStep = 1"
                >
                  <div class="step-icon">
                    <i class="fas fa-ruler-combined" v-if="currentAssessmentStep > 1"></i>
                    <span v-else>1</span>
                  </div>
                  <div class="step-label">Vital Signs</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 2, 'completed': currentAssessmentStep > 2 }"
                  @click="currentAssessmentStep = 2"
                >
                  <div class="step-icon">
                    <i class="fas fa-stethoscope" v-if="currentAssessmentStep > 2"></i>
                    <span v-else>2</span>
                  </div>
                  <div class="step-label">System Examination</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 3, 'completed': currentAssessmentStep > 3 }"
                  @click="currentAssessmentStep = 3"
                >
                  <div class="step-icon">
                    <i class="fas fa-clipboard-list" v-if="currentAssessmentStep > 3"></i>
                    <span v-else>3</span>
                  </div>
                  <div class="step-label">Assessment</div>
                </div>
              </template>

              <!-- Social & Environmental Steps -->
              <template v-else-if="activeMedicalTab === 'Social & Environmental'">
                <!-- Progress Indicator -->
                <div class="progress-indicator mb-3">
                  <div class="progress-text text-center mb-1">
                    <small class="text-muted">Step {{ currentAssessmentStep }} of 4</small>
                    <span class="progress-percentage ml-2">{{ Math.round((currentAssessmentStep / 4) * 100) }}% Complete</span>
                  </div>
                  <div class="progress" style="height: 8px;">
                    <div 
                      class="progress-bar bg-success" 
                      role="progressbar" 
                      :style="{ width: ((currentAssessmentStep / 4) * 100) + '%' }" 
                      :aria-valuenow="(currentAssessmentStep / 4) * 100" 
                      aria-valuemin="0" 
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 1, 'completed': currentAssessmentStep > 1 }"
                  @click="currentAssessmentStep = 1"
                >
                  <div class="step-icon">
                    <i class="fas fa-briefcase" v-if="currentAssessmentStep > 1"></i>
                    <span v-else>1</span>
                  </div>
                  <div class="step-label">Occupation</div>
                  <div class="step-description" v-if="currentAssessmentStep === 1">Work environment</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 2, 'completed': currentAssessmentStep > 2 }"
                  @click="currentAssessmentStep = 2"
                >
                  <div class="step-icon">
                    <i class="fas fa-running" v-if="currentAssessmentStep > 2"></i>
                    <span v-else>2</span>
                  </div>
                  <div class="step-label">Lifestyle</div>
                  <div class="step-description" v-if="currentAssessmentStep === 2">Physical activity & diet</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 3, 'completed': currentAssessmentStep > 3 }"
                  @click="currentAssessmentStep = 3"
                >
                  <div class="step-icon">
                    <i class="fas fa-home" v-if="currentAssessmentStep > 3"></i>
                    <span v-else>3</span>
                  </div>
                  <div class="step-label">Living Situation</div>
                  <div class="step-description" v-if="currentAssessmentStep === 3">Housing & environment</div>
                </div>
                <div 
                  class="progress-step" 
                  :class="{ 'active': currentAssessmentStep >= 4, 'completed': currentAssessmentStep > 4 }"
                  @click="currentAssessmentStep = 4"
                >
                  <div class="step-icon">
                    <i class="fas fa-hands-helping" v-if="currentAssessmentStep > 4"></i>
                    <span v-else>4</span>
                  </div>
                  <div class="step-label">Social Support</div>
                  <div class="step-description" v-if="currentAssessmentStep === 4">Community resources</div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- Wizard Content -->
        <div class="assessment-wizard-content p-4">
          <!-- Medical History Tab Content -->
          <template v-if="activeMedicalTab === 'Medical History'">
            <!-- Step 1: Past Medical History -->
            <div v-if="currentAssessmentStep === 1" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-clipboard-medical mr-2 text-primary"></i>
                Past Medical History
              </h5>
              <p class="text-muted">Record patient's past and current medical conditions.</p>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Common Medical Conditions</h6>
                </div>
                <div class="card-body">
                  <div class="form-group">
                    <div class="condition-checkboxes">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-diabetes" value="Type 2 Diabetes Mellitus" v-model="assessmentForm.pastMedicalHistory.conditions">
                            <label class="custom-control-label" for="condition-diabetes">Type 2 Diabetes Mellitus</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-hypertension" value="Hypertension" v-model="assessmentForm.pastMedicalHistory.conditions">
                            <label class="custom-control-label" for="condition-hypertension">Hypertension</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-asthma" value="Asthma" v-model="assessmentForm.pastMedicalHistory.conditions">
                            <label class="custom-control-label" for="condition-asthma">Asthma</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-pneumonia" value="Pneumonia" v-model="assessmentForm.pastMedicalHistory.conditions">
                            <label class="custom-control-label" for="condition-pneumonia">Pneumonia</label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-arthritis" value="Rheumatoid Arthritis" v-model="assessmentForm.pastMedicalHistory.conditions">
                            <label class="custom-control-label" for="condition-arthritis">Rheumatoid Arthritis</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-heart" value="Coronary Artery Disease" v-model="assessmentForm.pastMedicalHistory.conditions">
                            <label class="custom-control-label" for="condition-heart">Coronary Artery Disease</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-fracture" value="Bone Fracture" v-model="assessmentForm.pastMedicalHistory.conditions">
                            <label class="custom-control-label" for="condition-fracture">Bone Fracture</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="condition-other" value="Other">
                            <label class="custom-control-label" for="condition-other">Other</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Other Condition (if applicable)</label>
                    <input type="text" class="form-control" v-model="assessmentForm.pastMedicalHistory.customCondition" placeholder="Enter condition name">
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Condition Details</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Diagnosis Date</label>
                        <input type="date" class="form-control" v-model="assessmentForm.pastMedicalHistory.diagnosisDate">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Status</label>
                        <select class="form-control" v-model="assessmentForm.pastMedicalHistory.status">
                          <option value="Active">Active</option>
                          <option value="Resolved">Resolved</option>
                          <option value="In Remission">In Remission</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label>Treatment & Management</label>
                    <textarea class="form-control" rows="3" v-model="assessmentForm.pastMedicalHistory.notes" placeholder="Enter details about treatment, management, and any additional information about the condition"></textarea>
                  </div>
                </div>
              </div>

              <div class="alert alert-info">
                <div class="d-flex">
                  <div class="mr-3">
                    <i class="fas fa-info-circle fa-2x"></i>
                  </div>
                  <div>
                    <h6 class="alert-heading mb-1">Important</h6>
                    <p class="mb-0">Please include all relevant medical conditions, even if they are currently resolved. This information helps provide a complete picture of the patient's health history.</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2: Family History -->
            <div v-if="currentAssessmentStep === 2" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-users mr-2 text-primary"></i>
                Family History
              </h5>
              <p class="text-muted">Record patient's family medical history. Add multiple family members to create a comprehensive family health profile.</p>

              <!-- Added Family Members List -->
              <div v-if="assessmentForm.familyHistory.members.length > 0" class="mb-4">
                <h6 class="mb-3">Added Family Members</h6>
                <div class="family-members-list">
                  <div v-for="(member, index) in assessmentForm.familyHistory.members" :key="index" class="family-member-card">
                    <div class="family-member-header">
                      <div class="d-flex align-items-center">
                        <i :class="member.relationship.includes('Mother') || member.relationship.includes('Grandmother') || member.relationship.includes('Sister') ? 'fas fa-female' : 'fas fa-male'" class="family-member-icon"></i>
                        <div>
                          <h6 class="mb-0">{{ member.relationship }} <span v-if="member.age">({{ member.age }} years)</span></h6>
                          <small class="text-muted">{{ member.relationship.includes('Grandfather') || member.relationship.includes('Grandmother') ? 'Extended Family' : 'Immediate Family' }}</small>
                        </div>
                      </div>
                      <div>
                        <span class="badge" :class="member.status === 'Living' ? 'badge-soft-primary' : 'badge-soft-secondary'">{{ member.status }}</span>
                        <button type="button" class="btn btn-sm btn-icon btn-soft-danger ml-2" @click="removeFamilyMember(index)">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <div class="family-member-body">
                      <p v-if="member.conditions.length > 0 || member.customCondition" class="mb-1">
                        <strong>Conditions:</strong> {{ [...member.conditions, member.customCondition].filter(Boolean).join(', ') }}
                      </p>
                      <p v-if="member.notes" class="mb-0">
                        <strong>Notes:</strong> {{ member.notes }}
                      </p>
                      <p v-if="!member.conditions.length && !member.customCondition && !member.notes" class="text-muted mb-0">
                        No conditions or notes specified
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Add New Family Member Form -->
              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Add New Family Member</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Relationship <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="assessmentForm.familyHistory.currentMember.relationship">
                          <option value="">Select relationship</option>
                          <option value="Father">Father</option>
                          <option value="Mother">Mother</option>
                          <option value="Brother">Brother</option>
                          <option value="Sister">Sister</option>
                          <option value="Paternal Grandfather">Paternal Grandfather</option>
                          <option value="Paternal Grandmother">Paternal Grandmother</option>
                          <option value="Maternal Grandfather">Maternal Grandfather</option>
                          <option value="Maternal Grandmother">Maternal Grandmother</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Age</label>
                        <input type="number" class="form-control" v-model="assessmentForm.familyHistory.currentMember.age" placeholder="Enter age">
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Status</label>
                    <select class="form-control" v-model="assessmentForm.familyHistory.currentMember.status">
                      <option value="Living">Living</option>
                      <option value="Deceased">Deceased</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Medical Conditions</label>
                    <div class="condition-checkboxes">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="family-diabetes" value="Diabetes" v-model="assessmentForm.familyHistory.currentMember.conditions">
                            <label class="custom-control-label" for="family-diabetes">Diabetes</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="family-hypertension" value="Hypertension" v-model="assessmentForm.familyHistory.currentMember.conditions">
                            <label class="custom-control-label" for="family-hypertension">Hypertension</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="family-heart" value="Heart Disease" v-model="assessmentForm.familyHistory.currentMember.conditions">
                            <label class="custom-control-label" for="family-heart">Heart Disease</label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="family-cancer" value="Cancer" v-model="assessmentForm.familyHistory.currentMember.conditions">
                            <label class="custom-control-label" for="family-cancer">Cancer</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="family-arthritis" value="Arthritis" v-model="assessmentForm.familyHistory.currentMember.conditions">
                            <label class="custom-control-label" for="family-arthritis">Arthritis</label>
                          </div>
                          <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox" class="custom-control-input" id="family-other" value="Other">
                            <label class="custom-control-label" for="family-other">Other</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Other Condition (if applicable)</label>
                    <input type="text" class="form-control" v-model="assessmentForm.familyHistory.currentMember.customCondition" placeholder="Enter condition name">
                  </div>

                  <div class="form-group">
                    <label>Notes</label>
                    <textarea class="form-control" rows="3" v-model="assessmentForm.familyHistory.currentMember.notes" placeholder="Enter additional details about family history"></textarea>
                  </div>

                  <div class="text-right">
                    <button type="button" class="btn btn-primary" @click="addFamilyMember">
                      <i class="fas fa-plus-circle mr-1"></i> Add Family Member
                    </button>
                  </div>
                </div>
              </div>

              <div class="alert alert-info" v-if="assessmentForm.familyHistory.members.length === 0">
                <i class="fas fa-info-circle mr-2"></i>
                Please add at least one family member to continue.
              </div>
            </div>

            <!-- Step 3: Medication History -->
            <div v-if="currentAssessmentStep === 3" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-pills mr-2 text-primary"></i>
                Medication History
              </h5>
              <p class="text-muted">Record patient's current and past medications, including prescription drugs, over-the-counter medications, and supplements.</p>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Medication Information</h6>
                </div>
                <div class="card-body">
                  <div class="form-group">
                    <label>Medication Name <span class="text-danger">*</span></label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ri-medicine-bottle-line"></i></span>
                      </div>
                      <input type="text" class="form-control" v-model="assessmentForm.medicationHistory.medicationName" placeholder="Enter brand or generic name (e.g., Metformin, Lisinopril)">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Dosage <span class="text-danger">*</span></label>
                        <div class="input-group">
                          <input type="text" class="form-control" v-model="assessmentForm.medicationHistory.dosage" placeholder="e.g., 500mg, 10mg">
                          <div class="input-group-append">
                            <select class="form-control">
                              <option value="mg">mg</option>
                              <option value="mcg">mcg</option>
                              <option value="g">g</option>
                              <option value="ml">ml</option>
                              <option value="units">units</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Frequency <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="assessmentForm.medicationHistory.frequency">
                          <option value="">Select frequency</option>
                          <option value="Once daily">Once daily</option>
                          <option value="Twice daily">Twice daily</option>
                          <option value="Three times daily">Three times daily</option>
                          <option value="Four times daily">Four times daily</option>
                          <option value="Every morning">Every morning</option>
                          <option value="Every evening">Every evening</option>
                          <option value="As needed">As needed (PRN)</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Prescription Details</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Start Date</label>
                        <input type="date" class="form-control" v-model="assessmentForm.medicationHistory.startDate">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>End Date (if applicable)</label>
                        <input type="date" class="form-control" v-model="assessmentForm.medicationHistory.endDate">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Purpose/Indication</label>
                        <input type="text" class="form-control" v-model="assessmentForm.medicationHistory.purpose" placeholder="e.g., Diabetes management, Hypertension">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Prescriber</label>
                        <input type="text" class="form-control" v-model="assessmentForm.medicationHistory.prescriber" placeholder="e.g., Dr. Smith">
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Status</label>
                    <div class="d-flex">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="status-current" name="medication-status" class="custom-control-input" value="Current" v-model="assessmentForm.medicationHistory.status">
                        <label class="custom-control-label" for="status-current">Current</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="status-discontinued" name="medication-status" class="custom-control-input" value="Discontinued" v-model="assessmentForm.medicationHistory.status">
                        <label class="custom-control-label" for="status-discontinued">Discontinued</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Additional Information</h6>
                </div>
                <div class="card-body">
                  <div class="form-group mb-0">
                    <label>Notes</label>
                    <textarea class="form-control" rows="3" v-model="assessmentForm.medicationHistory.notes" placeholder="Enter additional details such as side effects, special instructions, reason for discontinuation, etc."></textarea>
                  </div>
                </div>
              </div>

              <div class="alert alert-warning">
                <div class="d-flex">
                  <div class="mr-3">
                    <i class="fas fa-exclamation-triangle fa-2x"></i>
                  </div>
                  <div>
                    <h6 class="alert-heading mb-1">Medication Accuracy</h6>
                    <p class="mb-0">Please ensure all medication information is accurate and complete. Include all prescription medications, over-the-counter drugs, and supplements the patient is currently taking or has recently discontinued.</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 4: Social History -->
            <div v-if="currentAssessmentStep === 4" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-user-friends mr-2 text-primary"></i>
                Social History
              </h5>
              <p class="text-muted">Record patient's lifestyle and social information.</p>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Tobacco Use</label>
                    <select class="form-control" v-model="assessmentForm.socialHistory.tobaccoUse">
                      <option value="Never">Never</option>
                      <option value="Former">Former</option>
                      <option value="Current">Current</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Alcohol Use</label>
                    <select class="form-control" v-model="assessmentForm.socialHistory.alcoholUse">
                      <option value="Never">Never</option>
                      <option value="Occasional">Occasional</option>
                      <option value="Moderate">Moderate</option>
                      <option value="Heavy">Heavy</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Recreational Drug Use</label>
                    <select class="form-control" v-model="assessmentForm.socialHistory.drugUse">
                      <option value="Never">Never</option>
                      <option value="Former">Former</option>
                      <option value="Current">Current</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Exercise</label>
                    <select class="form-control" v-model="assessmentForm.socialHistory.exercise">
                      <option value="None">None</option>
                      <option value="Light">Light</option>
                      <option value="Moderate">Moderate</option>
                      <option value="Vigorous">Vigorous</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Diet</label>
                <input type="text" class="form-control" v-model="assessmentForm.socialHistory.diet" placeholder="Describe patient's diet">
              </div>

              <div class="form-group">
                <label>Occupation</label>
                <input type="text" class="form-control" v-model="assessmentForm.socialHistory.occupation" placeholder="Enter patient's occupation">
              </div>

              <div class="form-group">
                <label>Living Arrangement</label>
                <input type="text" class="form-control" v-model="assessmentForm.socialHistory.livingArrangement" placeholder="e.g., Lives with spouse">
              </div>

              <div class="form-group">
                <label>Family Support</label>
                <input type="text" class="form-control" v-model="assessmentForm.socialHistory.familySupport" placeholder="Describe patient's support system">
              </div>

              <div class="form-group">
                <label>Notes</label>
                <textarea class="form-control" rows="3" v-model="assessmentForm.socialHistory.notes" placeholder="Enter additional details about social history"></textarea>
              </div>
            </div>
          </template>

          <!-- Physical Examination Tab Content -->
          <template v-else-if="activeMedicalTab === 'Physical Examination'">
            <!-- Step 1: Vital Signs -->
            <div v-if="currentAssessmentStep === 1" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-heartbeat mr-2 text-primary"></i>
                Vital Signs
              </h5>
              <p class="text-muted">Record patient's vital measurements.</p>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Height</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.height" placeholder="e.g., 175">
                      <div class="input-group-append">
                        <span class="input-group-text">cm</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Weight</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.weight" placeholder="e.g., 70">
                      <div class="input-group-append">
                        <span class="input-group-text">kg</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>BMI</label>
                    <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.bmi" placeholder="e.g., 24.5">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Temperature</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.temperature" placeholder="e.g., 37.0">
                      <div class="input-group-append">
                        <span class="input-group-text">°C</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Pulse</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.pulse" placeholder="e.g., 72">
                      <div class="input-group-append">
                        <span class="input-group-text">bpm</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Respiratory Rate</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.respiratoryRate" placeholder="e.g., 16">
                      <div class="input-group-append">
                        <span class="input-group-text">breaths/min</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Blood Pressure</label>
                    <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.bloodPressure" placeholder="e.g., 120/80 mmHg">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Oxygen Saturation</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="assessmentForm.physicalExamination.oxygenSaturation" placeholder="e.g., 98">
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2: System Examination -->
            <div v-if="currentAssessmentStep === 2" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-stethoscope mr-2 text-primary"></i>
                System Examination
              </h5>
              <p class="text-muted">Record findings from physical examination of body systems.</p>

              <div class="form-group">
                <label>General Appearance</label>
                <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.generalAppearance" placeholder="Describe patient's general appearance"></textarea>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Skin</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.skin" placeholder="Describe skin findings"></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>HEENT (Head, Eyes, Ears, Nose, Throat)</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.heent" placeholder="Describe HEENT findings"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Neck</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.neck" placeholder="Describe neck findings"></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Cardiovascular</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.cardiovascular" placeholder="Describe cardiovascular findings"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Respiratory</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.respiratory" placeholder="Describe respiratory findings"></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Gastrointestinal</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.gastrointestinal" placeholder="Describe gastrointestinal findings"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Musculoskeletal</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.musculoskeletal" placeholder="Describe musculoskeletal findings"></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Neurological</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.neurological" placeholder="Describe neurological findings"></textarea>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Psychiatric</label>
                <textarea class="form-control" rows="2" v-model="assessmentForm.physicalExamination.psychiatric" placeholder="Describe psychiatric findings"></textarea>
              </div>
            </div>

            <!-- Step 3: Assessment -->
            <div v-if="currentAssessmentStep === 3" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-clipboard-list mr-2 text-primary"></i>
                Assessment & Recommendations
              </h5>
              <p class="text-muted">Provide assessment and recommendations based on physical examination.</p>

              <div class="form-group">
                <label>Assessment Notes</label>
                <textarea class="form-control" rows="5" v-model="assessmentForm.physicalExamination.notes" placeholder="Enter assessment findings, diagnosis, and recommendations"></textarea>
              </div>
            </div>
          </template>

          <!-- Social & Environmental Tab Content -->
          <template v-else-if="activeMedicalTab === 'Social & Environmental'">
            <!-- Step 1: Occupation -->
            <div v-if="currentAssessmentStep === 1" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-briefcase mr-2 text-primary"></i>
                Occupation
              </h5>
              <p class="text-muted">Record patient's occupational information and related health factors.</p>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-gradient-primary-soft">
                  <h6 class="mb-0 text-primary">Current Employment</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Occupation <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="assessmentForm.socialEnvironmental.occupation" placeholder="e.g., Software Engineer">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Employer</label>
                        <input type="text" class="form-control" placeholder="e.g., TechSolutions Inc.">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Employment Status</label>
                        <select class="form-control" v-model="assessmentForm.socialEnvironmental.employmentStatus">
                          <option value="Full-time">Full-time</option>
                          <option value="Part-time">Part-time</option>
                          <option value="Self-employed">Self-employed</option>
                          <option value="Unemployed">Unemployed</option>
                          <option value="Retired">Retired</option>
                          <option value="Student">Student</option>
                          <option value="Disabled">Disabled</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Duration</label>
                        <div class="input-group">
                          <input type="number" class="form-control" placeholder="e.g., 5">
                          <div class="input-group-append">
                            <span class="input-group-text">years</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Work Schedule</label>
                        <select class="form-control">
                          <option value="Full-time">Full-time (40 hours/week)</option>
                          <option value="Part-time">Part-time (&lt; 40 hours/week)</option>
                          <option value="Shift work">Shift work</option>
                          <option value="Flexible">Flexible hours</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Work Setting</label>
                        <select class="form-control">
                          <option value="Office">Office</option>
                          <option value="Remote">Remote</option>
                          <option value="Hybrid">Office/Remote Hybrid</option>
                          <option value="Field">Field work</option>
                          <option value="Factory">Factory/Manufacturing</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label>Job Satisfaction</label>
                    <div class="d-flex align-items-center">
                      <div class="satisfaction-meter" style="width: 70%; height: 10px; background-color: #e9ecef; border-radius: 5px; overflow: hidden; margin-right: 10px;">
                        <div class="satisfaction-level" style="width: 80%; height: 100%; background-color: #556ee6; border-radius: 5px;"></div>
                      </div>
                      <select class="form-control" style="width: 120px;">
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High" selected>High</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-gradient-warning-soft">
                  <h6 class="mb-0 text-warning">Occupational Health Factors</h6>
                </div>
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="health-factor-item d-flex justify-content-between align-items-center p-2 bg-light rounded mb-2">
                        <div class="d-flex align-items-center">
                          <div class="health-factor-icon-container primary" style="width: 36px; height: 36px; border-radius: 50%; background-color: rgba(85, 110, 230, 0.1); display: flex; align-items: center; justify-content: center; margin-right: 10px;">
                            <i class="ri-chair-line health-factor-icon text-primary"></i>
                          </div>
                          <div>
                            <h6 class="mb-0 font-size-14">Sedentary Work</h6>
                            <p class="mb-0 text-muted small">Prolonged sitting at computer</p>
                          </div>
                        </div>
                        <div class="health-factor-risk">
                          <select class="form-control form-control-sm">
                            <option value="Low">Low Risk</option>
                            <option value="Moderate" selected>Moderate Risk</option>
                            <option value="High">High Risk</option>
                          </select>
                        </div>
                      </div>

                      <div class="health-factor-item d-flex justify-content-between align-items-center p-2 bg-light rounded mb-2">
                        <div class="d-flex align-items-center">
                          <div class="health-factor-icon-container info" style="width: 36px; height: 36px; border-radius: 50%; background-color: rgba(80, 165, 241, 0.1); display: flex; align-items: center; justify-content: center; margin-right: 10px;">
                            <i class="ri-eye-line health-factor-icon text-info"></i>
                          </div>
                          <div>
                            <h6 class="mb-0 font-size-14">Screen Time</h6>
                            <p class="mb-0 text-muted small">8+ hours daily of screen exposure</p>
                          </div>
                        </div>
                        <div class="health-factor-risk">
                          <select class="form-control form-control-sm">
                            <option value="Low">Low Risk</option>
                            <option value="Moderate" selected>Moderate Risk</option>
                            <option value="High">High Risk</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="health-factor-item d-flex justify-content-between align-items-center p-2 bg-light rounded mb-2">
                        <div class="d-flex align-items-center">
                          <div class="health-factor-icon-container danger" style="width: 36px; height: 36px; border-radius: 50%; background-color: rgba(244, 106, 106, 0.1); display: flex; align-items: center; justify-content: center; margin-right: 10px;">
                            <i class="ri-mental-health-line health-factor-icon text-danger"></i>
                          </div>
                          <div>
                            <h6 class="mb-0 font-size-14">Mental Stress</h6>
                            <p class="mb-0 text-muted small">Project deadlines and challenges</p>
                          </div>
                        </div>
                        <div class="health-factor-risk">
                          <select class="form-control form-control-sm">
                            <option value="Low">Low Risk</option>
                            <option value="Moderate">Moderate Risk</option>
                            <option value="High" selected>High Risk</option>
                          </select>
                        </div>
                      </div>

                      <div class="health-factor-item d-flex justify-content-between align-items-center p-2 bg-light rounded mb-2">
                        <div class="d-flex align-items-center">
                          <div class="health-factor-icon-container success" style="width: 36px; height: 36px; border-radius: 50%; background-color: rgba(52, 195, 143, 0.1); display: flex; align-items: center; justify-content: center; margin-right: 10px;">
                            <i class="ri-hand-line health-factor-icon text-success"></i>
                          </div>
                          <div>
                            <h6 class="mb-0 font-size-14">Repetitive Strain</h6>
                            <p class="mb-0 text-muted small">Keyboard and mouse use</p>
                          </div>
                        </div>
                        <div class="health-factor-risk">
                          <select class="form-control form-control-sm">
                            <option value="Low" selected>Low Risk</option>
                            <option value="Moderate">Moderate Risk</option>
                            <option value="High">High Risk</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label>Additional Work-Related Health Concerns</label>
                    <textarea class="form-control" rows="2" placeholder="Describe any additional health concerns related to occupation"></textarea>
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm">
                <div class="card-header bg-gradient-info-soft">
                  <h6 class="mb-0 text-info">Recommendations</h6>
                </div>
                <div class="card-body">
                  <div class="recommendation-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 15px;">
                    <div class="custom-control custom-checkbox mb-2">
                      <input type="checkbox" class="custom-control-input" id="rec-ergonomic" checked>
                      <label class="custom-control-label font-weight-bold" for="rec-ergonomic">Ergonomic Setup</label>
                      <p class="text-muted small ml-4 mb-0">Use ergonomic chair and desk setup to minimize back strain</p>
                    </div>

                    <div class="custom-control custom-checkbox mb-2">
                      <input type="checkbox" class="custom-control-input" id="rec-eye" checked>
                      <label class="custom-control-label font-weight-bold" for="rec-eye">Eye Care</label>
                      <p class="text-muted small ml-4 mb-0">Take regular breaks using the 20-20-20 rule for eye strain</p>
                    </div>

                    <div class="custom-control custom-checkbox mb-2">
                      <input type="checkbox" class="custom-control-input" id="rec-movement" checked>
                      <label class="custom-control-label font-weight-bold" for="rec-movement">Movement Breaks</label>
                      <p class="text-muted small ml-4 mb-0">Incorporate standing periods throughout workday</p>
                    </div>

                    <div class="custom-control custom-checkbox mb-2">
                      <input type="checkbox" class="custom-control-input" id="rec-stress" checked>
                      <label class="custom-control-label font-weight-bold" for="rec-stress">Stress Management</label>
                      <p class="text-muted small ml-4 mb-0">Practice mindfulness or brief meditation during work breaks</p>
                    </div>

                    <div class="custom-control custom-checkbox mb-2">
                      <input type="checkbox" class="custom-control-input" id="rec-wrist" checked>
                      <label class="custom-control-label font-weight-bold" for="rec-wrist">Wrist Protection</label>
                      <p class="text-muted small ml-4 mb-0">Consider wrist supports and ergonomic keyboard/mouse</p>
                    </div>
                  </div>

                  <div class="form-group mt-3 mb-0">
                    <label>Additional Recommendations</label>
                    <textarea class="form-control" rows="2" placeholder="Enter any additional recommendations"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2: Lifestyle -->
            <div v-if="currentAssessmentStep === 2" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-running mr-2 text-primary"></i>
                Lifestyle
              </h5>
              <p class="text-muted">Record patient's lifestyle factors that may impact health.</p>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-gradient-success-soft">
                  <h6 class="mb-0 text-success">Physical Activity</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Activity Level</label>
                        <div class="d-flex align-items-center">
                          <div class="progress activity-progress" style="flex-grow: 1; height: 10px; background-color: #e9ecef; border-radius: 5px; overflow: hidden; margin-right: 10px;">
                            <div class="progress-bar bg-warning" role="progressbar" style="width: 40%" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <select class="form-control" style="width: 120px;">
                            <option value="Sedentary">Sedentary</option>
                            <option value="Light">Light</option>
                            <option value="Moderate" selected>Moderate</option>
                            <option value="Active">Active</option>
                            <option value="Very Active">Very Active</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Weekly Exercise Duration</label>
                        <div class="input-group">
                          <input type="number" class="form-control" value="90" placeholder="e.g., 150">
                          <div class="input-group-append">
                            <span class="input-group-text">minutes</span>
                          </div>
                        </div>
                        <small class="text-warning">Below recommended 150 minutes/week</small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Activity Types</label>
                    <div class="activity-types-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 10px;">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="activity-walking" checked>
                        <label class="custom-control-label" for="activity-walking">
                          <i class="fas fa-walking text-primary mr-1"></i> Walking
                        </label>
                        <small class="d-block text-muted ml-4">3x weekly, 30 min</small>
                      </div>

                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="activity-swimming" checked>
                        <label class="custom-control-label" for="activity-swimming">
                          <i class="fas fa-swimming-pool text-info mr-1"></i> Swimming
                        </label>
                        <small class="d-block text-muted ml-4">1x weekly, 45 min</small>
                      </div>

                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="activity-cycling">
                        <label class="custom-control-label" for="activity-cycling">
                          <i class="fas fa-biking text-success mr-1"></i> Cycling
                        </label>
                        <small class="d-block text-muted ml-4">Occasional</small>
                      </div>

                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="activity-strength">
                        <label class="custom-control-label" for="activity-strength">
                          <i class="fas fa-dumbbell text-danger mr-1"></i> Strength Training
                        </label>
                      </div>

                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="activity-yoga">
                        <label class="custom-control-label" for="activity-yoga">
                          <i class="fas fa-pray text-warning mr-1"></i> Yoga/Stretching
                        </label>
                      </div>

                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="activity-other">
                        <label class="custom-control-label" for="activity-other">
                          <i class="fas fa-plus-circle text-secondary mr-1"></i> Other
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label>Daily Steps</label>
                    <div class="input-group">
                      <input type="number" class="form-control" value="5200" placeholder="e.g., 8000">
                      <div class="input-group-append">
                        <span class="input-group-text">steps/day</span>
                      </div>
                    </div>
                    <small class="text-warning">Below target of 10,000 steps/day</small>
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-gradient-info-soft">
                  <h6 class="mb-0 text-info">Nutrition & Diet</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Diet Quality</label>
                        <div class="d-flex align-items-center">
                          <div class="progress diet-progress" style="flex-grow: 1; height: 10px; background-color: #e9ecef; border-radius: 5px; overflow: hidden; margin-right: 10px;">
                            <div class="progress-bar bg-warning" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <select class="form-control" style="width: 120px;">
                            <option value="Poor">Poor</option>
                            <option value="Fair" selected>Fair</option>
                            <option value="Good">Good</option>
                            <option value="Excellent">Excellent</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Diet Type</label>
                        <select class="form-control">
                          <option value="Regular">Regular/No restrictions</option>
                          <option value="Diabetic" selected>Diabetic</option>
                          <option value="Low Sodium">Low Sodium</option>
                          <option value="Low Fat">Low Fat</option>
                          <option value="Vegetarian">Vegetarian</option>
                          <option value="Vegan">Vegan</option>
                          <option value="Gluten Free">Gluten Free</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Fruits & Vegetables Intake</label>
                        <select class="form-control">
                          <option value="0-1">0-1 servings/day</option>
                          <option value="2-3" selected>2-3 servings/day</option>
                          <option value="4-5">4-5 servings/day</option>
                          <option value="6+">6+ servings/day</option>
                        </select>
                        <small class="text-warning">Below recommended 5+ servings/day</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Water Intake</label>
                        <div class="input-group">
                          <input type="number" class="form-control" value="6" placeholder="e.g., 8">
                          <div class="input-group-append">
                            <span class="input-group-text">cups/day</span>
                          </div>
                        </div>
                        <small class="text-warning">Below recommended 8 cups/day</small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label>Dietary Challenges</label>
                    <textarea class="form-control" rows="2">Struggles with consistent carbohydrate control. Tends to snack in the evenings.</textarea>
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm">
                <div class="card-header bg-gradient-purple-soft">
                  <h6 class="mb-0 text-purple" style="color: #6b5eae;">Sleep & Stress</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Sleep Quality</label>
                        <div class="d-flex align-items-center">
                          <div class="progress sleep-progress" style="flex-grow: 1; height: 10px; background-color: #e9ecef; border-radius: 5px; overflow: hidden; margin-right: 10px;">
                            <div class="progress-bar bg-info" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <select class="form-control" style="width: 120px;">
                            <option value="Poor">Poor</option>
                            <option value="Fair">Fair</option>
                            <option value="Good" selected>Good</option>
                            <option value="Excellent">Excellent</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Average Sleep Duration</label>
                        <div class="input-group">
                          <input type="number" class="form-control" value="7.2" step="0.1" placeholder="e.g., 7.5">
                          <div class="input-group-append">
                            <span class="input-group-text">hours/night</span>
                          </div>
                        </div>
                        <small class="text-success">Within recommended 7-9 hours/night</small>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Sleep Issues</label>
                        <div class="sleep-issues-grid" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 5px;">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="sleep-falling">
                            <label class="custom-control-label" for="sleep-falling">Difficulty falling asleep</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="sleep-staying" checked>
                            <label class="custom-control-label" for="sleep-staying">Difficulty staying asleep</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="sleep-early">
                            <label class="custom-control-label" for="sleep-early">Early morning awakening</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="sleep-snoring">
                            <label class="custom-control-label" for="sleep-snoring">Snoring</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="sleep-apnea">
                            <label class="custom-control-label" for="sleep-apnea">Sleep apnea</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="sleep-other">
                            <label class="custom-control-label" for="sleep-other">Other</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Stress Level</label>
                        <div class="d-flex align-items-center">
                          <div class="progress stress-progress" style="flex-grow: 1; height: 10px; background-color: #e9ecef; border-radius: 5px; overflow: hidden; margin-right: 10px;">
                            <div class="progress-bar bg-danger" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <select class="form-control" style="width: 120px;">
                            <option value="Low">Low</option>
                            <option value="Moderate">Moderate</option>
                            <option value="High" selected>High</option>
                            <option value="Very High">Very High</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Primary Stress Sources</label>
                        <div class="stress-sources-grid" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 5px;">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="stress-work" checked>
                            <label class="custom-control-label" for="stress-work">Work</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="stress-financial" checked>
                            <label class="custom-control-label" for="stress-financial">Financial</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="stress-family">
                            <label class="custom-control-label" for="stress-family">Family</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="stress-health">
                            <label class="custom-control-label" for="stress-health">Health</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="stress-social">
                            <label class="custom-control-label" for="stress-social">Social</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="stress-other">
                            <label class="custom-control-label" for="stress-other">Other</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Stress Management Techniques</label>
                        <textarea class="form-control" rows="3" placeholder="Describe stress management techniques used">Occasional exercise. No regular stress management routine.</textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 3: Living Situation -->
            <div v-if="currentAssessmentStep === 3" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-home mr-2 text-primary"></i>
                Living Situation
              </h5>
              <p class="text-muted">Record patient's living environment and related factors.</p>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Housing Status</label>
                    <select class="form-control" v-model="assessmentForm.socialEnvironmental.housingStatus">
                      <option value="Own">Own</option>
                      <option value="Rent">Rent</option>
                      <option value="Temporary">Temporary</option>
                      <option value="Homeless">Homeless</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Living Arrangement</label>
                    <select class="form-control" v-model="assessmentForm.socialEnvironmental.livingArrangement">
                      <option value="Alone">Lives Alone</option>
                      <option value="With Spouse/Partner">With Spouse/Partner</option>
                      <option value="With Family">With Family</option>
                      <option value="With Roommates">With Roommates</option>
                      <option value="Assisted Living">Assisted Living</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Transportation Access</label>
                    <select class="form-control" v-model="assessmentForm.socialEnvironmental.transportationAccess">
                      <option value="Own Vehicle">Own Vehicle</option>
                      <option value="Public Transportation">Public Transportation</option>
                      <option value="Relies on Others">Relies on Others</option>
                      <option value="Limited Access">Limited Access</option>
                      <option value="No Access">No Access</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Food Security</label>
                    <select class="form-control" v-model="assessmentForm.socialEnvironmental.foodSecurity">
                      <option value="High">High</option>
                      <option value="Marginal">Marginal</option>
                      <option value="Low">Low</option>
                      <option value="Very Low">Very Low</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Safety Risks</label>
                <textarea class="form-control" rows="2" v-model="assessmentForm.socialEnvironmental.safetyRisks" placeholder="Describe any safety risks in the home environment"></textarea>
              </div>

              <div class="form-group">
                <label>Environmental Exposures</label>
                <textarea class="form-control" rows="2" v-model="assessmentForm.socialEnvironmental.environmentalExposures" placeholder="Describe any environmental exposures (e.g., mold, lead, etc.)"></textarea>
              </div>
            </div>

            <!-- Step 4: Social Support -->
            <div v-if="currentAssessmentStep === 4" class="assessment-step">
              <h5 class="step-title">
                <i class="fas fa-hands-helping mr-2 text-primary"></i>
                Social Support
              </h5>
              <p class="text-muted">Record patient's social support network and community engagement.</p>

              <div class="form-group">
                <label>Social Support</label>
                <select class="form-control" v-model="assessmentForm.socialEnvironmental.socialSupport">
                  <option value="Strong">Strong</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Limited">Limited</option>
                  <option value="None">None</option>
                </select>
              </div>

              <!-- Added Support Persons List -->
              <div v-if="assessmentForm.socialEnvironmental.supportPersons.length > 0" class="mb-4">
                <h6 class="mb-3">Primary Support Persons</h6>
                <div class="family-members-list">
                  <div v-for="(person, index) in assessmentForm.socialEnvironmental.supportPersons" :key="index" class="family-member-card">
                    <div class="family-member-header">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-user-friends family-member-icon"></i>
                        <div>
                          <h6 class="mb-0">{{ person.name }}</h6>
                          <small class="text-muted">{{ person.relationship }} | {{ person.mobile }}</small>
                        </div>
                      </div>
                      <div>
                        <span class="badge badge-soft-primary">{{ person.frequency }}</span>
                        <button type="button" class="btn btn-sm btn-icon btn-soft-danger ml-2" @click="removeSupportPerson(index)">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <div class="family-member-body">
                      <div class="support-types mb-2" v-if="person.mealPreparation || person.emergencyContact || person.transportation || person.homeMaintenance">
                        <strong>Support Types:</strong>
                        <div class="d-flex flex-wrap mt-1">
                          <span v-if="person.mealPreparation" class="badge badge-soft-success mr-1 mb-1">Meal Preparation</span>
                          <span v-if="person.emergencyContact" class="badge badge-soft-danger mr-1 mb-1">Emergency Contact</span>
                          <span v-if="person.transportation" class="badge badge-soft-info mr-1 mb-1">Transportation</span>
                          <span v-if="person.homeMaintenance" class="badge badge-soft-warning mr-1 mb-1">Home Maintenance</span>
                        </div>
                      </div>
                      <p v-if="person.notes" class="mb-0">
                        <strong>Notes:</strong> {{ person.notes }}
                      </p>
                      <p v-if="!person.notes && !person.mealPreparation && !person.emergencyContact && !person.transportation && !person.homeMaintenance" class="text-muted mb-0">
                        No support types or notes specified
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Add New Support Person Form -->
              <div class="card border-0 shadow-sm mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Add Primary Support Person</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.name" placeholder="Enter name">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Relationship <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.relationship">
                          <option value="">Select relationship</option>
                          <option value="Spouse">Spouse</option>
                          <option value="Child">Child</option>
                          <option value="Parent">Parent</option>
                          <option value="Sibling">Sibling</option>
                          <option value="Friend">Friend</option>
                          <option value="Caregiver">Caregiver</option>
                          <option value="Neighbor">Neighbor</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Mobile</label>
                        <input type="text" class="form-control" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.mobile" placeholder="Enter mobile number">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Contact Frequency</label>
                        <select class="form-control" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.frequency">
                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Support Type</label>
                    <div class="support-types-grid" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="support-meal" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.mealPreparation">
                        <label class="custom-control-label" for="support-meal">Meal Preparation</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="support-emergency" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.emergencyContact">
                        <label class="custom-control-label" for="support-emergency">Emergency Contact</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="support-transportation" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.transportation">
                        <label class="custom-control-label" for="support-transportation">Transportation</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="support-home" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.homeMaintenance">
                        <label class="custom-control-label" for="support-home">Home Maintenance</label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label>Notes</label>
                    <textarea class="form-control" rows="2" v-model="assessmentForm.socialEnvironmental.currentSupportPerson.notes" placeholder="Enter any additional notes about this support person"></textarea>
                  </div>

                  <div class="text-right mt-3">
                    <button type="button" class="btn btn-primary" @click="addSupportPerson">
                      <i class="fas fa-plus mr-1"></i> Add Support Person
                    </button>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Community Engagement</label>
                <select class="form-control" v-model="assessmentForm.socialEnvironmental.communityEngagement">
                  <option value="Active">Active</option>
                  <option value="Occasional">Occasional</option>
                  <option value="Minimal">Minimal</option>
                  <option value="None">None</option>
                </select>
              </div>

              <div class="form-group">
                <label>Community Resources Used</label>
                <textarea class="form-control" rows="2" placeholder="List community resources used (e.g., church, senior center, etc.)"></textarea>
              </div>

              <div class="form-group">
                <label>Financial Stability</label>
                <select class="form-control" v-model="assessmentForm.socialEnvironmental.financialStability">
                  <option value="Stable">Stable</option>
                  <option value="Occasionally Unstable">Occasionally Unstable</option>
                  <option value="Frequently Unstable">Frequently Unstable</option>
                  <option value="Chronically Unstable">Chronically Unstable</option>
                </select>
              </div>

              <div class="form-group">
                <label>Education Level</label>
                <select class="form-control" v-model="assessmentForm.socialEnvironmental.educationLevel">
                  <option value="Less than High School">Less than High School</option>
                  <option value="High School/GED">High School/GED</option>
                  <option value="Some College">Some College</option>
                  <option value="Associate's Degree">Associate's Degree</option>
                  <option value="Bachelor's Degree">Bachelor's Degree</option>
                  <option value="Graduate Degree">Graduate Degree</option>
                </select>
              </div>

              <div class="form-group">
                <label>Additional Notes</label>
                <textarea class="form-control" rows="3" v-model="assessmentForm.socialEnvironmental.notes" placeholder="Enter additional notes about social and environmental factors"></textarea>
              </div>

              <!-- Support Network Overview -->
              <div class="card border-0 shadow-sm mt-4">
                <div class="card-header bg-gradient-primary-soft">
                  <h6 class="mb-0 text-primary">Support Network Overview</h6>
                </div>
                <div class="card-body">
                  <div class="row mb-4">
                    <div class="col-md-4 text-center">
                      <div class="support-score-container">
                        <div class="support-score">
                          <span class="score-value">{{ assessmentForm.socialEnvironmental.supportScore }}</span>
                        </div>
                        <h6 class="mt-2 mb-0">Support Score</h6>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="support-rating-item">
                            <label>Family Support:</label>
                            <select class="form-control" v-model="assessmentForm.socialEnvironmental.familySupport">
                              <option value="Excellent">Excellent</option>
                              <option value="Good">Good</option>
                              <option value="Fair">Fair</option>
                              <option value="Poor">Poor</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="support-rating-item">
                            <label>Community Support:</label>
                            <select class="form-control" v-model="assessmentForm.socialEnvironmental.communitySupport">
                              <option value="Excellent">Excellent</option>
                              <option value="Good">Good</option>
                              <option value="Fair">Fair</option>
                              <option value="Poor">Poor</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="support-rating-item">
                            <label>Professional Support:</label>
                            <select class="form-control" v-model="assessmentForm.socialEnvironmental.professionalSupport">
                              <option value="Excellent">Excellent</option>
                              <option value="Good">Good</option>
                              <option value="Fair">Fair</option>
                              <option value="Poor">Poor</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Summary Assessment</label>
                    <textarea class="form-control" rows="3" v-model="assessmentForm.socialEnvironmental.summaryAssessment" placeholder="Provide a summary assessment of the patient's support network"></textarea>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Key Strengths</label>
                        <div class="key-strengths-container">
                          <div v-for="(strength, index) in assessmentForm.socialEnvironmental.keyStrengths" :key="'strength-'+index" class="input-group mb-2">
                            <input type="text" class="form-control" v-model="assessmentForm.socialEnvironmental.keyStrengths[index]" placeholder="Enter a key strength">
                            <div class="input-group-append">
                              <button class="btn btn-outline-danger" type="button" @click="assessmentForm.socialEnvironmental.keyStrengths.splice(index, 1)">
                                <i class="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                          <button class="btn btn-sm btn-outline-primary" @click="assessmentForm.socialEnvironmental.keyStrengths.push('')">
                            <i class="fas fa-plus mr-1"></i> Add Strength
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Potential Gaps</label>
                        <div class="potential-gaps-container">
                          <div v-for="(gap, index) in assessmentForm.socialEnvironmental.potentialGaps" :key="'gap-'+index" class="input-group mb-2">
                            <input type="text" class="form-control" v-model="assessmentForm.socialEnvironmental.potentialGaps[index]" placeholder="Enter a potential gap">
                            <div class="input-group-append">
                              <button class="btn btn-outline-danger" type="button" @click="assessmentForm.socialEnvironmental.potentialGaps.splice(index, 1)">
                                <i class="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                          <button class="btn btn-sm btn-outline-primary" @click="assessmentForm.socialEnvironmental.potentialGaps.push('')">
                            <i class="fas fa-plus mr-1"></i> Add Gap
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="recommendations-section mt-3">
                    <label>Recommendations</label>
                    <div class="card border-0 bg-light">
                      <div class="card-body">
                        <div class="form-group">
                          <label>Caregiver Support</label>
                          <textarea class="form-control" rows="2" v-model="assessmentForm.socialEnvironmental.recommendations.caregiverSupport" placeholder="Recommendations for caregiver support"></textarea>
                        </div>
                        <div class="form-group">
                          <label>Transportation Resources</label>
                          <textarea class="form-control" rows="2" v-model="assessmentForm.socialEnvironmental.recommendations.transportationResources" placeholder="Recommendations for transportation resources"></textarea>
                        </div>
                        <div class="form-group">
                          <label>Social Engagement</label>
                          <textarea class="form-control" rows="2" v-model="assessmentForm.socialEnvironmental.recommendations.socialEngagement" placeholder="Recommendations for social engagement"></textarea>
                        </div>
                        <div class="form-group mb-0">
                          <label>Technology Support</label>
                          <textarea class="form-control" rows="2" v-model="assessmentForm.socialEnvironmental.recommendations.technologySupport" placeholder="Recommendations for technology support"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- Wizard Footer -->
        <div class="assessment-wizard-footer p-3">
          <div class="d-flex justify-content-between align-items-center">
            <!-- Step Information -->
            <div class="step-info d-none d-md-block" v-if="activeMedicalTab === 'Social & Environmental'">
              <div class="step-name font-weight-bold">
                <span v-if="currentAssessmentStep === 1">Occupation</span>
                <span v-else-if="currentAssessmentStep === 2">Lifestyle</span>
                <span v-else-if="currentAssessmentStep === 3">Living Situation</span>
                <span v-else-if="currentAssessmentStep === 4">Social Support</span>
              </div>
              <div class="step-counter text-muted small">
                Step {{ currentAssessmentStep }} of 4
              </div>
            </div>

            <!-- Navigation Buttons -->
            <div class="d-flex">
              <button 
                class="btn btn-outline-secondary mr-2" 
                @click="currentAssessmentStep > 1 ? currentAssessmentStep-- : showAssessmentModal = false"
              >
                <i class="fas fa-arrow-left mr-1"></i>
                {{ currentAssessmentStep > 1 ? 'Previous' : 'Cancel' }}
              </button>

              <button 
                class="btn btn-primary" 
                @click="currentAssessmentStep < getMaxSteps() ? currentAssessmentStep++ : saveAssessment()"
              >
                <span v-if="currentAssessmentStep < getMaxSteps()">
                  Next: 
                  <span v-if="activeMedicalTab === 'Social & Environmental'">
                    <span v-if="currentAssessmentStep === 1">Lifestyle</span>
                    <span v-else-if="currentAssessmentStep === 2">Living Situation</span>
                    <span v-else-if="currentAssessmentStep === 3">Social Support</span>
                  </span>
                </span>
                <span v-else>Complete Assessment</span>
                <i class="fas ml-1" :class="currentAssessmentStep < getMaxSteps() ? 'fa-arrow-right' : 'fa-check-circle'"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Assessment Details Modal -->
    <b-modal
      v-model="showAssessmentDetailsModal"
      :title="selectedAssessment ? 'Assessment Details: ' + selectedAssessment.type : 'Assessment Details'"
      size="xl"
      hide-footer
      header-class="bg-primary text-white"
      body-class="p-0"
    >
      <div class="assessment-details-modal">
        <!-- Header with assessment info -->
        <div class="p-3 bg-light border-bottom">
          <div class="d-flex justify-content-between align-items-center">
            <div v-if="selectedAssessment">
              <h5 class="mb-1">{{ selectedAssessment.type }} Assessment</h5>
              <div class="d-flex align-items-center">
                <span class="mr-3"><i class="ri-calendar-line mr-1"></i> {{ selectedAssessment.date }}</span>
                <span class="mr-3"><i class="ri-user-line mr-1"></i> {{ selectedAssessment.provider }}</span>
                <span :class="[
                  'badge rounded-pill px-2 py-1',
                  selectedAssessment.status === 'Completed' ? 'bg-soft-success text-success' : 
                  selectedAssessment.status === 'In Progress' ? 'bg-soft-warning text-warning' : 
                  'bg-soft-danger text-danger'
                ]">
                  {{ selectedAssessment.status }}
                </span>
              </div>
            </div>
            <button class="btn btn-sm btn-light" @click="showAssessmentDetailsModal = false">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </div>

        <!-- Assessment/Screening Content -->
        <div class="p-3">
          <!-- Nested Tabs for Assessment/Screening -->
          <b-tabs content-class="p-4 text-muted" justified nav-class="medical-main-tabs" class="medical-tabs-container">
            <b-tab title="Medical History" title-link-class="medical-main-tab" active>
              <template v-slot:title>
                <div class="medical-tab-title">
                  <i class="fas fa-notes-medical medical-tab-icon"></i>
                  <span>Medical History</span>
                </div>
              </template>
              <div class="medical-nested-container">
                <b-tabs
                    vertical
                    nav-class="medical-nested-tabs"
                    nav-wrapper-class="col-sm-3"
                    content-class="pt-0 px-3 text-muted medical-nested-content"
                >
                  <b-tab title="Past Medical History" active title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-history medical-nested-tab-icon"></i>
                        <span>Past Medical History</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="medical-history-container">
                        <div class="medical-history-header">
                          <i class="fas fa-clipboard-medical medical-history-icon"></i>
                          <h5>Patient Medical History</h5>
                        </div>
                        <div class="medical-history-content">
                          <div class="medical-history-filters mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <span class="badge badge-soft-primary mr-2">All</span>
                                <span class="badge badge-soft-secondary mr-2">Active</span>
                                <span class="badge badge-soft-secondary">Resolved</span>
                              </div>
                              <div>
                                <select class="form-control form-control-sm custom-select border-0 bg-soft-light">
                                  <option>Sort by Date</option>
                                  <option>Sort by Name</option>
                                  <option>Sort by Status</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <ul class="list-unstyled medical-history-list">
                            <li class="medical-history-item active">
                              <div class="medical-history-item-header">
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-heartbeat medical-history-item-icon text-danger"></i>
                                  <div>
                                    <h6 class="mb-0">Type 2 Diabetes Mellitus</h6>
                                    <small class="text-muted">Diagnosed: Jan 15, 2020</small>
                                  </div>
                                </div>
                                <span class="badge badge-soft-danger">Active</span>
                              </div>
                              <div class="medical-history-item-body">
                                <p class="mb-1">Patient diagnosed with Type 2 Diabetes Mellitus. Currently managed with oral medications and lifestyle modifications.</p>
                                <div class="d-flex align-items-center mt-2">
                                  <span class="badge badge-soft-info mr-2">HbA1c: 7.2%</span>
                                  <span class="badge badge-soft-warning mr-2">Medication: Metformin</span>
                                  <span class="badge badge-soft-primary">Follow-up: Monthly</span>
                                </div>
                              </div>
                            </li>
                            <li class="medical-history-item active">
                              <div class="medical-history-item-header">
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-heart medical-history-item-icon text-danger"></i>
                                  <div>
                                    <h6 class="mb-0">Hypertension</h6>
                                    <small class="text-muted">Diagnosed: Mar 22, 2019</small>
                                  </div>
                                </div>
                                <span class="badge badge-soft-danger">Active</span>
                              </div>
                              <div class="medical-history-item-body">
                                <p class="mb-1">Essential hypertension, well-controlled with medication. Regular monitoring required.</p>
                                <div class="d-flex align-items-center mt-2">
                                  <span class="badge badge-soft-info mr-2">BP: 135/85 mmHg</span>
                                  <span class="badge badge-soft-warning mr-2">Medication: Lisinopril</span>
                                  <span class="badge badge-soft-primary">Follow-up: Quarterly</span>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Family History" title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-users medical-nested-tab-icon"></i>
                        <span>Family History</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="family-history-container">
                        <div class="family-history-header">
                          <i class="fas fa-users medical-history-icon"></i>
                          <h5>Family Medical History</h5>
                        </div>
                        <div class="family-history-content">
                          <ul class="list-unstyled family-history-list">
                            <li class="family-history-item">
                              <div class="family-history-item-header">
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-user family-history-item-icon text-primary"></i>
                                  <div>
                                    <h6 class="mb-0">Father</h6>
                                    <small class="text-muted">Age: 68</small>
                                  </div>
                                </div>
                              </div>
                              <div class="family-history-item-body">
                                <p class="mb-1">History of Type 2 Diabetes (diagnosed at age 55) and Hypertension (diagnosed at age 50).</p>
                                <div class="d-flex align-items-center mt-2">
                                  <span class="badge badge-soft-danger mr-2">Diabetes</span>
                                  <span class="badge badge-soft-danger mr-2">Hypertension</span>
                                </div>
                              </div>
                            </li>
                            <li class="family-history-item">
                              <div class="family-history-item-header">
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-user family-history-item-icon text-info"></i>
                                  <div>
                                    <h6 class="mb-0">Mother</h6>
                                    <small class="text-muted">Age: 65</small>
                                  </div>
                                </div>
                              </div>
                              <div class="family-history-item-body">
                                <p class="mb-1">History of Hyperlipidemia (diagnosed at age 52) and Osteoarthritis (diagnosed at age 60).</p>
                                <div class="d-flex align-items-center mt-2">
                                  <span class="badge badge-soft-warning mr-2">Hyperlipidemia</span>
                                  <span class="badge badge-soft-warning mr-2">Osteoarthritis</span>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Medication History" title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-pills medical-nested-tab-icon"></i>
                        <span>Medication History</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="medication-history-container">
                        <div class="medication-history-header">
                          <i class="fas fa-prescription-bottle-alt medication-history-icon"></i>
                          <h5>Medication History</h5>
                        </div>
                        <div class="medication-history-content">
                          <div class="medication-history-filters mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <span class="badge badge-soft-primary mr-2">All</span>
                                <span class="badge badge-soft-success mr-2">Current</span>
                                <span class="badge badge-soft-secondary">Discontinued</span>
                              </div>
                              <div>
                                <select class="form-control form-control-sm custom-select border-0 bg-soft-light">
                                  <option>Sort by Date</option>
                                  <option>Sort by Name</option>
                                  <option>Sort by Status</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <ul class="list-unstyled medication-history-list">
                            <li class="medication-history-item current">
                              <div class="medication-history-item-header">
                                <div class="d-flex align-items-center">
                                  <i class="ri-medicine-bottle-line medication-history-item-icon text-primary"></i>
                                  <div>
                                    <h6 class="mb-0">Metformin (Glucophage)</h6>
                                    <small class="text-muted">Started: Jan 20, 2020</small>
                                  </div>
                                </div>
                                <span class="badge badge-soft-success">Current</span>
                              </div>
                              <div class="medication-history-item-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <p class="mb-1"><strong>Dosage:</strong> 500mg</p>
                                    <p class="mb-1"><strong>Frequency:</strong> Twice daily with meals</p>
                                  </div>
                                  <div class="col-md-6">
                                    <p class="mb-1"><strong>Purpose:</strong> Diabetes management</p>
                                    <p class="mb-1"><strong>Prescriber:</strong> Dr. Smith</p>
                                  </div>
                                </div>
                                <div class="medication-notes mt-2">
                                  <p class="mb-0"><strong>Notes:</strong> Take with food to minimize GI side effects. Last refill: 05/15/2023</p>
                                </div>
                              </div>
                            </li>
                            <li class="medication-history-item current">
                              <div class="medication-history-item-header">
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-tablets medication-history-item-icon text-info"></i>
                                  <div>
                                    <h6 class="mb-0">Lisinopril</h6>
                                    <small class="text-muted">Started: Mar 15, 2019</small>
                                  </div>
                                </div>
                                <span class="badge badge-soft-success">Current</span>
                              </div>
                              <div class="medication-history-item-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <p class="mb-1"><strong>Dosage:</strong> 10mg</p>
                                    <p class="mb-1"><strong>Frequency:</strong> Once daily</p>
                                  </div>
                                  <div class="col-md-6">
                                    <p class="mb-1"><strong>Purpose:</strong> Hypertension management</p>
                                    <p class="mb-1"><strong>Prescriber:</strong> Dr. Johnson</p>
                                  </div>
                                </div>
                                <div class="medication-notes mt-2">
                                  <p class="mb-0"><strong>Notes:</strong> Take in the morning. Monitor for dizziness. Last refill: 06/01/2023</p>
                                </div>
                              </div>
                            </li>
                            <li class="medication-history-item current">
                              <div class="medication-history-item-header">
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-pills medication-history-item-icon text-warning"></i>
                                  <div>
                                    <h6 class="mb-0">Atorvastatin (Lipitor)</h6>
                                    <small class="text-muted">Started: Apr 10, 2020</small>
                                  </div>
                                </div>
                                <span class="badge badge-soft-success">Current</span>
                              </div>
                              <div class="medication-history-item-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <p class="mb-1"><strong>Dosage:</strong> 20mg</p>
                                    <p class="mb-1"><strong>Frequency:</strong> Once daily at bedtime</p>
                                  </div>
                                  <div class="col-md-6">
                                    <p class="mb-1"><strong>Purpose:</strong> Cholesterol management</p>
                                    <p class="mb-1"><strong>Prescriber:</strong> Dr. Smith</p>
                                  </div>
                                </div>
                                <div class="medication-notes mt-2">
                                  <p class="mb-0"><strong>Notes:</strong> Report any muscle pain or weakness. Last refill: 05/20/2023</p>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Social History" title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-user-friends medical-nested-tab-icon"></i>
                        <span>Social History</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="social-history-container">
                        <div class="social-history-header">
                          <i class="fas fa-user-friends social-history-icon"></i>
                          <h5>Social History</h5>
                        </div>
                        <div class="social-history-content">
                          <div class="social-history-filters mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <span class="badge badge-soft-primary mr-2">All</span>
                                <span class="badge badge-soft-info mr-2">Lifestyle</span>
                                <span class="badge badge-soft-success mr-2">Support</span>
                                <span class="badge badge-soft-warning">Risk Factors</span>
                              </div>
                              <div>
                                <button class="btn btn-sm btn-soft-primary">
                                  <i class="fas fa-print mr-1"></i> Print Report
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Substance Use Section -->
                          <div class="social-history-section">
                            <div class="social-history-section-header">
                              <i class="fas fa-smoking social-history-section-icon"></i>
                              <h6>Substance Use</h6>
                            </div>
                            <div class="social-history-section-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="social-history-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-smoking social-history-item-icon text-danger"></i>
                                      <div>
                                        <h6 class="mb-0">Tobacco Use</h6>
                                        <p class="mb-0 text-muted">Former smoker, quit 5 years ago</p>
                                        <p class="mb-0 text-muted small">20 pack-year history (1 pack/day for 20 years)</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="social-history-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-wine-glass-alt social-history-item-icon text-warning"></i>
                                      <div>
                                        <h6 class="mb-0">Alcohol Use</h6>
                                        <p class="mb-0 text-muted">Social drinker</p>
                                        <p class="mb-0 text-muted small">2-3 drinks per week, primarily on weekends</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-6">
                                  <div class="social-history-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-cannabis social-history-item-icon text-success"></i>
                                      <div>
                                        <h6 class="mb-0">Recreational Drug Use</h6>
                                        <p class="mb-0 text-muted">Denies current or past use</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="social-history-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-pills social-history-item-icon text-info"></i>
                                      <div>
                                        <h6 class="mb-0">Caffeine Use</h6>
                                        <p class="mb-0 text-muted">Moderate consumption</p>
                                        <p class="mb-0 text-muted small">2-3 cups of coffee daily</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Lifestyle Section -->
                          <div class="social-history-section mt-4">
                            <div class="social-history-section-header">
                              <i class="fas fa-running social-history-section-icon"></i>
                              <h6>Lifestyle & Diet</h6>
                            </div>
                            <div class="social-history-section-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="social-history-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-dumbbell social-history-item-icon text-primary"></i>
                                      <div>
                                        <h6 class="mb-0">Exercise</h6>
                                        <p class="mb-0 text-muted">Moderate activity level</p>
                                        <p class="mb-0 text-muted small">Walks 30 minutes, 3 times per week</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="social-history-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-utensils social-history-item-icon text-success"></i>
                                      <div>
                                        <h6 class="mb-0">Diet</h6>
                                        <p class="mb-0 text-muted">Mixed diet with moderate restrictions</p>
                                        <p class="mb-0 text-muted small">Following diabetic diet recommendations with occasional lapses</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
            <b-tab title="Physical Examination" title-link-class="medical-main-tab">
              <template v-slot:title>
                <div class="medical-tab-title">
                  <i class="fas fa-stethoscope medical-tab-icon"></i>
                  <span>Physical Examination</span>
                </div>
              </template>
              <div class="medical-content-card">
                <div class="physical-exam-container">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-clipboard-list physical-exam-icon"></i>
                      <h5 class="mb-0">Physical Examination Results</h5>
                    </div>
                    <div>
                      <span class="badge badge-soft-primary mr-2">
                        <i class="far fa-calendar-alt mr-1"></i> Exam Date: 06/15/2023
                      </span>
                      <span class="badge badge-soft-info">
                        <i class="fas fa-user-md mr-1"></i> Dr. Johnson
                      </span>
                    </div>
                  </div>

                  <div class="row mb-4">
                    <div class="col-md-12">
                      <div class="alert alert-soft-primary mb-0">
                        <div class="d-flex">
                          <div class="alert-icon">
                            <i class="ri-information-line"></i>
                          </div>
                          <div class="alert-content">
                            <strong>Examination Summary:</strong> Patient presents in good general condition. Vital signs are stable with slightly elevated blood pressure. Physical examination reveals no acute distress. Cardiovascular and respiratory systems are within normal limits.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-4">
                    <div class="col-md-6">
                      <div class="card border-0 shadow-sm">
                        <div class="card-header bg-gradient-light">
                          <h6 class="mb-0"><i class="fas fa-chart-line mr-2 text-primary"></i>Vital Measurements</h6>
                        </div>
                        <div class="card-body">
                          <ul class="list-unstyled physical-exam-list">
                            <li class="physical-exam-item">
                              <i class="fas fa-ruler-vertical physical-exam-item-icon text-primary"></i>
                              <span class="physical-exam-item-label">Height:</span>
                              <span class="physical-exam-item-value">5'10" (178 cm)</span>
                            </li>
                            <li class="physical-exam-item">
                              <i class="fas fa-weight physical-exam-item-icon text-info"></i>
                              <span class="physical-exam-item-label">Weight:</span>
                              <span class="physical-exam-item-value">175 lbs (79.4 kg)</span>
                            </li>
                            <li class="physical-exam-item">
                              <i class="fas fa-calculator physical-exam-item-icon text-warning"></i>
                              <span class="physical-exam-item-label">BMI:</span>
                              <span class="physical-exam-item-value">25.1 kg/m²</span>
                              <span class="badge badge-soft-warning ml-2">Overweight</span>
                            </li>
                            <li class="physical-exam-item">
                              <i class="fas fa-heartbeat physical-exam-item-icon text-danger"></i>
                              <span class="physical-exam-item-label">Blood Pressure:</span>
                              <span class="physical-exam-item-value">135/85 mmHg</span>
                              <span class="badge badge-soft-warning ml-2">Elevated</span>
                            </li>
                            <li class="physical-exam-item">
                              <i class="fas fa-heart physical-exam-item-icon text-success"></i>
                              <span class="physical-exam-item-label">Heart Rate:</span>
                              <span class="physical-exam-item-value">78 bpm</span>
                              <span class="badge badge-soft-success ml-2">Normal</span>
                            </li>
                            <li class="physical-exam-item">
                              <i class="fas fa-lungs physical-exam-item-icon text-primary"></i>
                              <span class="physical-exam-item-label">Respiratory Rate:</span>
                              <span class="physical-exam-item-value">16 breaths/min</span>
                              <span class="badge badge-soft-success ml-2">Normal</span>
                            </li>
                            <li class="physical-exam-item">
                              <i class="fas fa-thermometer-half physical-exam-item-icon text-danger"></i>
                              <span class="physical-exam-item-label">Temperature:</span>
                              <span class="physical-exam-item-value">98.6°F (37°C)</span>
                              <span class="badge badge-soft-success ml-2">Normal</span>
                            </li>
                            <li class="physical-exam-item">
                              <i class="fas fa-tint physical-exam-item-icon text-info"></i>
                              <span class="physical-exam-item-label">Oxygen Saturation:</span>
                              <span class="physical-exam-item-value">98%</span>
                              <span class="badge badge-soft-success ml-2">Normal</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-header bg-gradient-light">
                          <h6 class="mb-0"><i class="fas fa-stethoscope mr-2 text-primary"></i>System Examination</h6>
                        </div>
                        <div class="card-body">
                          <div class="system-exam-item">
                            <h6 class="system-exam-title">
                              <i class="fas fa-heart mr-2 text-danger"></i>Cardiovascular
                            </h6>
                            <p class="system-exam-value">Regular rate and rhythm. No murmurs, gallops, or rubs. Normal S1 and S2.</p>
                          </div>

                          <div class="system-exam-item">
                            <h6 class="system-exam-title">
                              <i class="fas fa-lungs mr-2 text-info"></i>Respiratory
                            </h6>
                            <p class="system-exam-value">Clear to auscultation bilaterally. No wheezes, rales, or rhonchi.</p>
                          </div>

                          <div class="system-exam-item">
                            <h6 class="system-exam-title">
                              <i class="fas fa-brain mr-2 text-primary"></i>Neurological
                            </h6>
                            <p class="system-exam-value">Alert and oriented x3. Cranial nerves II-XII intact. Motor strength 5/5 in all extremities. Sensory intact to light touch. No focal deficits.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="card border-0 shadow-sm">
                        <div class="card-header bg-gradient-light">
                          <h6 class="mb-0"><i class="fas fa-notes-medical mr-2 text-primary"></i>Assessment & Recommendations</h6>
                        </div>
                        <div class="card-body">
                          <div class="assessment-item">
                            <h6 class="assessment-title">Assessment</h6>
                            <ol class="assessment-list">
                              <li>Type 2 Diabetes Mellitus - Controlled with current medication regimen</li>
                              <li>Essential Hypertension - Slightly elevated, consider medication adjustment</li>
                              <li>Overweight - BMI 25.8</li>
                            </ol>
                          </div>

                          <div class="assessment-item mt-3">
                            <h6 class="assessment-title">Recommendations</h6>
                            <ol class="assessment-list">
                              <li>Continue current diabetes medications</li>
                              <li>Consider increasing lisinopril to 20mg daily for better BP control</li>
                              <li>Dietary counseling for weight management</li>
                              <li>Increase physical activity to 150 minutes per week</li>
                              <li>Follow up in 3 months with repeat labs</li>
                            </ol>
                          </div>

                          <div class="d-flex justify-content-end mt-3">
                            <button class="btn btn-sm btn-outline-primary mr-2">
                              <i class="fas fa-print mr-1"></i> Print Report
                            </button>
                            <button class="btn btn-sm btn-primary">
                              <i class="fas fa-share-alt mr-1"></i> Share with Patient
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Social & Environmental" title-link-class="medical-main-tab">
              <template v-slot:title>
                <div class="medical-tab-title">
                  <i class="fas fa-home medical-tab-icon"></i>
                  <span>Social & Environmental</span>
                </div>
              </template>
              <div class="medical-nested-container">
                <b-tabs
                    vertical
                    nav-class="medical-nested-tabs"
                    nav-wrapper-class="col-sm-3"
                    content-class="pt-0 px-3 text-muted medical-nested-content"
                >
                  <b-tab title="Occupation" active title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-briefcase medical-nested-tab-icon"></i>
                        <span>Occupation</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="occupation-container">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <div class="d-flex align-items-center">
                            <i class="ri-briefcase-4-line occupation-icon text-primary"></i>
                            <h5 class="mb-0">Occupation Information</h5>
                          </div>
                          <div class="occupation-actions">
                            <span class="badge badge-soft-primary mr-2">
                              <i class="far fa-clock mr-1"></i> Updated: 05/28/2023
                            </span>
                            <button class="btn btn-sm btn-soft-primary">
                              <i class="ri-edit-line mr-1"></i> Edit
                            </button>
                          </div>
                        </div>

                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card occupation-card border-0 shadow-hover">
                              <div class="card-header bg-gradient-primary-soft">
                                <div class="d-flex align-items-center">
                                  <div class="occupation-card-icon">
                                    <i class="ri-user-3-line"></i>
                                  </div>
                                  <h6 class="mb-0 text-primary">Current Employment</h6>
                                </div>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="occupation-detail-item">
                                      <span class="occupation-detail-label">Occupation:</span>
                                      <span class="occupation-detail-value">Software Engineer</span>
                                    </div>
                                    <div class="occupation-detail-item">
                                      <span class="occupation-detail-label">Employer:</span>
                                      <span class="occupation-detail-value">TechSolutions Inc.</span>
                                    </div>
                                    <div class="occupation-detail-item">
                                      <span class="occupation-detail-label">Duration:</span>
                                      <span class="occupation-detail-value">5 years (since 2018)</span>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="occupation-detail-item">
                                      <span class="occupation-detail-label">Work Schedule:</span>
                                      <span class="occupation-detail-value">Full-time (40 hours/week)</span>
                                    </div>
                                    <div class="occupation-detail-item">
                                      <span class="occupation-detail-label">Work Setting:</span>
                                      <span class="occupation-detail-value">Office/Remote Hybrid</span>
                                    </div>
                                    <div class="occupation-detail-item">
                                      <span class="occupation-detail-label">Job Satisfaction:</span>
                                      <div class="d-flex align-items-center">
                                        <div class="satisfaction-meter">
                                          <div class="satisfaction-level" style="width: 80%;"></div>
                                        </div>
                                        <span class="ml-2 satisfaction-value">High</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card occupation-card border-0 shadow-hover">
                              <div class="card-header bg-gradient-warning-soft">
                                <div class="d-flex align-items-center">
                                  <div class="occupation-card-icon warning">
                                    <i class="ri-alert-line"></i>
                                  </div>
                                  <h6 class="mb-0 text-warning">Occupational Health Factors</h6>
                                </div>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="health-factor-item">
                                      <div class="d-flex align-items-center">
                                        <div class="health-factor-icon-container primary">
                                          <i class="ri-chair-line health-factor-icon"></i>
                                        </div>
                                        <div>
                                          <h6 class="mb-0">Sedentary Work</h6>
                                          <p class="mb-0 text-muted">Prolonged sitting at computer workstation</p>
                                        </div>
                                      </div>
                                      <div class="health-factor-risk">
                                        <span class="badge badge-soft-warning">Moderate Risk</span>
                                      </div>
                                    </div>
                                            
                                    <div class="health-factor-item">
                                      <div class="d-flex align-items-center">
                                        <div class="health-factor-icon-container info">
                                          <i class="ri-eye-line health-factor-icon"></i>
                                        </div>
                                        <div>
                                          <h6 class="mb-0">Screen Time</h6>
                                          <p class="mb-0 text-muted">8+ hours daily of computer screen exposure</p>
                                        </div>
                                      </div>
                                      <div class="health-factor-risk">
                                        <span class="badge badge-soft-warning">Moderate Risk</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="health-factor-item">
                                      <div class="d-flex align-items-center">
                                        <div class="health-factor-icon-container danger">
                                          <i class="ri-mental-health-line health-factor-icon"></i>
                                        </div>
                                        <div>
                                          <h6 class="mb-0">Mental Stress</h6>
                                          <p class="mb-0 text-muted">Project deadlines and technical challenges</p>
                                        </div>
                                      </div>
                                      <div class="health-factor-risk">
                                        <span class="badge badge-soft-danger">High Risk</span>
                                      </div>
                                    </div>
                                            
                                    <div class="health-factor-item">
                                      <div class="d-flex align-items-center">
                                        <div class="health-factor-icon-container success">
                                          <i class="ri-hand-line health-factor-icon"></i>
                                        </div>
                                        <div>
                                          <h6 class="mb-0">Repetitive Strain</h6>
                                          <p class="mb-0 text-muted">Keyboard and mouse use</p>
                                        </div>
                                      </div>
                                      <div class="health-factor-risk">
                                        <span class="badge badge-soft-success">Low Risk</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                                
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card occupation-card border-0 shadow-hover">
                              <div class="card-header bg-gradient-info-soft">
                                <div class="d-flex align-items-center">
                                  <div class="occupation-card-icon info">
                                    <i class="ri-list-check-2"></i>
                                  </div>
                                  <h6 class="mb-0 text-info">Recommendations</h6>
                                </div>
                              </div>
                              <div class="card-body">
                                <div class="recommendation-grid">
                                  <div class="recommendation-card">
                                    <div class="recommendation-icon">
                                      <i class="ri-ergonomic-chair-line"></i>
                                    </div>
                                    <div class="recommendation-content">
                                      <h6>Ergonomic Setup</h6>
                                      <p>Use ergonomic chair and desk setup to minimize back strain</p>
                                    </div>
                                  </div>

                                  <div class="recommendation-card">
                                    <div class="recommendation-icon">
                                      <i class="ri-eye-2-line"></i>
                                    </div>
                                    <div class="recommendation-content">
                                      <h6>Eye Care</h6>
                                      <p>Take regular breaks using the 20-20-20 rule for eye strain</p>
                                    </div>
                                  </div>

                                  <div class="recommendation-card">
                                    <div class="recommendation-icon">
                                      <i class="ri-walk-line"></i>
                                    </div>
                                    <div class="recommendation-content">
                                      <h6>Movement Breaks</h6>
                                      <p>Incorporate standing periods throughout workday with adjustable desk</p>
                                    </div>
                                  </div>

                                  <div class="recommendation-card">
                                    <div class="recommendation-icon">
                                      <i class="ri-mental-health-line"></i>
                                    </div>
                                    <div class="recommendation-content">
                                      <h6>Stress Management</h6>
                                      <p>Practice mindfulness or brief meditation during work breaks</p>
                                    </div>
                                  </div>

                                  <div class="recommendation-card">
                                    <div class="recommendation-icon">
                                      <i class="ri-keyboard-line"></i>
                                    </div>
                                    <div class="recommendation-content">
                                      <h6>Wrist Protection</h6>
                                      <p>Consider wrist supports and ergonomic keyboard/mouse</p>
                                    </div>
                                  </div>
                                </div>

                                <div class="d-flex justify-content-end mt-4">
                                  <button class="btn btn-sm btn-outline-primary mr-2">
                                    <i class="ri-file-pdf-line mr-1"></i> Download Guide
                                  </button>
                                  <button class="btn btn-sm btn-primary">
                                    <i class="ri-calendar-check-line mr-1"></i> Schedule Assessment
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Lifestyle" title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-running medical-nested-tab-icon"></i>
                        <span>Lifestyle</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="lifestyle-container">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-running lifestyle-icon text-primary"></i>
                            <h5 class="mb-0">Lifestyle Assessment</h5>
                          </div>
                          <span class="badge badge-soft-primary">
                            <i class="far fa-calendar-check mr-1"></i> Updated: 06/10/2023
                          </span>
                        </div>

                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-heartbeat mr-2 text-danger"></i>Physical Activity</h6>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="activity-summary">
                                      <div class="activity-level">
                                        <span class="activity-label">Activity Level:</span>
                                        <div class="progress activity-progress">
                                          <div class="progress-bar bg-warning" role="progressbar" style="width: 40%" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span class="activity-value">Moderate</span>
                                      </div>

                                      <div class="activity-detail-item">
                                        <span class="activity-detail-label">Weekly Exercise:</span>
                                        <span class="activity-detail-value">90 minutes</span>
                                        <span class="badge badge-soft-warning ml-2">Below Target</span>
                                      </div>

                                      <div class="activity-detail-item">
                                        <span class="activity-detail-label">Daily Steps:</span>
                                        <span class="activity-detail-value">5,200 avg.</span>
                                        <span class="badge badge-soft-warning ml-2">Below Target</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="activity-types">
                                      <h6 class="activity-types-title">Activity Types</h6>
                                      <div class="activity-type-item">
                                        <i class="fas fa-walking activity-type-icon text-primary"></i>
                                        <span class="activity-type-name">Walking</span>
                                        <span class="activity-type-frequency">3x weekly, 30 min</span>
                                      </div>
                                      
                                      <div class="activity-type-item">
                                        <i class="fas fa-swimming-pool activity-type-icon text-info"></i>
                                        <span class="activity-type-name">Swimming</span>
                                        <span class="activity-type-frequency">1x weekly, 45 min</span>
                                      </div>
                                      
                                      <div class="activity-type-item">
                                        <i class="fas fa-biking activity-type-icon text-success"></i>
                                        <span class="activity-type-name">Cycling</span>
                                        <span class="activity-type-frequency">Occasional</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="activity-goals mt-3">
                                  <h6 class="activity-goals-title">Activity Goals</h6>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="activity-goal-item">
                                        <div class="goal-icon bg-soft-primary">
                                          <i class="fas fa-shoe-prints"></i>
                                        </div>
                                        <div class="goal-details">
                                          <span class="goal-target">10,000</span>
                                          <span class="goal-label">Daily Steps</span>
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div class="col-md-4">
                                      <div class="activity-goal-item">
                                        <div class="goal-icon bg-soft-success">
                                          <i class="fas fa-dumbbell"></i>
                                        </div>
                                        <div class="goal-details">
                                          <span class="goal-target">150</span>
                                          <span class="goal-label">Weekly Minutes</span>
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div class="col-md-4">
                                      <div class="activity-goal-item">
                                        <div class="goal-icon bg-soft-info">
                                          <i class="fas fa-fire-alt"></i>
                                        </div>
                                        <div class="goal-details">
                                          <span class="goal-target">5</span>
                                          <span class="goal-label">Active Days/Week</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-utensils mr-2 text-success"></i>Nutrition</h6>
                              </div>
                              <div class="card-body">
                                <div class="nutrition-summary">
                                  <div class="nutrition-quality">
                                    <span class="nutrition-label">Diet Quality:</span>
                                    <div class="progress nutrition-progress">
                                      <div class="progress-bar bg-warning" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="nutrition-value">Fair</span>
                                  </div>
                                  
                                  <div class="nutrition-detail-item">
                                    <i class="fas fa-apple-alt nutrition-icon text-success"></i>
                                    <span class="nutrition-detail-label">Fruits & Vegetables:</span>
                                    <span class="nutrition-detail-value">2-3 servings/day</span>
                                    <span class="badge badge-soft-warning ml-2">Below Target</span>
                                  </div>
                                  
                                  <div class="nutrition-detail-item">
                                    <i class="fas fa-bread-slice nutrition-icon text-warning"></i>
                                    <span class="nutrition-detail-label">Whole Grains:</span>
                                    <span class="nutrition-detail-value">1-2 servings/day</span>
                                    <span class="badge badge-soft-warning ml-2">Below Target</span>
                                  </div>
                                  
                                  <div class="nutrition-detail-item">
                                    <i class="fas fa-drumstick-bite nutrition-icon text-danger"></i>
                                    <span class="nutrition-detail-label">Protein Sources:</span>
                                    <span class="nutrition-detail-value">Adequate</span>
                                    <span class="badge badge-soft-success ml-2">On Target</span>
                                  </div>
                                  
                                  <div class="nutrition-detail-item">
                                    <i class="fas fa-cookie nutrition-icon text-secondary"></i>
                                    <span class="nutrition-detail-label">Processed Foods:</span>
                                    <span class="nutrition-detail-value">Frequent consumption</span>
                                    <span class="badge badge-soft-danger ml-2">Above Target</span>
                                  </div>
                                  
                                  <div class="nutrition-detail-item">
                                    <i class="fas fa-tint nutrition-icon text-info"></i>
                                    <span class="nutrition-detail-label">Hydration:</span>
                                    <span class="nutrition-detail-value">~6 cups water/day</span>
                                    <span class="badge badge-soft-warning ml-2">Below Target</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-moon mr-2 text-info"></i>Sleep & Stress</h6>
                              </div>
                              <div class="card-body">
                                <div class="sleep-summary mb-4">
                                  <div class="sleep-quality">
                                    <span class="sleep-label">Sleep Quality:</span>
                                    <div class="progress sleep-progress">
                                      <div class="progress-bar bg-info" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="sleep-value">Good</span>
                                  </div>
                                  
                                  <div class="sleep-detail-item">
                                    <i class="fas fa-bed sleep-icon text-info"></i>
                                    <span class="sleep-detail-label">Average Duration:</span>
                                    <span class="sleep-detail-value">7.2 hours/night</span>
                                    <span class="badge badge-soft-success ml-2">On Target</span>
                                  </div>
                                  
                                  <div class="sleep-detail-item">
                                    <i class="fas fa-hourglass-half sleep-icon text-warning"></i>
                                    <span class="sleep-detail-label">Sleep Latency:</span>
                                    <span class="sleep-detail-value">25-30 minutes</span>
                                    <span class="badge badge-soft-warning ml-2">Slightly Delayed</span>
                                  </div>
                                  
                                  <div class="sleep-detail-item">
                                    <i class="fas fa-clock sleep-icon text-danger"></i>
                                    <span class="sleep-detail-label">Waking Episodes:</span>
                                    <span class="sleep-detail-value">1-2 times/night</span>
                                    <span class="badge badge-soft-warning ml-2">Occasional Disruption</span>
                                  </div>
                                </div>
                                
                                <div class="stress-summary">
                                  <div class="stress-level">
                                    <span class="stress-label">Stress Level:</span>
                                    <div class="progress stress-progress">
                                      <div class="progress-bar bg-danger" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="stress-value">Elevated</span>
                                  </div>
                                  
                                  <div class="stress-detail-item">
                                    <i class="fas fa-brain stress-icon text-danger"></i>
                                    <span class="stress-detail-label">Primary Sources:</span>
                                    <span class="stress-detail-value">Work, Financial concerns</span>
                                  </div>
                                  
                                  <div class="stress-detail-item">
                                    <i class="fas fa-spa stress-icon text-success"></i>
                                    <span class="stress-detail-label">Coping Mechanisms:</span>
                                    <span class="stress-detail-value">Limited, occasional exercise</span>
                                    <span class="badge badge-soft-warning ml-2">Needs Improvement</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-clipboard-list mr-2 text-primary"></i>Lifestyle Recommendations</h6>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="recommendation-category">
                                      <h6 class="recommendation-category-title text-primary">
                                        <i class="fas fa-running mr-2"></i>Physical Activity
                                      </h6>
                                      <ul class="recommendation-list">
                                        <li>Increase daily steps to 7,500 initially, then 10,000</li>
                                        <li>Add 1-2 strength training sessions weekly</li>
                                        <li>Consider joining a group fitness class for motivation</li>
                                        <li>Schedule walking meetings at work when possible</li>
                                      </ul>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-4">
                                    <div class="recommendation-category">
                                      <h6 class="recommendation-category-title text-success">
                                        <i class="fas fa-apple-alt mr-2"></i>Nutrition
                                      </h6>
                                      <ul class="recommendation-list">
                                        <li>Increase fruit and vegetable intake to 5+ servings daily</li>
                                        <li>Replace refined grains with whole grain options</li>
                                        <li>Reduce processed food consumption by meal prepping</li>
                                        <li>Increase water intake to 8+ cups daily</li>
                                      </ul>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-4">
                                    <div class="recommendation-category">
                                      <h6 class="recommendation-category-title text-info">
                                        <i class="fas fa-brain mr-2"></i>Sleep & Stress
                                      </h6>
                                      <ul class="recommendation-list">
                                        <li>Establish consistent sleep/wake schedule</li>
                                        <li>Practice 10-minute mindfulness meditation daily</li>
                                        <li>Limit screen time 1 hour before bedtime</li>
                                        <li>Consider referral to stress management program</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="d-flex justify-content-end mt-3">
                                  <button class="btn btn-sm btn-outline-primary mr-2">
                                    <i class="fas fa-download mr-1"></i> Download Plan
                                  </button>
                                  <button class="btn btn-sm btn-primary">
                                    <i class="fas fa-calendar-plus mr-1"></i> Schedule Follow-up
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Living Situation" title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-home medical-nested-tab-icon"></i>
                        <span>Living Situation</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="living-situation-container">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-home living-situation-icon text-primary"></i>
                            <h5 class="mb-0">Living Environment Assessment</h5>
                          </div>
                          <span class="badge badge-soft-primary">
                            <i class="far fa-calendar-check mr-1"></i> Updated: 05/15/2023
                          </span>
                        </div>

                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-house-user mr-2 text-primary"></i>Residence Information</h6>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Residence Type:</span>
                                      <span class="residence-detail-value">Single-family home</span>
                                    </div>
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Ownership:</span>
                                      <span class="residence-detail-value">Owned (Mortgage)</span>
                                    </div>
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Duration at Residence:</span>
                                      <span class="residence-detail-value">8 years</span>
                                    </div>
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Number of Floors:</span>
                                      <span class="residence-detail-value">2 (Bedroom on 2nd floor)</span>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Household Members:</span>
                                      <span class="residence-detail-value">2 (Patient and spouse)</span>
                                    </div>
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Pets:</span>
                                      <span class="residence-detail-value">1 dog (medium-sized)</span>
                                    </div>
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Neighborhood:</span>
                                      <span class="residence-detail-value">Suburban, low crime area</span>
                                    </div>
                                    <div class="residence-detail-item">
                                      <span class="residence-detail-label">Proximity to Services:</span>
                                      <span class="residence-detail-value">Grocery, pharmacy within 1 mile</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-universal-access mr-2 text-success"></i>Accessibility & Safety</h6>
                              </div>
                              <div class="card-body">
                                <div class="safety-assessment">
                                  <div class="safety-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-stairs safety-icon text-warning"></i>
                                      <div>
                                        <h6 class="mb-0">Stairs</h6>
                                        <p class="mb-0 text-muted">Interior stairs to bedroom level</p>
                                      </div>
                                    </div>
                                    <div class="safety-status">
                                      <span class="badge badge-soft-warning">Potential Concern</span>
                                    </div>
                                  </div>
                                  
                                  <div class="safety-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-shower safety-icon text-success"></i>
                                      <div>
                                        <h6 class="mb-0">Bathroom</h6>
                                        <p class="mb-0 text-muted">Grab bars installed in shower</p>
                                      </div>
                                    </div>
                                    <div class="safety-status">
                                      <span class="badge badge-soft-success">Adequate</span>
                                    </div>
                                  </div>
                                  
                                  <div class="safety-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-lightbulb safety-icon text-success"></i>
                                      <div>
                                        <h6 class="mb-0">Lighting</h6>
                                        <p class="mb-0 text-muted">Well-lit throughout, night lights in hallways</p>
                                      </div>
                                    </div>
                                    <div class="safety-status">
                                      <span class="badge badge-soft-success">Adequate</span>
                                    </div>
                                  </div>
                                  
                                  <div class="safety-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-fire-extinguisher safety-icon text-success"></i>
                                      <div>
                                        <h6 class="mb-0">Fire Safety</h6>
                                        <p class="mb-0 text-muted">Smoke detectors on each floor, fire extinguisher in kitchen</p>
                                      </div>
                                    </div>
                                    <div class="safety-status">
                                      <span class="badge badge-soft-success">Adequate</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-hand-holding-heart mr-2 text-info"></i>Support Resources</h6>
                              </div>
                              <div class="card-body">
                                <div class="support-assessment">
                                  <div class="support-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-user-friends support-icon text-primary"></i>
                                      <div>
                                        <h6 class="mb-0">Family Support</h6>
                                        <p class="mb-0 text-muted">Spouse provides daily assistance</p>
                                      </div>
                                    </div>
                                    <div class="support-rating">
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                    </div>
                                  </div>
                                  
                                  <div class="support-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-users support-icon text-success"></i>
                                      <div>
                                        <h6 class="mb-0">Community Support</h6>
                                        <p class="mb-0 text-muted">Active church community, weekly social activities</p>
                                      </div>
                                    </div>
                                    <div class="support-rating">
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="far fa-star text-warning"></i>
                                    </div>
                                  </div>
                                  
                                  <div class="support-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-hands-helping support-icon text-info"></i>
                                      <div>
                                        <h6 class="mb-0">Professional Services</h6>
                                        <p class="mb-0 text-muted">Cleaning service biweekly</p>
                                      </div>
                                    </div>
                                    <div class="support-rating">
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="far fa-star text-warning"></i>
                                      <i class="far fa-star text-warning"></i>
                                    </div>
                                  </div>
                                  
                                  <div class="support-item">
                                    <div class="d-flex align-items-center">
                                      <i class="fas fa-bus support-icon text-danger"></i>
                                      <div>
                                        <h6 class="mb-0">Transportation</h6>
                                        <p class="mb-0 text-muted">Patient drives, spouse as backup</p>
                                      </div>
                                    </div>
                                    <div class="support-rating">
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="fas fa-star text-warning"></i>
                                      <i class="far fa-star text-warning"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-clipboard-list mr-2 text-primary"></i>Recommendations</h6>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="recommendation-item">
                                      <div class="recommendation-priority high">
                                        <span>High</span>
                                      </div>
                                      <div class="recommendation-content">
                                        <h6>Install handrails on both sides of interior stairs</h6>
                                        <p>To improve safety when navigating between floors, especially at night.</p>
                                      </div>
                                    </div>
                                    
                                    <div class="recommendation-item">
                                      <div class="recommendation-priority medium">
                                        <span>Medium</span>
                                      </div>
                                      <div class="recommendation-content">
                                        <h6>Remove throw rugs or secure with non-slip backing</h6>
                                        <p>To reduce fall risk, especially in hallways and living areas.</p>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-6">
                                    <div class="recommendation-item">
                                      <div class="recommendation-priority medium">
                                        <span>Medium</span>
                                      </div>
                                      <div class="recommendation-content">
                                        <h6>Consider first-floor bedroom conversion</h6>
                                        <p>Long-term planning for potential mobility limitations.</p>
                                      </div>
                                    </div>
                                    
                                    <div class="recommendation-item">
                                      <div class="recommendation-priority low">
                                        <span>Low</span>
                                      </div>
                                      <div class="recommendation-content">
                                        <h6>Explore community transportation options</h6>
                                        <p>As backup for times when neither patient nor spouse can drive.</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="d-flex justify-content-end mt-3">
                                  <button class="btn btn-sm btn-outline-primary mr-2">
                                    <i class="fas fa-print mr-1"></i> Print Assessment
                                  </button>
                                  <button class="btn btn-sm btn-primary">
                                    <i class="fas fa-calendar-plus mr-1"></i> Schedule Home Visit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Social Support" title-link-class="medical-nested-tab">
                    <template v-slot:title>
                      <div class="medical-nested-tab-title">
                        <i class="fas fa-hands-helping medical-nested-tab-icon"></i>
                        <span>Social Support</span>
                      </div>
                    </template>
                    <b-card-text class="medical-content-card">
                      <div class="social-support-container">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-hands-helping social-support-icon text-primary"></i>
                            <h5 class="mb-0">Social Support Network</h5>
                          </div>
                          <span class="badge badge-soft-primary">
                            <i class="far fa-calendar-check mr-1"></i> Updated: 06/02/2023
                          </span>
                        </div>

                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-chart-pie mr-2 text-primary"></i>Support Network Overview</h6>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="support-score-container">
                                      <div class="support-score">
                                        <div class="support-score-circle">
                                          <span class="support-score-value">82</span>
                                          <span class="support-score-label">Support Score</span>
                                        </div>
                                      </div>
                                      <div class="support-score-details">
                                        <div class="support-score-item">
                                          <span class="support-score-item-label">Family Support:</span>
                                          <div class="progress support-score-progress">
                                            <div class="progress-bar bg-success" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                          </div>
                                          <span class="support-score-item-value">Excellent</span>
                                        </div>
                                        <div class="support-score-item">
                                          <span class="support-score-item-label">Community Support:</span>
                                          <div class="progress support-score-progress">
                                            <div class="progress-bar bg-primary" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                          </div>
                                          <span class="support-score-item-value">Good</span>
                                        </div>
                                        <div class="support-score-item">
                                          <span class="support-score-item-label">Professional Support:</span>
                                          <div class="progress support-score-progress">
                                            <div class="progress-bar bg-info" role="progressbar" style="width: 80%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                          </div>
                                          <span class="support-score-item-value">Good</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="support-summary">
                                      <h6 class="support-summary-title">Summary Assessment</h6>
                                      <p class="support-summary-text">
                                        Patient has a strong support network, primarily from spouse and adult children.
                                        Active in church community which provides additional social connections.
                                        Professional healthcare team is well-established with good coordination.
                                      </p>
                                      <div class="support-summary-strengths">
                                        <h6><i class="fas fa-plus-circle text-success mr-2"></i>Key Strengths</h6>
                                        <ul>
                                          <li>Spouse provides consistent daily support</li>
                                          <li>Adult children visit weekly and assist with transportation</li>
                                          <li>Active church membership provides social engagement</li>
                                        </ul>
                                      </div>
                                      <div class="support-summary-gaps">
                                        <h6><i class="fas fa-minus-circle text-danger mr-2"></i>Potential Gaps</h6>
                                        <ul>
                                          <li>Limited backup transportation options</li>
                                          <li>Spouse is sole caregiver with minimal respite</li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-users mr-2 text-success"></i>Support Network Members</h6>
                              </div>
                              <div class="card-body">
                                <div class="support-network-list">
                                  <div class="support-network-item primary-support">
                                    <div class="support-network-avatar">
                                      <i class="fas fa-user-circle"></i>
                                      <div class="support-network-badge primary">
                                        <i class="fas fa-star"></i>
                                      </div>
                                    </div>
                                    <div class="support-network-details">
                                      <h6>Mary Johnson <span class="relationship">(Spouse)</span></h6>
                                      <p class="support-network-contact"><i class="fas fa-phone-alt mr-1"></i> 555-123-4567</p>
                                      <div class="support-network-roles">
                                        <span class="badge badge-soft-primary">Primary Caregiver</span>
                                        <span class="badge badge-soft-info">Medication Management</span>
                                        <span class="badge badge-soft-success">Transportation</span>
                                        <span class="badge badge-soft-warning">Meal Preparation</span>
                                      </div>
                                      <p class="support-network-notes">Lives with patient. Provides daily assistance with medication management, meal preparation, and transportation to appointments.</p>
                                    </div>
                                    <div class="support-network-frequency">
                                      <span class="badge badge-soft-success">Daily</span>
                                    </div>
                                  </div>
                                  
                                  <div class="support-network-item">
                                    <div class="support-network-avatar">
                                      <i class="fas fa-user-circle"></i>
                                    </div>
                                    <div class="support-network-details">
                                      <h6>Michael Johnson <span class="relationship">(Son)</span></h6>
                                      <p class="support-network-contact"><i class="fas fa-phone-alt mr-1"></i> 555-234-5678</p>
                                      <div class="support-network-roles">
                                        <span class="badge badge-soft-success">Transportation</span>
                                        <span class="badge badge-soft-info">Home Maintenance</span>
                                      </div>
                                      <p class="support-network-notes">Lives 15 minutes away. Visits weekly to help with home maintenance and provides backup transportation when needed.</p>
                                    </div>
                                    <div class="support-network-frequency">
                                      <span class="badge badge-soft-primary">Weekly</span>
                                    </div>
                                  </div>
                                  
                                  <div class="support-network-item">
                                    <div class="support-network-avatar">
                                      <i class="fas fa-user-md"></i>
                                    </div>
                                    <div class="support-network-details">
                                      <h6>Dr. Liz Poe <span class="relationship">(Primary Care Provider)</span></h6>
                                      <p class="support-network-contact"><i class="fas fa-phone-alt mr-1"></i> 555-456-7890</p>
                                      <div class="support-network-roles">
                                        <span class="badge badge-soft-danger">Medical Care</span>
                                        <span class="badge badge-soft-info">Medication Management</span>
                                      </div>
                                      <p class="support-network-notes">Primary care physician for 8 years. Coordinates overall medical care and medication management.</p>
                                    </div>
                                    <div class="support-network-frequency">
                                      <span class="badge badge-soft-warning">Quarterly</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card border-0 shadow-sm">
                              <div class="card-header bg-gradient-light">
                                <h6 class="mb-0"><i class="fas fa-clipboard-list mr-2 text-primary"></i>Recommendations</h6>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="social-recommendation-item">
                                      <div class="social-recommendation-header">
                                        <i class="fas fa-user-friends social-recommendation-icon text-primary"></i>
                                        <h6>Caregiver Support</h6>
                                      </div>
                                      <div class="social-recommendation-body">
                                        <p>Explore respite care options for spouse to prevent caregiver burnout. Consider adult day program 1-2 days/week.</p>
                                        <div class="social-recommendation-action">
                                          <button class="btn btn-sm btn-soft-primary">
                                            <i class="fas fa-plus-circle mr-1"></i> Add to Care Plan
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div class="social-recommendation-item">
                                      <div class="social-recommendation-header">
                                        <i class="fas fa-bus social-recommendation-icon text-warning"></i>
                                        <h6>Transportation Resources</h6>
                                      </div>
                                      <div class="social-recommendation-body">
                                        <p>Connect with senior transportation services as backup option when family is unavailable. Provide information on local senior ride programs.</p>
                                        <div class="social-recommendation-action">
                                          <button class="btn btn-sm btn-soft-primary">
                                            <i class="fas fa-plus-circle mr-1"></i> Add to Care Plan
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-6">
                                    <div class="social-recommendation-item">
                                      <div class="social-recommendation-header">
                                        <i class="fas fa-users social-recommendation-icon text-success"></i>
                                        <h6>Social Engagement</h6>
                                      </div>
                                      <div class="social-recommendation-body">
                                        <p>Encourage participation in senior center activities to expand social network beyond family and church. Consider diabetes support group.</p>
                                        <div class="social-recommendation-action">
                                          <button class="btn btn-sm btn-soft-primary">
                                            <i class="fas fa-plus-circle mr-1"></i> Add to Care Plan
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div class="social-recommendation-item">
                                      <div class="social-recommendation-header">
                                        <i class="fas fa-mobile-alt social-recommendation-icon text-info"></i>
                                        <h6>Technology Support</h6>
                                      </div>
                                      <div class="social-recommendation-body">
                                        <p>Explore video calling options to maintain connection with grandchildren who live out of state. Consider basic smartphone training.</p>
                                        <div class="social-recommendation-action">
                                          <button class="btn btn-sm btn-soft-primary">
                                            <i class="fas fa-plus-circle mr-1"></i> Add to Care Plan
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="d-flex justify-content-end mt-3">
                                  <button class="btn btn-sm btn-outline-primary mr-2">
                                    <i class="fas fa-print mr-1"></i> Print Assessment
                                  </button>
                                  <button class="btn btn-sm btn-primary">
                                    <i class="fas fa-calendar-plus mr-1"></i> Schedule Follow-up
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>

    <!-- Device Modal -->
    <b-modal
      v-model="showDeviceModal"
      title="Add New Device"
      title-class="font-18"
      size="lg"
      hide-footer
      class="device-modal"
    >
      <div class="p-3">
        <div class="form-row mb-3">
          <div class="col-md-6">
            <label for="deviceName" class="form-label">Device Name</label>
            <input type="text" id="deviceName" v-model="deviceForm.name" class="form-control" placeholder="Enter device name">
          </div>
          <div class="col-md-6">
            <label for="deviceType" class="form-label">Device Type</label>
            <select id="deviceType" v-model="deviceForm.type" class="form-control">
              <option value="smartwatch">Smart Watch</option>
              <option value="glucosemonitor">Glucose Monitor</option>
              <option value="bpmonitor">Blood Pressure Monitor</option>
              <option value="ecgmonitor">ECG Monitor</option>
              <option value="pulseoximeter">Pulse Oximeter</option>
              <option value="thermometer">Smart Thermometer</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-md-6">
            <label for="deviceModel" class="form-label">Model</label>
            <input type="text" id="deviceModel" v-model="deviceForm.model" class="form-control" placeholder="Enter model number">
          </div>
          <div class="col-md-6">
            <label for="deviceManufacturer" class="form-label">Manufacturer</label>
            <input type="text" id="deviceManufacturer" v-model="deviceForm.manufacturer" class="form-control" placeholder="Enter manufacturer">
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-md-6">
            <label for="deviceSerialNumber" class="form-label">Serial Number</label>
            <input type="text" id="deviceSerialNumber" v-model="deviceForm.serialNumber" class="form-control" placeholder="Enter serial number">
          </div>
          <div class="col-md-6">
            <label for="deviceStatus" class="form-label">Status</label>
            <select id="deviceStatus" v-model="deviceForm.status" class="form-control">
              <option value="connected">Connected</option>
              <option value="disconnected">Disconnected</option>
              <option value="pairing">Pairing</option>
              <option value="error">Error</option>
            </select>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-md-6">
            <label for="deviceBatteryLevel" class="form-label">Battery Level (%)</label>
            <input type="number" id="deviceBatteryLevel" v-model="deviceForm.batteryLevel" class="form-control" min="0" max="100" placeholder="Enter battery level">
          </div>
        </div>

        <div class="form-group">
          <label for="deviceNotes" class="form-label">Notes</label>
          <textarea id="deviceNotes" v-model="deviceForm.notes" class="form-control" rows="3" placeholder="Enter any additional notes about this device"></textarea>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showDeviceModal = false"
          >
            <i class="ri-close-line align-middle mr-1"></i> Cancel
          </b-button>
          <b-button
            variant="success"
            @click="addDevice"
          >
            <i class="ri-save-line align-middle mr-1"></i> Add Device
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Wellness Entry Modal -->
    <b-modal
      v-model="showWellnessEntryModal"
      title="Add Wellness Package"
      title-class="font-18"
      size="lg"
      hide-footer
      class="wellness-entry-modal"
    >
      <div class="p-3">
        <!-- Package Selection Section -->
        <div class="mb-4 card shadow-sm">
          <div class="card-header bg-light py-3">
            <h5 class="mb-0">Select Wellness Packages</h5>
          </div>
          <div class="card-body">
            <!-- Package Selection Dropdown -->
            <div class="form-group">
              <label for="packageSelect" class="form-label">Select one or more wellness packages</label>
              <multiselect
                id="packageSelect"
                v-model="wellnessEntryForm.selectedPackages"
                :options="wellnessPackages.flatMap(category => category.packages)"
                :multiple="true"
                :searchable="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Search and select packages"
                label="name"
                track-by="id"
                class="package-multiselect"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} package(s) selected</span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                    <span class="option__small">{{ props.option.level }}</span>
                  </div>
                </template>
              </multiselect>
            </div>

            <!-- Selected Packages Inline Labels -->
            <div v-if="wellnessEntryForm.selectedPackages.length > 0" class="selected-packages-inline mt-4">
              <h6 class="mb-3 text-primary">
                <i class="fas fa-check-circle mr-1"></i> Selected Packages
                <span class="badge badge-soft-primary ml-2">{{ wellnessEntryForm.selectedPackages.length }}</span>
              </h6>
              <div class="d-flex flex-wrap">
                <div
                  v-for="pkg in wellnessEntryForm.selectedPackages"
                  :key="'selected-' + pkg.id"
                  class="program-label mr-2 mb-2 py-2 px-3 border rounded-pill bg-light d-flex align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span class="font-weight-medium">{{ pkg.name }}</span>
                    <span class="badge badge-soft-primary ml-2">{{ pkg.level }}</span>
                  </div>
                  <div class="d-flex ml-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-icon text-info p-0 mr-1"
                      @click="editPackage(pkg)"
                      title="Edit package"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-icon text-danger p-0"
                      @click="togglePackageSelection(pkg)"
                      title="Remove package"
                    >
                      <i class="fas fa-times-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Package Details Section -->
        <div v-if="wellnessEntryForm.selectedPackages.length > 0" class="mb-4 card shadow-sm">
          <div class="card-header bg-light py-3">
            <h5 class="mb-0">Package Details</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div
                v-for="pkg in wellnessEntryForm.selectedPackages"
                :key="'details-' + pkg.id"
                class="col-md-6 mb-3"
              >
                <div class="package-card p-3 border rounded shadow-sm h-100">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0 font-weight-bold">{{ pkg.name }}</h6>
                    <span class="badge badge-soft-primary">{{ pkg.level }}</span>
                  </div>
                  <p class="text-muted small mb-2">{{ pkg.targetAudience }}</p>
                  <div class="package-services mb-3">
                    <p class="font-weight-bold mb-2">Services:</p>
                    <ul class="pl-3">
                      <li v-for="(service, serviceIndex) in pkg.services" :key="serviceIndex" class="small mb-1">
                        {{ service }}
                      </li>
                    </ul>
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-weight-bold">₹{{ pkg.price.toLocaleString() }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Total Price -->
        <div class="mb-4 p-3 bg-light rounded">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Total Price:</h5>
            <h5 class="mb-0 font-weight-bold">₹{{ calculateTotalPrice().toLocaleString() }}</h5>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex justify-content-end">
          <b-button
            variant="light"
            class="mr-2"
            @click="showWellnessEntryModal = false"
          >
            <i class="ri-close-line align-middle mr-1"></i> Cancel
          </b-button>
          <b-button
            variant="success"
            @click="submitWellnessEntry"
            :disabled="wellnessEntryForm.selectedPackages.length === 0"
          >
            <i class="ri-save-line align-middle mr-1"></i> Submit
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Transition Care Modal -->
    <b-modal
      v-model="showTransitionModal"
      title="Add Transition Care"
      title-class="font-18"
      size="lg"
      hide-footer
      class="transition-care-modal"
    >
      <div class="p-3">
        <!-- Program Selection Section -->
        <div class="mb-4 card shadow-sm">
          <div class="card-header bg-light py-3">
            <h5 class="mb-0">Select Care Programs</h5>
          </div>
          <div class="card-body">
            <!-- Program Selection Dropdown -->
            <div class="form-group">
              <label for="programSelect" class="form-label">Select one or more care programs</label>
              <multiselect
                id="programSelect"
                v-model="transitionForm.selectedPrograms"
                :options="transitionCarePackages"
                :multiple="true"
                :searchable="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Search and select programs"
                label="name"
                track-by="id"
                class="program-multiselect"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} program(s) selected</span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.tier }}: {{ props.option.name }}</span>
                    <span class="option__small">{{ props.option.duration }}</span>
                  </div>
                </template>
              </multiselect>
            </div>

            <!-- Selected Programs Inline Labels -->
            <div v-if="transitionForm.selectedPrograms.length > 0" class="selected-programs-inline mt-4">
              <h6 class="mb-3 text-primary">
                <i class="fas fa-check-circle mr-1"></i> Selected Programs
                <span class="badge badge-soft-primary ml-2">{{ transitionForm.selectedPrograms.length }}</span>
              </h6>
              <div class="d-flex flex-wrap">
                <div
                  v-for="program in transitionForm.selectedPrograms"
                  :key="'selected-' + program.id"
                  class="program-label mr-2 mb-2 py-2 px-3 border rounded-pill bg-light d-flex align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span class="font-weight-medium">{{ program.tier }}: {{ program.name }}</span>
                    <span class="badge badge-soft-primary ml-2">{{ program.duration }}</span>
                  </div>
                  <div class="d-flex ml-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-icon text-info p-0 mr-1"
                      @click="editProgram(program)"
                      title="Edit program"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-icon text-danger p-0"
                      @click="toggleProgramSelection(program)"
                      title="Remove program"
                    >
                      <i class="fas fa-times-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Patient Information Section -->
        <div class="mb-4 card shadow-sm" :class="{'d-none': transitionForm.selectedPrograms.length === 0}">
          <div class="card-header bg-light py-3">
            <h5 class="mb-0">Patient Information</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="patientName" class="form-label">Patient Name <span class="text-danger">*</span></label>
                <input 
                  type="text" 
                  id="patientName" 
                  class="form-control" 
                  v-model="transitionForm.patientInfo.name" 
                  placeholder="Enter patient name"
                >
              </div>
              <div class="col-md-3 mb-3">
                <label for="patientAge" class="form-label">Age</label>
                <input 
                  type="number" 
                  id="patientAge" 
                  class="form-control" 
                  v-model="transitionForm.patientInfo.age" 
                  placeholder="Age"
                >
              </div>
              <div class="col-md-3 mb-3">
                <label for="patientGender" class="form-label">Gender</label>
                <select 
                  id="patientGender" 
                  class="form-control custom-select" 
                  v-model="transitionForm.patientInfo.gender"
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mb-3">
                <label for="patientCondition" class="form-label">Medical Condition</label>
                <textarea 
                  id="patientCondition" 
                  class="form-control" 
                  v-model="transitionForm.patientInfo.condition" 
                  placeholder="Describe the patient's medical condition"
                  rows="3"
                ></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="admissionDate" class="form-label">Admission Date</label>
                <input 
                  type="date" 
                  id="admissionDate" 
                  class="form-control" 
                  v-model="transitionForm.patientInfo.admissionDate"
                >
              </div>
              <div class="col-md-6 mb-3">
                <label for="dischargeDate" class="form-label">Expected Discharge Date</label>
                <input 
                  type="date" 
                  id="dischargeDate" 
                  class="form-control" 
                  v-model="transitionForm.patientInfo.dischargeDate"
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Summary Section -->
        <div class="mb-4 card shadow-sm" v-if="transitionForm.selectedPrograms.length > 0">
          <div class="card-header bg-light py-3">
            <h5 class="mb-0">Summary</h5>
          </div>
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-1">Total Programs Selected:</h6>
                <p class="mb-0 font-weight-bold">{{ transitionForm.selectedPrograms.length }} program(s)</p>
              </div>
              <div>
                <h6 class="mb-1">Total Price:</h6>
                <p class="mb-0 font-weight-bold text-success">₹{{ calculateTransitionTotalPrice().toLocaleString() }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex justify-content-end">
          <b-button
            variant="light"
            class="mr-2"
            @click="showTransitionModal = false"
          >
            <i class="ri-close-line align-middle mr-1"></i> Cancel
          </b-button>
          <b-button
            variant="success"
            @click="submitTransitionForm"
            :disabled="transitionForm.selectedPrograms.length === 0 || !transitionForm.patientInfo.name"
          >
            <i class="ri-save-line align-middle mr-1"></i> Submit
          </b-button>
        </div>
      </div>
    </b-modal>
    </div></Layout>
</template>

<style scoped>
.mr-2 {
  margin-right: 0.5rem;
}
.w-100 {
  width: 100%;
}
.gap-3 {
  gap: 1rem;
}
.gap-2 {
  gap: 0.5rem;
}

/* Care Management Styling */
.bg-soft-light {
  background-color: rgba(248, 249, 250, 0.5) !important;
  transition: background-color 0.3s ease;
}

.table-hover tbody tr:hover {
  background-color: rgba(85, 110, 230, 0.05);
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #556ee6 0%, #34c38f 100%) !important;
}

.care-plan-card {
  border-radius: 0.5rem;
  overflow: hidden;
  transition: all 0.3s ease;
}

.care-plan-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.care-plan-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  font-size: 1.25rem;
}

.care-plan-info {
  background-color: #fff;
  border-radius: 0 0 0.5rem 0.5rem;
}

.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
  padding: 0.35em 0.65em;
  border-radius: 0.25rem;
}

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
  padding: 0.35em 0.65em;
  border-radius: 0.25rem;
}

.badge-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
  padding: 0.35em 0.65em;
  border-radius: 0.25rem;
}

/* Patient Summary Card Styling */
.patient-summary-card {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  transition: all 0.3s ease;
}

.patient-summary-card .section-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 0.25rem;
}

.patient-summary-card .section-title {
  font-weight: 600;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
}

.patient-summary-card .section-content {
  padding: 0.25rem 0;
}

.patient-summary-card .info-item,
.patient-summary-card .condition-item,
.patient-summary-card .medication-item,
.patient-summary-card .consulting-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
  padding: 0.125rem 0;
  font-size: 0.85rem;
}

.patient-summary-card .info-item:last-child,
.patient-summary-card .condition-item:last-child,
.patient-summary-card .medication-item:last-child,
.patient-summary-card .consulting-item:last-child {
  margin-bottom: 0;
}

.patient-info-section,
.patient-conditions-section,
.patient-medications-section,
.patient-medical-section,
.patient-consulting-section {
  background-color: #fff;
  border-radius: 0.375rem;
  padding: 0.5rem;
  height: 100%;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.03);
}

/* Wellness and Transition Care Styling */
.package-card, .tier-card {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100%;
}

.package-card:hover, .tier-card:hover {
  border-color: #556ee6;
  box-shadow: 0 0.5rem 1rem rgba(85, 110, 230, 0.15);
  transform: translateY(-2px);
}

.package-card.active, .tier-card.active {
  border-color: #556ee6;
  background-color: rgba(85, 110, 230, 0.05);
  box-shadow: 0 0.5rem 1rem rgba(85, 110, 230, 0.15);
}

.program-label {
  transition: all 0.2s ease;
  border-color: #e9ecef;
  background-color: rgba(248, 249, 250, 0.7);
}

.program-label:hover {
  border-color: #556ee6;
  background-color: rgba(85, 110, 230, 0.05);
  box-shadow: 0 0.25rem 0.5rem rgba(85, 110, 230, 0.1);
}

.program-label .btn-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.program-label .btn-icon:hover {
  transform: scale(1.2);
}

.font-weight-medium {
  font-weight: 500;
}

.addon-card {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.addon-card:hover {
  border-color: #556ee6;
  box-shadow: 0 0.25rem 0.5rem rgba(85, 110, 230, 0.15);
}

.transition-care-modal .tier-services, 
.wellness-entry-modal .package-services {
  max-height: 200px;
  overflow-y: auto;
  padding-right: 5px;
}

.transition-care-modal .tier-services::-webkit-scrollbar,
.wellness-entry-modal .package-services::-webkit-scrollbar {
  width: 4px;
}

.transition-care-modal .tier-services::-webkit-scrollbar-thumb,
.wellness-entry-modal .package-services::-webkit-scrollbar-thumb {
  background-color: rgba(85, 110, 230, 0.3);
  border-radius: 4px;
}

.transition-care-modal .tier-services::-webkit-scrollbar-track,
.wellness-entry-modal .package-services::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

/* Medication Styling */
.medication-card {
  border: none;
  border-radius: 0.75rem;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.medication-category {
  margin-bottom: 1rem;
}

.medication-disease-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
}

.medication-item {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0;
  margin-left: 0.5rem;
  border-left: 2px solid #e9ecef;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
}

.medication-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.medication-details {
  flex-grow: 1;
}

.medication-details strong {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.medication-dosage {
  font-size: 0.8rem;
  color: #74788d;
}

/* Information Cards Styling */
.info-card {
  border: none;
  border-radius: 0.75rem;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.shadow-hover {
  transition: all 0.3s ease;
}

.shadow-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.info-card .card-header {
  padding: 1rem 1.25rem;
  border-bottom: none;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #5664d2 0%, #7a85e0 100%);
}

.bg-gradient-success {
  background: linear-gradient(135deg, #34c38f 0%, #4ce3ae 100%);
}

.bg-gradient-info {
  background: linear-gradient(135deg, #50a5f1 0%, #7bc9ff 100%);
}

.info-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 1rem;
}

.info-card-content {
  padding: 0.5rem;
}

.info-card-primary {
  border-top: 3px solid #5664d2;
}

.info-card-success {
  border-top: 3px solid #34c38f;
}

.info-card-info {
  border-top: 3px solid #50a5f1;
}

.badge-pill {
  padding: 0.4em 0.8em;
  border-radius: 50rem;
  font-weight: 600;
  font-size: 0.75rem;
}

.badge-soft-primary {
  color: #5664d2;
  background-color: rgba(86, 100, 210, 0.18);
}

.badge-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18);
}

.condition-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.4em 0.8em;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.diabetes-text {
  display: inline-flex;
  align-items: center;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #5664d2;
  transition: all 0.3s ease;
}

.diabetes-text i {
  color: #5664d2;
  margin-right: 0.5rem;
}

.diabetes-text:hover {
  color: #4254c5;
}

.status-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.status-indicator.active {
  background-color: #34c38f;
  box-shadow: 0 0 0 3px rgba(52, 195, 143, 0.2);
}

.status-text.active {
  color: #34c38f;
  font-weight: 600;
}

.team-member {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.team-member:last-child {
  margin-bottom: 0;
}

.program-stat {
  text-align: center;
  padding: 0.5rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  width: 45%;
}

.program-stat:hover {
  background-color: rgba(248, 249, 250, 0.9);
  transform: translateY(-2px);
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #5664d2;
  margin-top: 0.1rem;
}

/* Care Plan Table Styling */
.care-plan-table-container {
  margin-top: 1.5rem;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(86, 100, 210, 0.12);
  border: 1px solid rgba(86, 100, 210, 0.1);
  transition: all 0.3s ease;
}

.care-plan-table-container:hover {
  box-shadow: 0 12px 30px rgba(86, 100, 210, 0.15);
  transform: translateY(-2px);
}

.care-plan-table {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.care-plan-table thead th {
  background: linear-gradient(135deg, #5664d2 0%, #7a85e0 100%);
  border-bottom: none;
  padding: 1.25rem 1.5rem;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.6px;
  position: relative;
}

.care-plan-table .th-patient {
  border-top-left-radius: 0.75rem;
}

.care-plan-table .th-action {
  border-top-right-radius: 0.75rem;
}

.care-plan-table .th-updates {
  position: relative;
}

.care-plan-table .th-updates::after,
.care-plan-table .th-patient::after {
  content: '';
  position: absolute;
  right: 0;
  top: 25%;
  height: 50%;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.3);
}

.care-plan-row {
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(241, 245, 249, 0.8);
}

.care-plan-row:last-child {
  border-bottom: none;
}

.care-plan-row:nth-child(odd) {
  background-color: rgba(248, 250, 252, 0.7);
}

.care-plan-row:hover {
  background-color: rgba(86, 100, 210, 0.05);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
}

.care-plan-row[data-category="goals"] {
  border-left: 5px solid #5664d2;
}

.care-plan-row[data-category="barriers"] {
  border-left: 5px solid #f1b44c;
}

.care-plan-row[data-category="symptoms"] {
  border-left: 5px solid #f46a6a;
}

.care-plan-row[data-category="allergies"] {
  border-left: 5px solid #50a5f1;
}

.care-plan-row.bg-soft-light {
  background-color: rgba(86, 100, 210, 0.08) !important;
  border-right: 1px solid rgba(86, 100, 210, 0.2);
  border-top: 1px solid rgba(86, 100, 210, 0.2);
  border-bottom: 1px solid rgba(86, 100, 210, 0.2);
}

.care-plan-info-cell {
  padding: 1.5rem;
  vertical-align: middle;
  line-height: 1.6;
}

.care-plan-info-cell strong {
  color: #344767;
  font-weight: 700;
  display: block;
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
}

.care-plan-info-cell ul, .care-plan-info-cell ol {
  margin-bottom: 0;
  padding-left: 1.5rem;
}

.care-plan-info-cell li {
  margin-bottom: 0.5rem;
  position: relative;
}

.care-plan-info-cell li:last-child {
  margin-bottom: 0;
}

.edit-container {
  padding: 0.75rem;
  background-color: rgba(248, 249, 250, 0.7);
  border-radius: 0.5rem;
  box-shadow: inset 0 0 0 1px rgba(86, 100, 210, 0.1);
}

.input-group-prepend .input-group-text {
  background-color: #5664d2;
  color: white;
  border-color: #5664d2;
}

.animated-border {
  border: 1px solid #ced4da;
  transition: all 0.3s ease;
  border-radius: 0.25rem;
  padding: 0.6rem 0.75rem;
}

.animated-border:focus {
  border-color: #5664d2;
  box-shadow: 0 0 0 0.2rem rgba(86, 100, 210, 0.25);
}

.update-content {
  padding: 0.75rem;
  min-height: 3rem;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.btn-animated {
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  padding: 0.5rem 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.btn-hover-shadow:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(86, 100, 210, 0.2) !important;
}

.btn-primary {
  background: linear-gradient(135deg, #5664d2 0%, #7a85e0 100%);
  border: none;
}

.btn-success {
  background: linear-gradient(135deg, #34c38f 0%, #4ce3ae 100%);
  border: none;
}

.btn-outline-secondary {
  border: 1px solid #ced4da;
  color: #6c757d;
}

.btn-outline-secondary:hover {
  background-color: #f8f9fa;
  color: #5664d2;
  border-color: #5664d2;
}

.no-updates {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a94a6;
  font-style: italic;
  background-color: rgba(248, 249, 250, 0.7);
  padding: 0.75rem;
  border-radius: 0.5rem;
  border: 1px dashed rgba(86, 100, 210, 0.2);
  transition: all 0.3s ease;
}

.no-updates:hover {
  background-color: rgba(248, 249, 250, 0.9);
  border-color: rgba(86, 100, 210, 0.4);
  transform: translateY(-1px);
}

.no-updates i {
  margin-left: 0.5rem;
  font-size: 1rem;
  color: #5664d2;
  opacity: 0.7;
}

/* Header Action Buttons */
.header-buttons {
  margin-right: -0.5rem;
}

.header-action-btn {
  padding: 0.4rem 0.75rem;
  font-weight: 500;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-action-btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  color: white;
}

.header-action-btn i {
  font-size: 0.875rem;
}

/* Modal Styling */
.review-note-modal .modal-content,
.treatment-test-modal .modal-content,
.referral-modal .modal-content {
  border-radius: 0.5rem;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.review-note-modal .modal-header,
.treatment-test-modal .modal-header,
.referral-modal .modal-header {
  background: linear-gradient(135deg, #5664d2 0%, #7a85e0 100%);
  color: white;
  border-radius: 0.5rem 0.5rem 0 0;
  border-bottom: none;
}

.review-note-modal .modal-title,
.treatment-test-modal .modal-title,
.referral-modal .modal-title {
  font-weight: 600;
}

.review-note-modal .close,
.treatment-test-modal .close,
.referral-modal .close {
  color: white;
  opacity: 0.8;
  text-shadow: none;
}

.review-note-modal .close:hover,
.treatment-test-modal .close:hover,
.referral-modal .close:hover {
  opacity: 1;
}

.note-editor {
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  padding: 1rem;
  font-size: 0.9375rem;
  line-height: 1.6;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 200px;
}

.note-editor:focus {
  border-color: #5664d2;
  box-shadow: 0 0 0 0.2rem rgba(86, 100, 210, 0.25);
}

.referral-results {
  min-height: 150px;
  background-color: #f8f9fa;
  border-radius: 0.375rem;
  padding: 1rem;
  border: 1px dashed #e2e8f0;
}

.btn-animated:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}

.btn-animated:hover:after {
  animation: ripple 1s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(25, 25);
    opacity: 0.5;
  }
  100% {
    opacity: 0;
    transform: scale(40, 40);
  }
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;
}

.btn-hover-shadow {
  transition: all 0.3s ease;
}

.btn-hover-shadow:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,.15);
}

.table {
  border-radius: 0.25rem;
  overflow: hidden;
}

.table th {
  background: linear-gradient(to right, #f8f9fa, #ffffff);
  border-bottom: 2px solid #e9ecef;
}

.form-control:focus {
  border-color: #556ee6;
  box-shadow: 0 0 0 0.2rem rgba(85, 110, 230, 0.25);
}

.align-middle {
  vertical-align: middle !important;
}

/* Custom Tabs Styling */
.custom-tabs-container {
  position: relative;
  margin-bottom: 1.5rem;
}

.custom-tabs {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0;
  position: relative;
}

.custom-tabs .nav-item {
  margin-bottom: -1px;
  position: relative;
}

.custom-tabs .nav-link {
  border: none;
  border-top: 3px solid transparent;
  color: #495057;
  font-weight: 500;
  padding: 0.75rem 1.25rem;
  border-radius: 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

/* Medical Tabs Styling */
.medical-tabs-container {
  margin-top: 1.5rem;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.medical-main-tabs {
  background: linear-gradient(to right, #f8f9fa, #ffffff);
  border-bottom: none !important;
  padding: 0.5rem 0.5rem 0;
  border-radius: 0.75rem 0.75rem 0 0;
}

.medical-main-tab {
  border: none !important;
  border-radius: 0.5rem 0.5rem 0 0 !important;
  padding: 0.75rem 1.5rem !important;
  margin-right: 0.25rem;
  font-weight: 600;
  color: #495057;
  background-color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.medical-main-tab:hover {
  background-color: rgba(255, 255, 255, 0.8);
  transform: translateY(-2px);
}

.medical-main-tab.active {
  background-color: #ffffff !important;
  color: #556ee6 !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.medical-tab-title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.medical-tab-icon {
  margin-right: 0.5rem;
  font-size: 1rem;
  color: #556ee6;
}

.medical-nested-container {
  background-color: #ffffff;
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.02);
}

.medical-nested-tabs {
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
  padding: 1rem 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.medical-nested-tab {
  border: none !important;
  border-radius: 0.25rem !important;
  padding: 0.75rem 1rem !important;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #495057;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.medical-nested-tab:hover {
  background-color: rgba(85, 110, 230, 0.1);
  transform: translateX(5px);
}

.medical-nested-tab.active {
  background: linear-gradient(135deg, #556ee6 0%, #7a85e0 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 8px rgba(85, 110, 230, 0.25);
}

.medical-nested-tab-title {
  display: flex;
  align-items: center;
}

.medical-nested-tab-icon {
  margin-right: 0.75rem;
  font-size: 0.875rem;
}

.medical-nested-content {
  background-color: #ffffff;
  border-radius: 0.5rem;
  min-height: 300px;
}

.medical-content-card {
  background-color: #ffffff;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  min-height: 300px;
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 250px;
  text-align: center;
  color: #8a94a6;
}

.placeholder-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #e2e8f0;
}

/* Physical Examination Styling */
.physical-exam-container {
  padding: 1rem;
}

.physical-exam-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}

.physical-exam-icon {
  font-size: 1.5rem;
  color: #556ee6;
  margin-right: 0.75rem;
}

.physical-exam-content {
  padding: 0.5rem;
}

.physical-exam-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.physical-exam-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background-color: rgba(248, 249, 250, 0.7);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.physical-exam-item:hover {
  background-color: rgba(248, 249, 250, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.physical-exam-item-icon {
  font-size: 1.25rem;
  color: #556ee6;
  margin-right: 1rem;
  width: 24px;
  text-align: center;
}

.physical-exam-item-label {
  font-weight: 600;
  margin-right: 0.5rem;
  min-width: 120px;
}

.physical-exam-item-value {
  font-weight: 500;
  color: #495057;
}

/* Medical History Styling */
.medical-history-container {
  padding: 1rem;
}

.medical-history-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}

.medical-history-icon {
  font-size: 1.5rem;
  color: #556ee6;
  margin-right: 0.75rem;
}

.medical-history-content {
  padding: 0.5rem;
}

.medical-history-filters .badge {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  transition: all 0.3s ease;
}

.medical-history-filters .badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.medical-history-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.medical-history-item {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.medical-history-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.medical-history-item.active {
  border-left-color: #f46a6a;
}

.medical-history-item.resolved {
  border-left-color: #34c38f;
}

.medical-history-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.medical-history-item-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.medical-history-item-body {
  padding: 1rem;
}

.badge-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18);
}

.badge-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
}

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
}

.badge-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.18);
}

/* Family History Styling */
.family-history-container {
  padding: 1rem;
}

.family-history-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}

.family-history-icon {
  font-size: 1.5rem;
  color: #556ee6;
  margin-right: 0.75rem;
}

.family-history-content {
  padding: 0.5rem;
}

.family-history-filters .badge {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  transition: all 0.3s ease;
}

.family-history-filters .badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.family-history-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.family-history-item {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.family-history-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.family-history-item.immediate {
  border-left-color: #556ee6;
}

.family-history-item.extended {
  border-left-color: #f1b44c;
}

.family-history-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.family-history-item-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.family-history-item-body {
  padding: 1rem;
}

/* Medication History Styling */
.medication-history-container {
  padding: 1rem;
}

.medication-history-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}

.medication-history-icon {
  font-size: 1.5rem;
  color: #556ee6;
  margin-right: 0.75rem;
}

.medication-history-content {
  padding: 0.5rem;
}

.medication-history-filters .badge {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  transition: all 0.3s ease;
}

.medication-history-filters .badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.medication-history-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.medication-history-item {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.medication-history-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.medication-history-item.current {
  border-left-color: #34c38f;
}

.medication-history-item.discontinued {
  border-left-color: #74788d;
}

.medication-history-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.medication-history-item-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.medication-history-item-body {
  padding: 1rem;
}

.medication-notes {
  background-color: rgba(248, 249, 250, 0.5);
  padding: 0.75rem;
  border-radius: 0.5rem;
  border-left: 3px solid #556ee6;
}

/* Lifestyle Styling */
.lifestyle-container {
  padding: 1rem;
}

.lifestyle-icon {
  font-size: 1.5rem;
  margin-right: 0.75rem;
}

/* Activity Styling */
.activity-summary {
  padding: 0.75rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.activity-summary:hover {
  background-color: rgba(248, 249, 250, 0.8);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.activity-level {
  margin-bottom: 1rem;
}

.activity-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #495057;
}

.activity-progress {
  height: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 1rem;
  background-color: rgba(0, 0, 0, 0.05);
}

.activity-value {
  font-weight: 600;
  color: #f1b44c;
}

.activity-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.activity-detail-label {
  font-weight: 600;
  margin-right: 0.5rem;
  color: #495057;
  min-width: 120px;
}

.activity-detail-value {
  font-weight: 500;
}

.activity-types {
  padding: 0.75rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
  height: 100%;
  transition: all 0.3s ease;
}

.activity-types:hover {
  background-color: rgba(248, 249, 250, 0.8);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.activity-types-title {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: #495057;
}

.activity-type-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
}

.activity-type-item:hover {
  background-color: rgba(255, 255, 255, 0.8);
  transform: translateX(5px);
}

.activity-type-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.activity-type-name {
  font-weight: 600;
  margin-right: 0.5rem;
  min-width: 80px;
}

.activity-type-frequency {
  color: #6c757d;
  font-size: 0.875rem;
}

.activity-goals {
  padding: 0.75rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.activity-goals:hover {
  background-color: rgba(248, 249, 250, 0.8);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.activity-goals-title {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: #495057;
}

.activity-goal-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.activity-goal-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.goal-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 0.75rem;
  font-size: 1.25rem;
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.15);
  color: #556ee6;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.15);
  color: #34c38f;
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.15);
  color: #50a5f1;
}

.goal-details {
  display: flex;
  flex-direction: column;
}

.goal-target {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
  color: #343a40;
}

.goal-label {
  font-size: 0.875rem;
  color: #6c757d;
}

/* Nutrition Styling */
.nutrition-summary {
  padding: 0.5rem;
}

.nutrition-quality {
  margin-bottom: 1rem;
}

.nutrition-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #495057;
}

.nutrition-progress {
  height: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 1rem;
  background-color: rgba(0, 0, 0, 0.05);
}

.nutrition-value {
  font-weight: 600;
  color: #f1b44c;
}

.nutrition-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
  flex-wrap: wrap;
}

.nutrition-detail-item:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.nutrition-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.nutrition-detail-label {
  font-weight: 600;
  margin-right: 0.5rem;
  color: #495057;
  min-width: 150px;
}

.nutrition-detail-value {
  font-weight: 500;
  margin-right: 0.5rem;
}

/* Sleep & Stress Styling */
.sleep-summary {
  padding: 0.5rem;
}

.sleep-quality {
  margin-bottom: 1rem;
}

.sleep-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #495057;
}

.sleep-progress {
  height: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 1rem;
  background-color: rgba(0, 0, 0, 0.05);
}

.sleep-value {
  font-weight: 600;
  color: #50a5f1;
}

.sleep-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
  flex-wrap: wrap;
}

.sleep-detail-item:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.sleep-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.sleep-detail-label {
  font-weight: 600;
  margin-right: 0.5rem;
  color: #495057;
  min-width: 150px;
}

.sleep-detail-value {
  font-weight: 500;
  margin-right: 0.5rem;
}

.stress-summary {
  padding: 0.5rem;
  border-top: 1px dashed rgba(0, 0, 0, 0.1);
  padding-top: 1rem;
}

.stress-level {
  margin-bottom: 1rem;
}

.stress-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #495057;
}

.stress-progress {
  height: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 1rem;
  background-color: rgba(0, 0, 0, 0.05);
}

.stress-value {
  font-weight: 600;
  color: #f46a6a;
}

.stress-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
  flex-wrap: wrap;
}

.stress-detail-item:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.stress-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.stress-detail-label {
  font-weight: 600;
  margin-right: 0.5rem;
  color: #495057;
  min-width: 150px;
}

.stress-detail-value {
  font-weight: 500;
}

/* Recommendations Styling */
.recommendation-category {
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  height: 100%;
  transition: all 0.3s ease;
}

.recommendation-category:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.recommendation-category-title {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.recommendation-list {
  padding-left: 1.5rem;
}

.recommendation-list li {
  margin-bottom: 0.75rem;
  position: relative;
}

.recommendation-list li:before {
  content: '';
  position: absolute;
  left: -1.25rem;
  top: 0.5rem;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #556ee6;
}

.recommendation-list li:last-child {
  margin-bottom: 0;
}

/* Living Situation Styling */
.living-situation-container {
  padding: 1rem;
}

.living-situation-icon {
  font-size: 1.5rem;
  margin-right: 0.75rem;
}

/* Residence Information Styling */
.residence-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
}

.residence-detail-item:hover {
  background-color: rgba(248, 249, 250, 0.8);
  transform: translateX(5px);
}

.residence-detail-label {
  font-weight: 600;
  margin-right: 0.5rem;
  color: #495057;
  min-width: 150px;
}

.residence-detail-value {
  font-weight: 500;
}

/* Safety Assessment Styling */
.safety-assessment {
  padding: 0.5rem;
}

.safety-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.safety-item:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}

.safety-item:last-child {
  margin-bottom: 0;
}

.safety-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.safety-status {
  min-width: 100px;
  text-align: right;
}

/* Support Assessment Styling */
.support-assessment {
  padding: 0.5rem;
}

.support-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.support-item:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}

.support-item:last-child {
  margin-bottom: 0;
}

.support-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.support-rating {
  min-width: 100px;
  text-align: right;
}

.support-rating i {
  margin-left: 2px;
}

/* Recommendation Styling */
.recommendation-item {
  display: flex;
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.recommendation-item:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}

.recommendation-priority {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 1rem;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
}

.recommendation-priority.high {
  background-color: rgba(244, 106, 106, 0.15);
  color: #f46a6a;
}

.recommendation-priority.medium {
  background-color: rgba(241, 180, 76, 0.15);
  color: #f1b44c;
}

.recommendation-priority.low {
  background-color: rgba(52, 195, 143, 0.15);
  color: #34c38f;
}

.recommendation-content {
  flex: 1;
}

.recommendation-content h6 {
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.recommendation-content p {
  color: #6c757d;
  margin-bottom: 0;
  font-size: 0.875rem;
}

/* Social Support Styling */
.social-support-container {
  padding: 1rem;
}

.social-support-icon {
  font-size: 1.5rem;
  margin-right: 0.75rem;
}

/* Support Score Styling */
.support-score-container {
  display: flex;
  padding: 1rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.support-score-container:hover {
  background-color: rgba(248, 249, 250, 0.8);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.support-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 1.5rem;
}

.support-score-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5664d2 0%, #7a85e0 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 10px rgba(86, 100, 210, 0.3);
}

.support-score-value {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
}

.support-score-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  margin-top: 0.25rem;
}

.support-score-details {
  flex: 1;
}

.support-score-item {
  margin-bottom: 0.75rem;
}

.support-score-item:last-child {
  margin-bottom: 0;
}

.support-score-item-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: #495057;
}

.support-score-progress {
  height: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 1rem;
  background-color: rgba(0, 0, 0, 0.05);
}

.support-score-item-value {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6c757d;
}

/* Support Summary Styling */
.support-summary {
  padding: 1rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
  height: 100%;
  transition: all 0.3s ease;
}

.support-summary:hover {
  background-color: rgba(248, 249, 250, 0.8);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.support-summary-title {
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: #495057;
  font-weight: 600;
}

.support-summary-text {
  margin-bottom: 1rem;
  line-height: 1.5;
}

.support-summary-strengths,
.support-summary-gaps {
  margin-bottom: 0.75rem;
}

.support-summary-strengths h6,
.support-summary-gaps h6 {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.support-summary-strengths ul,
.support-summary-gaps ul {
  padding-left: 1.5rem;
  margin-bottom: 0.5rem;
}

.support-summary-strengths li,
.support-summary-gaps li {
  margin-bottom: 0.25rem;
}

/* Support Network Styling */
.support-network-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.support-network-item {
  display: flex;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
  border-left: 4px solid #e9ecef;
}

.support-network-item:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}

.support-network-item.primary-support {
  border-left-color: #5664d2;
  background-color: rgba(86, 100, 210, 0.05);
}

.support-network-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  position: relative;
  flex-shrink: 0;
}

.support-network-avatar i {
  font-size: 1.5rem;
  color: #6c757d;
}

.support-network-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.support-network-badge.primary {
  background-color: #5664d2;
  color: white;
}

.support-network-badge i {
  font-size: 0.625rem;
}

.support-network-details {
  flex: 1;
}

.support-network-details h6 {
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.relationship {
  font-weight: normal;
  color: #6c757d;
  font-size: 0.875rem;
}

.support-network-contact {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: #495057;
}

.support-network-roles {
  margin-bottom: 0.5rem;
}

.support-network-roles .badge {
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
}

.support-network-notes {
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0;
}

.support-network-frequency {
  min-width: 80px;
  text-align: right;
  flex-shrink: 0;
  align-self: flex-start;
}

/* Social Recommendation Styling */
.social-recommendation-item {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 1rem;
  transition: all 0.3s ease;
  overflow: hidden;
}

.social-recommendation-item:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}

.social-recommendation-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: rgba(248, 249, 250, 0.7);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.social-recommendation-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
}

.social-recommendation-header h6 {
  margin-bottom: 0;
  font-weight: 600;
}

.social-recommendation-body {
  padding: 0.75rem 1rem;
}

.social-recommendation-body p {
  margin-bottom: 0.75rem;
}

.social-recommendation-action {
  display: flex;
  justify-content: flex-end;
}

/* Occupation Styling */
.occupation-container {
  padding: 1rem;
}

.occupation-icon {
  font-size: 1.5rem;
  margin-right: 0.75rem;
}

.occupation-actions {
  display: flex;
  align-items: center;
}

.occupation-card {
  transition: all 0.3s ease;
  overflow: hidden;
}

.shadow-hover {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  transition: all 0.3s ease;
}

.shadow-hover:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transform: translateY(-3px);
}

.bg-gradient-primary-soft {
  background: linear-gradient(135deg, rgba(86, 100, 210, 0.1) 0%, rgba(122, 133, 224, 0.1) 100%);
  border-bottom: 1px solid rgba(86, 100, 210, 0.1);
}

.bg-gradient-warning-soft {
  background: linear-gradient(135deg, rgba(241, 180, 76, 0.1) 0%, rgba(243, 197, 120, 0.1) 100%);
  border-bottom: 1px solid rgba(241, 180, 76, 0.1);
}

.bg-gradient-info-soft {
  background: linear-gradient(135deg, rgba(80, 165, 241, 0.1) 0%, rgba(123, 201, 255, 0.1) 100%);
  border-bottom: 1px solid rgba(80, 165, 241, 0.1);
}

.occupation-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(86, 100, 210, 0.15);
  color: #5664d2;
  margin-right: 0.75rem;
  font-size: 1.25rem;
}

.occupation-card-icon.warning {
  background-color: rgba(241, 180, 76, 0.15);
  color: #f1b44c;
}

.occupation-card-icon.info {
  background-color: rgba(80, 165, 241, 0.15);
  color: #50a5f1;
}

.occupation-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
}

.occupation-detail-item:hover {
  background-color: rgba(248, 249, 250, 0.8);
  transform: translateX(5px);
}

.occupation-detail-label {
  font-weight: 600;
  margin-right: 0.5rem;
  color: #495057;
  min-width: 120px;
}

.occupation-detail-value {
  font-weight: 500;
}

.satisfaction-meter {
  width: 100px;
  height: 8px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
  margin-right: 0.5rem;
}

.satisfaction-level {
  height: 100%;
  background: linear-gradient(to right, #34c38f, #4ce3ae);
  border-radius: 4px;
}

.satisfaction-value {
  font-weight: 600;
  color: #34c38f;
}

.health-factor-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.health-factor-item:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}

.health-factor-item:last-child {
  margin-bottom: 0;
}

.health-factor-icon-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.health-factor-icon-container.primary {
  background-color: rgba(86, 100, 210, 0.15);
  color: #5664d2;
}

.health-factor-icon-container.info {
  background-color: rgba(80, 165, 241, 0.15);
  color: #50a5f1;
}

.health-factor-icon-container.danger {
  background-color: rgba(244, 106, 106, 0.15);
  color: #f46a6a;
}

.health-factor-icon-container.success {
  background-color: rgba(52, 195, 143, 0.15);
  color: #34c38f;
}

.health-factor-icon {
  font-size: 1.25rem;
}

.health-factor-risk {
  min-width: 100px;
  text-align: right;
}

.recommendation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.recommendation-card {
  display: flex;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.recommendation-card:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}

.recommendation-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(86, 100, 210, 0.15);
  color: #5664d2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.recommendation-content {
  flex: 1;
}

.recommendation-content h6 {
  margin-bottom: 0.25rem;
  font-weight: 600;
  color: #343a40;
}

.recommendation-content p {
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
}

/* Social History Styling */
.social-history-container {
  padding: 1rem;
}

.social-history-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}

.social-history-icon {
  font-size: 1.5rem;
  color: #556ee6;
  margin-right: 0.75rem;
}

.social-history-content {
  padding: 0.5rem;
}

.social-history-filters .badge {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  transition: all 0.3s ease;
}

.social-history-filters .badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.social-history-section {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
}

.social-history-section:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.social-history-section-header {
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: rgba(248, 249, 250, 0.7);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.social-history-section-icon {
  font-size: 1.25rem;
  color: #556ee6;
  margin-right: 0.75rem;
}

.social-history-section-body {
  padding: 1rem;
}

.social-history-item {
  padding: 0.75rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.social-history-item:hover {
  background-color: rgba(248, 249, 250, 0.5);
}

.social-history-item-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.social-history-footer {
  padding: 0.75rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-radius: 0.5rem;
}

.btn-soft-primary {
  background-color: rgba(85, 110, 230, 0.15);
  border-color: transparent;
  color: #556ee6;
  transition: all 0.3s ease;
}

.btn-soft-primary:hover {
  background-color: #556ee6;
  color: #fff;
}

.btn-soft-info {
  background-color: rgba(80, 165, 241, 0.15);
  border-color: transparent;
  color: #50a5f1;
  transition: all 0.3s ease;
}

.btn-soft-info:hover {
  background-color: #50a5f1;
  color: #fff;
}

/* Patient Notes Card Styles */
.patient-note-card {
  border: none;
  border-radius: 0.75rem;
  overflow: hidden;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.note-card-primary {
  border-left: 3px solid #556ee6;
}

.note-card-success {
  border-left: 3px solid #34c38f;
}

.note-card-info {
  border-left: 3px solid #50a5f1;
}

.patient-note-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.note-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.note-card-primary .note-card-header {
  background-color: rgba(85, 110, 230, 0.05);
}

.note-card-success .note-card-header {
  background-color: rgba(52, 195, 143, 0.05);
}

.note-card-info .note-card-header {
  background-color: rgba(80, 165, 241, 0.05);
}

.note-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 1rem;
  font-size: 1.25rem;
  transition: all 0.3s ease;
}

.note-icon-primary {
  background-color: rgba(85, 110, 230, 0.15);
  color: #556ee6;
}

.note-icon-success {
  background-color: rgba(52, 195, 143, 0.15);
  color: #34c38f;
}

.note-icon-info {
  background-color: rgba(80, 165, 241, 0.15);
  color: #50a5f1;
}

.note-card-body {
  padding: 1.25rem;
  background-color: #fff;
}

.note-card-footer {
  padding: 0.75rem 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
}

.note-card-primary .note-card-footer {
  background-color: rgba(85, 110, 230, 0.02);
}

.note-card-success .note-card-footer {
  background-color: rgba(52, 195, 143, 0.02);
}

.note-card-info .note-card-footer {
  background-color: rgba(80, 165, 241, 0.02);
}

.empty-notes-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 2rem;
  background-color: #f8f9fa;
  border-radius: 0.75rem;
  border: 1px dashed #dee2e6;
  transition: all 0.3s ease;
}

.empty-notes-container:hover {
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.empty-notes-icon {
  font-size: 3.5rem;
  color: #adb5bd;
  margin-bottom: 1.25rem;
  background-color: rgba(173, 181, 189, 0.1);
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.empty-notes-container:hover .empty-notes-icon {
  transform: scale(1.1);
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.1);
}

/* Animation for patient notes */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-note {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.patient-notes-list {
  padding: 0.5rem;
}

.custom-tabs .nav-link:hover {
  background-color: rgba(85, 110, 230, 0.05);
  color: #556ee6;
}

.custom-tabs .nav-link.active {
  color: #556ee6;
  background-color: #fff;
  border-bottom: 2px solid #fff;
  border-top-width: 3px;
}

.custom-tabs .nav-link .tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  margin-right: 8px;
  transition: all 0.3s ease;
}

.custom-tabs .nav-link:hover .tab-icon {
  transform: scale(1.1);
}

.custom-tabs .nav-link.active .tab-icon {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.custom-tabs .nav-link .tab-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  transition: all 0.3s ease;
}

.custom-tabs .nav-link.active .tab-indicator {
  width: 100%;
}

.tab-content {
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.tab-pane {
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tab-pane.active {
  display: block;
  opacity: 1;
}

.tab-pane.show {
  opacity: 1;
}

.avatar-container:hover .edit-icon {
  opacity: 1;
}

/* Patient Info Card Styles */
.patient-info-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.patient-info-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-item i {
  font-size: 16px;
  width: 24px;
  text-align: center;
}

/* Patient Basic Info Card Styles */
.patient-basic-info-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.patient-basic-info-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.patient-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.patient-info-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.patient-info-item:hover {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.patient-info-badge {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 14px;
}

.patient-info-badge.program {
  color: #0d6efd;
}

.patient-info-badge.mri {
  color: #6610f2;
}

.patient-info-badge.location {
  color: #dc3545;
}

.patient-info-badge.insurance {
  color: #0dcaf0;
}

.patient-info-badge.phone {
  color: #198754;
}

.patient-info-badge.emergency {
  color: #fd7e14;
}

.patient-info-badge.visit {
  color: #6c757d;
}

.patient-info-badge.followup {
  color: #20c997;
}

.patient-info-text {
  flex: 1;
  font-size: 0.85rem;
  display: flex;
  flex-direction: column;
}

.patient-info-text strong {
  font-size: 0.7rem;
  color: #6c757d;
}

/* Condition Card Styles */
.condition-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.condition-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.condition-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.condition-badge {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.condition-badge.chronic {
  color: #dc3545;
}

.condition-badge.secondary {
  color: #fd7e14;
}

.condition-badge.vitals {
  color: #20c997;
}

.condition-badge.allergies {
  color: #6f42c1;
}

.condition-text {
  flex: 1;
}

/* Care Team Card Styles */
.care-team-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.care-team-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.team-member {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.member-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.member-info {
  flex: 1;
}

.me-2 {
  margin-right: 0.5rem;
}

/* Compact Patient Summary Card Styles */
.patient-summary-card {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  padding: 8px;
}

/* Patient Info Row */
.patient-info-row {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.patient-info-row .badge {
  font-size: 14px;
  padding: 3px 8px;
}

.me-1 {
  margin-right: 0.25rem !important;
}

/* Essential Info Row */
.essential-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.info-pill {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 15px;
  padding: 3px 8px;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.info-pill i {
  margin-right: 4px;
  font-size: 14px;
}

.info-pill span {
  font-weight: 500;
}

/* Medication Row */
.medication-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.med-pill {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 15px;
  padding: 3px 8px;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.med-pill i {
  margin-right: 4px;
  font-size: 14px;
}

.med-pill span {
  font-weight: 500;
}

/* Badge Styles */
.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
}

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
}

.text-purple {
  color: #6610f2;
}

.text-teal {
  color: #20c997;
}

/* Assessment Wizard Styles */
.assessment-wizard {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.assessment-wizard-progress {
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.progress-container {
  max-width: 800px;
  margin: 0 auto;
}

.progress {
  height: 8px;
  margin-bottom: 1.5rem;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  transition: width 0.3s ease;
}

.progress-steps {
  display: flex;
  justify-content: space-between;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 25%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.step-label {
  font-size: 0.875rem;
  color: #6c757d;
  text-align: center;
  transition: all 0.3s ease;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.step-description {
  font-size: 0.75rem;
  color: #adb5bd;
  text-align: center;
  max-width: 120px;
  margin: 0 auto;
  line-height: 1.2;
  display: none;
}

.progress-step.active .step-description {
  display: block;
  animation: fadeIn 0.3s ease;
}

.progress-indicator {
  margin-bottom: 1.5rem;
}

.progress-text {
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-percentage {
  font-weight: 600;
  color: #34c38f;
}

.progress-step.active .step-icon {
  background-color: #556ee6;
  color: white;
  box-shadow: 0 0 0 4px rgba(85, 110, 230, 0.2);
}

.progress-step.active .step-label {
  color: #556ee6;
  font-weight: 600;
}

.progress-step.completed .step-icon {
  background-color: #34c38f;
  color: white;
}

.progress-step.completed .step-label {
  color: #34c38f;
}

.assessment-wizard-content {
  flex: 1;
  overflow-y: auto;
  min-height: 400px;
}

.assessment-step {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.step-title {
  margin-bottom: 1rem;
  color: #495057;
  display: flex;
  align-items: center;
}

.assessment-wizard-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.step-info {
  display: flex;
  flex-direction: column;
}

.step-name {
  color: #495057;
  margin-bottom: 0.25rem;
}

.step-counter {
  color: #6c757d;
}

.condition-checkboxes {
  background-color: #f8f9fa;
  border-radius: 0.25rem;
  padding: 1rem;
  border: 1px solid #e9ecef;
}

/* Family Members List Styles */
.family-members-list {
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 1rem;
}

.family-member-card {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
  border-left: 4px solid #556ee6;
  transition: all 0.3s ease;
  overflow: hidden;
}

.family-member-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.family-member-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: rgba(248, 249, 250, 0.5);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.family-member-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  color: #556ee6;
}

.family-member-body {
  padding: 0.75rem 1rem;
}

.btn-soft-danger {
  background-color: rgba(244, 106, 106, 0.2);
  color: #f46a6a;
  border: none;
}

.btn-soft-danger:hover {
  background-color: rgba(244, 106, 106, 0.3);
  color: #f46a6a;
}

.btn-icon {
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #556ee6;
  border-color: #556ee6;
}

.form-control:focus {
  border-color: #556ee6;
  box-shadow: 0 0 0 0.2rem rgba(85, 110, 230, 0.25);
}

.btn-primary {
  background-color: #556ee6;
  border-color: #556ee6;
}

.btn-primary:hover {
  background-color: #4458ca;
  border-color: #4458ca;
}

.btn-secondary {
  background-color: #74788d;
  border-color: #74788d;
}

.btn-secondary:hover {
  background-color: #636678;
  border-color: #636678;
}

/* Support Network Overview Styles */
.support-score-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.support-score {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, #34c38f, #556ee6);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.score-value {
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.support-rating-item {
  margin-bottom: 1rem;
}

.support-rating-item label {
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.key-strengths-container,
.potential-gaps-container {
  max-height: 250px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.recommendations-section .card {
  border-radius: 0.5rem;
}

.recommendations-section .form-group:last-child {
  margin-bottom: 0;
}

.badge-soft-success {
  background-color: rgba(52, 195, 143, 0.18);
  color: #34c38f;
}

.badge-soft-danger {
  background-color: rgba(244, 106, 106, 0.18);
  color: #f46a6a;
}

.badge-soft-info {
  background-color: rgba(80, 165, 241, 0.18);
  color: #50a5f1;
}

.badge-soft-warning {
  background-color: rgba(241, 180, 76, 0.18);
  color: #f1b44c;
}

.badge-soft-primary {
  background-color: rgba(85, 110, 230, 0.18);
  color: #556ee6;
}

/* Treatment Tab Styles */
.treatment-tab {
  padding: 1rem 0;
}

.treatment-card {
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: none;
  overflow: hidden;
  position: relative;
}

.treatment-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(to right, #556ee6, #34c38f);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.treatment-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 25px rgba(85, 110, 230, 0.18);
}

.treatment-card:hover:before {
  opacity: 1;
}

.treatment-card .card-body {
  padding: 1.5rem;
}

.treatment-card .card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #343a40;
  display: flex;
  align-items: center;
}

.treatment-card .card-title i {
  font-size: 1.5rem;
  margin-right: 0.75rem;
  background-color: rgba(85, 110, 230, 0.1);
  color: #556ee6;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.treatment-card .badge {
  font-weight: 500;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.badge-soft-danger {
  background-color: rgba(244, 106, 106, 0.18);
  color: #f46a6a;
}

.badge-soft-primary {
  background-color: rgba(85, 110, 230, 0.18);
  color: #556ee6;
}

.treatment-details {
  position: relative;
  padding: 1.25rem;
  background-color: #f8f9fa;
  border-radius: 0.75rem;
  margin-bottom: 1.25rem;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
}

.treatment-details p {
  margin-bottom: 0.25rem;
}

.treatment-details .row {
  margin-bottom: 0.75rem;
}

.treatment-details .row:last-child {
  margin-bottom: 0;
}

.treatment-details strong {
  color: #495057;
  font-weight: 600;
}

.section-header {
  color: #556ee6;
  font-weight: 600;
  font-size: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed rgba(85, 110, 230, 0.3);
  display: flex;
  align-items: center;
}

.section-header i {
  color: #556ee6;
  font-size: 1.1rem;
}

.equipment-item {
  display: inline-flex;
  align-items: center;
  background-color: rgba(85, 110, 230, 0.08);
  color: #556ee6;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-size: 0.85rem;
}

.equipment-item:before {
  content: '•';
  margin-right: 0.5rem;
  color: #556ee6;
}

.team-member {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #495057;
}

.nurse-item {
  background-color: rgba(52, 195, 143, 0.08);
}

.nurse-item i {
  color: #34c38f;
}

.assistant-doctor-item {
  background-color: rgba(241, 180, 76, 0.08);
}

.assistant-doctor-item i {
  color: #f1b44c;
}

.senior-doctor-item {
  background-color: rgba(85, 110, 230, 0.08);
}

.senior-doctor-item i {
  color: #556ee6;
}

.treatment-actions {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-start;
}

.treatment-actions .btn {
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.treatment-actions .btn:hover {
  transform: translateY(-2px);
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border: none;
}

.action-btn i {
  font-size: 1rem;
  margin-right: 0.5rem;
}

.btn-soft-primary {
  background-color: rgba(85, 110, 230, 0.15);
  color: #556ee6;
}

.btn-soft-primary:hover {
  background-color: rgba(85, 110, 230, 0.25);
  color: #556ee6;
}

.btn-soft-info {
  background-color: rgba(80, 165, 241, 0.15);
  color: #50a5f1;
}

.btn-soft-info:hover {
  background-color: rgba(80, 165, 241, 0.25);
  color: #50a5f1;
}

.btn-soft-success {
  background-color: rgba(52, 195, 143, 0.15);
  color: #34c38f;
}

.btn-soft-success:hover {
  background-color: rgba(52, 195, 143, 0.25);
  color: #34c38f;
}

/* Pagination Styles */
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 0.75rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}

.pagination-info {
  display: flex;
  align-items: center;
}

.pagination-info i {
  color: #556ee6;
  font-size: 1.1rem;
  margin-right: 0.5rem;
}

.pagination-controls {
  display: flex;
  align-items: center;
}

.custom-pagination .page-item .page-link {
  border-radius: 50% !important;
  margin: 0 0.2rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #495057;
  border: none;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.custom-pagination .page-item .page-link:hover {
  background-color: rgba(85, 110, 230, 0.1);
  color: #556ee6;
}

.custom-pagination .page-item.active .page-link {
  background-color: #556ee6;
  color: #fff;
  box-shadow: 0 2px 8px rgba(85, 110, 230, 0.35);
}

.custom-pagination .page-item.disabled .page-link {
  color: #adb5bd;
  background-color: #f8f9fa;
  box-shadow: none;
}

/* Treatment card animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.treatment-card {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.col-lg-6:nth-child(1) .treatment-card { animation-delay: 0.1s; }
.col-lg-6:nth-child(2) .treatment-card { animation-delay: 0.2s; }
.col-lg-6:nth-child(3) .treatment-card { animation-delay: 0.3s; }
.col-lg-6:nth-child(4) .treatment-card { animation-delay: 0.4s; }
.col-lg-6:nth-child(5) .treatment-card { animation-delay: 0.5s; }
.col-lg-6:nth-child(6) .treatment-card { animation-delay: 0.6s; }

/* Treatment Modal Styles */
.treatment-modal .modal-content {
  border: none;
  border-radius: 0.5rem;
  overflow: hidden;
}

.treatment-modal .modal-header {
  background-color: #556ee6;
  color: white;
  border-bottom: none;
}

.treatment-modal .modal-title {
  font-weight: 600;
}

.treatment-modal .close {
  color: white;
  opacity: 0.8;
}

.treatment-modal .close:hover {
  opacity: 1;
}

.treatment-type-card {
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
}

.treatment-type-card:hover {
  border-color: #556ee6;
  background-color: rgba(85, 110, 230, 0.05);
}

.treatment-type-card.active {
  border-color: #556ee6;
  background-color: rgba(85, 110, 230, 0.1);
}

.treatment-type-card i {
  color: #556ee6;
}

/* Form Wizard Customization */
.vue-form-wizard .wizard-icon-circle {
  border-color: #556ee6 !important;
}

.vue-form-wizard .wizard-icon-circle.active {
  background-color: #556ee6 !important;
}

.vue-form-wizard .wizard-nav-pills > li.active > a {
  color: #556ee6 !important;
}

/* Transitions Tab Styles */
.transitions-tab {
  padding: 1rem 0;
}

.transition-card {
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: none;
  overflow: hidden;
  position: relative;
}

.transition-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(to right, #50a5f1, #34c38f);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.transition-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 25px rgba(80, 165, 241, 0.18);
}

.transition-card:hover:before {
  opacity: 1;
}

.transition-card .card-body {
  padding: 1.5rem;
}

.transition-card .card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #343a40;
  display: flex;
  align-items: center;
}

.transition-card .card-title i {
  font-size: 1.5rem;
  margin-right: 0.75rem;
  background-color: rgba(80, 165, 241, 0.1);
  color: #50a5f1;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-item {
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.document-item:hover {
  background-color: #e9ecef;
}

.team-member {
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.team-member:hover {
  background-color: #e9ecef;
}

.empty-transitions-container {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Wellness Tab Styles */
.wellness-tab {
  padding: 1rem 0;
}

.wellness-score-card .wellness-score-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #556ee6 0%, #34c38f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 5px 15px rgba(85, 110, 230, 0.3);
}

.wellness-score-circle .score-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
}

.activity-card, .sleep-card, .nutrition-card, .wellness-score-card {
  transition: all 0.3s ease;
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.activity-card:hover, .sleep-card:hover, .nutrition-card:hover, .wellness-score-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.progress-vertical {
  height: 100px;
  width: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  margin: 0 auto 0.5rem;
  position: relative;
}

.progress-vertical .progress-bar {
  width: 100%;
  position: absolute;
  bottom: 0;
  border-radius: 4px;
}

.activity-timeline {
  position: relative;
  padding-left: 1.5rem;
}

.activity-item {
  position: relative;
  padding-bottom: 1.5rem;
  padding-left: 1.25rem;
}

.activity-item:last-child {
  padding-bottom: 0;
}

.activity-dot {
  position: absolute;
  left: -1.5rem;
  top: 0.25rem;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.activity-item:not(:last-child):before {
  content: '';
  position: absolute;
  left: -1.25rem;
  top: 0.75rem;
  bottom: 0;
  width: 2px;
  background-color: #e9ecef;
}

.activity-chart-placeholder {
  background-image: linear-gradient(135deg, #f8f9fa 25%, #e9ecef 25%, #e9ecef 50%, #f8f9fa 50%, #f8f9fa 75%, #e9ecef 75%, #e9ecef 100%);
  background-size: 20px 20px;
}

.vue-form-wizard .wizard-btn {
  background-color: #556ee6 !important;
}

/* Prescription Upload Styles */
.prescription-upload-section {
  background-color: rgba(85, 110, 230, 0.05);
  border-radius: 0.5rem;
  padding: 1.5rem;
  border: 1px dashed rgba(85, 110, 230, 0.5);
}

.prescription-upload-container {
  max-width: 600px;
  margin: 0 auto;
}

.prescription-files-list {
  background-color: #fff;
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.prescription-files-list .list-group-item {
  transition: all 0.2s ease;
  border-left: 3px solid #556ee6;
}

.prescription-files-list .list-group-item:hover {
  background-color: rgba(85, 110, 230, 0.05);
}

.btn-soft-danger {
  background-color: rgba(244, 106, 106, 0.15);
  color: #f46a6a;
  border: none;
  transition: all 0.2s ease;
}

.btn-soft-danger:hover {
  background-color: rgba(244, 106, 106, 0.3);
}

/* Procedure Card Styles */
.procedure-card {
  border-radius: 0.5rem;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border-left: 4px solid #556ee6;
}

.procedure-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.procedure-card .card-title {
  font-weight: 600;
  font-size: 1.1rem;
}

.procedure-details {
  font-size: 0.9rem;
  color: #495057;
}

.procedure-details p strong {
  color: #343a40;
  font-weight: 600;
}

.btn-icon {
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

</style>
